import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, Input, Output, ViewChildren, ViewChild, ViewEncapsulation, Inject, NgModule } from '@angular/core';
import * as i1$2 from 'reference-library';
import * as i10 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i12 from '@angular/forms';
import { Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import * as moment from 'moment';
import moment__default from 'moment';
import { sync_profile_code } from 'permission-library';
import * as i9$1 from '@angular/material/expansion';
import { MatAccordion, MatExpansionModule } from '@angular/material/expansion';
import * as errorUtils from 'error-message-utility';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import * as i23 from '@angular/material/table';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MarkCleanFormAction, MarkDirtyFormAction } from 'dirty-check-store';
import { BehaviorSubject, Subject, combineLatest } from 'rxjs';
import { map, take, takeUntil, distinctUntilChanged } from 'rxjs/operators';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { DeleteDialogLibraryComponent, DeleteDialogLibraryModule } from 'delete-dialog-library';
import { environment } from 'environment-configurations';
import * as Roles from 'app-models';
import { acceptedFileTypes, Tranings, License } from 'app-models';
import { CustomErrorToastComponent } from 'custom-error-toast';
import * as i1$1 from 'cache-country-list';
import { saveAs } from 'file-saver';
import * as i1 from '@angular/common/http';
import * as i2 from 'web-storage';
import * as i3 from 'ngx-toastr';
import * as i6 from '@angular/router';
import * as i2$1 from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import * as i8 from '@ngrx/store';
import * as i9 from 'primeng/dynamicdialog';
import * as i10$1 from '@angular/material/card';
import { MatCardModule } from '@angular/material/card';
import * as i11 from '@angular/material/stepper';
import { MatStepperModule } from '@angular/material/stepper';
import * as i14 from 'primeng/dropdown';
import { DropdownModule } from 'primeng/dropdown';
import * as i15 from 'year-date-picker-library';
import { YearDatePickerLibraryModule } from 'year-date-picker-library';
import * as i16 from '@angular/material/form-field';
import { MatFormFieldModule } from '@angular/material/form-field';
import * as i17 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import * as i18 from '@angular/material/datepicker';
import { MatDatepickerModule } from '@angular/material/datepicker';
import * as i19 from '@angular/material/chips';
import { MatChipsModule } from '@angular/material/chips';
import * as i20 from 'file-upload-deafult-library';
import { FileUploadDeafultLibraryModule } from 'file-upload-deafult-library';
import * as i21 from 'save-as-draft';
import { SaveAsDraftModule } from 'save-as-draft';
import * as i22 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i24 from 'primeng/button';
import { ButtonModule } from 'primeng/button';
import * as i25 from 'primeng/tooltip';
import { map as map$1 } from 'rxjs/internal/operators/map';
import * as CryptoJS from 'crypto-js';
import * as i13 from '@angular/material/checkbox';
import { MatCheckboxModule } from '@angular/material/checkbox';
import * as i20$1 from 'file-download-library';
import { FileDownloadLibraryModule } from 'file-download-library';
import { MomentDateAdapter, MatMomentDateModule } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS, MatNativeDateModule } from '@angular/material/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatListModule } from '@angular/material/list';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FileUploadLibraryModule } from 'file-upload-library';
import { PrimengLibraryModule } from 'primeng-library';
import { AccordionModule } from 'primeng/accordion';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { MultiSelectModule } from 'primeng/multiselect';
import { PaginatorModule } from 'primeng/paginator';
import { ImageCropperModule } from 'ngx-image-cropper';
import { HelpVideoOverlayLibraryModule } from 'help-video-overlay-library';
import { CustomQuestionnaireModule } from 'custom-questionnaire';
import { MatTabsModule } from '@angular/material/tabs';

class AddEducationDetailsService {
    constructor(http, webStorage) {
        this.http = http;
        this.webStorage = webStorage;
        this.countryDataSource = new BehaviorSubject({ listCountries: [] });
        this.deletedfile$ = new BehaviorSubject({});
        this.uploaded$ = new BehaviorSubject({});
        this.dependentProfileSubject = new BehaviorSubject({});
        this.onLifeStorySubTabs = new Subject();
        this.isExpired = false;
        this.isEducationDetailsChanged = new Subject();
        this.selfBeneficiaryDetailChange = new Subject();
        this.newSubDependentCreated = new Subject();
        this.currentUserSubject = new BehaviorSubject(this.webStorage.getWebStorageItem('currentUser'));
        this.currentUser = this.currentUserSubject.asObservable();
    }
    get currentUserValue() {
        return this.currentUserSubject.value;
    }
    getStates(countryCode) {
        return this.http.get(`/countries/states?countryCode=${countryCode}`).pipe(map((response) => {
            if (response.status) {
                return response.data;
            }
        }));
    }
    // getEducationDetails(petitionId: number, superTaskId: number, taskId: number, familyId?: number) {
    getEducationDetails(visatype, caseType, caseId, synctype, superTaskId, subTaskId, isUsedForbeneEdit) {
        // let isUsedForBenEdit;
        // if(sessionStorage.getItem('wizardTID')){
        //   isUsedForBenEdit = false;
        // } else {
        //   isUsedForBenEdit = true;
        // }
        const url = `/${visatype}/${caseType}/${caseId}/${synctype}?superTaskId=${superTaskId}&taskId=${subTaskId}&isUsedForBenEdit=${isUsedForbeneEdit}`;
        return this.http.get(url).pipe(map((data) => data));
    }
    getBeneEducationInformation(superTaskId, subTaskId, isUsedForBenEdit = false) {
        return this.http.get(`/superTask/${superTaskId}/subTask/${subTaskId}/gc/i140Case/educationDetails?isUsedForBenEdit=false`);
    }
    getBeneEducationInformationPerm(gcId, isUsedForBenEdit = false) {
        return this.http.get(`/gc/perm/${gcId}/educationDetails?isUsedForBenEdit=false`);
    }
    savegcI140DegreeDetails(gcI140Id, payload) {
        return this.http.post(`/gcCase/saveEducation/${gcI140Id}?isGcI140Case=true&isGcPermCase=false`, payload);
    }
    savePermDegreeDetails(permId, payload) {
        return this.http.post(`/gcCase/saveEducation/${permId}?isGcI140Case=false&isGcPermCase=true`, payload);
    }
    saveEducatinDegreeDetails(petitionId, payload, familyId) {
        const url = `/petition/saveEducation/${petitionId}`;
        return this.http.post(url, payload).pipe(map((response) => response));
    }
    saveEducatinDegreeDetailsForProfile(beneficiaryId, payload, familyId) {
        const url = familyId ? `/beneficiary/${beneficiaryId}/profile/education?familyId=${familyId}` : `/beneficiary/${beneficiaryId}/profile/education`;
        return this.http.post(url, payload).pipe(map((response) => response));
    }
    deleteEducatinDegreeDetails(visatype, caseType, caseId, synctype, superTaskId, subTaskId, educationId) {
        return this.http.delete(`/${visatype}/${caseType}/${caseId}/${synctype}/${educationId}?superTaskId=${superTaskId}&taskId=${subTaskId}`).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    deleteEducatinDegreeDetailsForProfile(beneficiaryId, educationId, familyId) {
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        return this.http.delete(`/beneficiary/${beneficiaryId}/profile/education/${educationId}${profileFamilyString}`).pipe(map((data) => {
            // IM-3066 - remove deleted file.
            this.deletefile(beneficiaryId);
            return data;
        }));
    }
    deletegcI140DegreeDetails(superTaskId, subTaskId, educationId) {
        return this.http.delete(`/superTask/${superTaskId}/subTask/${subTaskId}/gc/i140Case/education/${educationId}/delete`).pipe(map((response) => {
            return response;
        }));
    }
    deletefile(beneficiaryId) {
        this.deletedfile$.next(true);
    }
    checkBeneEditPermission() {
        const permission = JSON.parse(sessionStorage.getItem('currentUser'));
        return permission ? permission['permissions'].length > 0 && permission['permissions'].find(x => x === 'EDIT_BENEFICIARY') ? true : false : false;
        // return permission['permissions'].length>0 && permission['permissions'].find(x=> x === 'DELETE_BENEFICIARY')? true : false;
    }
    checkValidity() {
        return this.isExpired;
    }
    educationDetailsChanged(data) {
        this.isEducationDetailsChanged.next(data);
    }
    changeDependentProfileID(dependentId, beneficiaryType) {
        this.dependentProfileSubject.next({ dependentId: dependentId, beneficiaryType: beneficiaryType });
    }
    downloadDocuments(path, fileName) {
        this.http.get(path, { responseType: "arraybuffer" })
            .pipe(take(1))
            .subscribe(pdf => {
            const blob = new Blob([pdf], { type: 'application/pdf' });
            saveAs(blob, fileName);
        });
    }
    genericGetUploadDocument(useCase, useCaseId, categoryName, entityId, useEntityId, familyId) {
        const entityUrlString = (useEntityId) ? `/entity/${entityId}` : '';
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        return this.http.get(`/document/${useCase}/${useCaseId}/category/${categoryName}${entityUrlString}${profileFamilyString}`).pipe(map((response) => {
            if (response.status === 200) {
                response.data = response.data.filter(x => x.fileLocation !== null);
                return response;
            }
            return response;
        }));
    }
    getEducationDetailsForProfile(beneficiaryId, familyId) {
        const url = familyId ? `/beneficiary/${beneficiaryId}/profile/education?familyId=${familyId}` : `/beneficiary/${beneficiaryId}/profile/education`;
        // console.log('url', url);
        return this.http.get(url).pipe(map((data) => data));
    }
}
AddEducationDetailsService.ɵfac = function AddEducationDetailsService_Factory(t) { return new (t || AddEducationDetailsService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.ImagilityWebStorage)); };
AddEducationDetailsService.ɵprov = i0.ɵɵdefineInjectable({ token: AddEducationDetailsService, factory: AddEducationDetailsService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AddEducationDetailsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }, { type: i2.ImagilityWebStorage }]; }, null); })();

function AddEducationDetailsComponent_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 83);
    i0.ɵɵelementStart(1, "button", 84);
    i0.ɵɵlistener("click", function AddEducationDetailsComponent_ng_container_1_div_1_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r22); i0.ɵɵnextContext(); const _r3 = i0.ɵɵreference(9); const ctx_r21 = i0.ɵɵnextContext(); ctx_r21.toggleExpansion(); return _r3 == null ? null : _r3.reset(); });
    i0.ɵɵelementStart(2, "span", 85);
    i0.ɵɵtext(3, "Add Education");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function AddEducationDetailsComponent_ng_container_1_ng_template_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 86);
    i0.ɵɵtext(1, "Degree Details");
    i0.ɵɵelementEnd();
} }
function AddEducationDetailsComponent_ng_container_1_span_53_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span");
} }
function AddEducationDetailsComponent_ng_container_1_span_55_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 87);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r6.getGlobalErrorMessages("ZIPCODE_ONLY"), " ");
} }
function AddEducationDetailsComponent_ng_container_1_div_62_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵelementStart(1, "div", 15);
    i0.ɵɵelementStart(2, "label", 88);
    i0.ɵɵtext(3, "State");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "p-dropdown", 89);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("options", ctx_r7.listStates);
} }
function AddEducationDetailsComponent_ng_container_1_div_63_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵelementStart(1, "div", 15);
    i0.ɵɵelementStart(2, "label", 88);
    i0.ɵɵtext(3, "State");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "input", 90);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function AddEducationDetailsComponent_ng_container_1_div_75_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 91);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r9.getGlobalErrorMessages("INVALID_YEAR"), " ");
} }
function AddEducationDetailsComponent_ng_container_1_div_76_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 94);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r23 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r23.getGlobalErrorMessages("INVALID_YEAR"), " ");
} }
function AddEducationDetailsComponent_ng_container_1_div_76_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵelementStart(1, "div", 15);
    i0.ɵɵelementStart(2, "label", 92);
    i0.ɵɵtext(3, "End Year");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "year-date-picker-library", 39);
    i0.ɵɵtemplate(5, AddEducationDetailsComponent_ng_container_1_div_76_div_5_Template, 2, 1, "div", 93);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("yearFormControl", ctx_r10.addDegreeCourceForm.controls.endYear);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r10.showEndYearValidationError);
} }
function AddEducationDetailsComponent_ng_container_1_div_86_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 95);
    i0.ɵɵtext(1, " Awarded Date cannot be less than End year ");
    i0.ɵɵelementEnd();
} }
function AddEducationDetailsComponent_ng_container_1_lib_save_as_draft_90_Template(rf, ctx) { if (rf & 1) {
    const _r25 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "lib-save-as-draft", 96);
    i0.ɵɵlistener("onClickSaveAsDraft", function AddEducationDetailsComponent_ng_container_1_lib_save_as_draft_90_Template_lib_save_as_draft_onClickSaveAsDraft_0_listener($event) { i0.ɵɵrestoreView(_r25); const ctx_r24 = i0.ɵɵnextContext(2); return ctx_r24.saveAsDraft($event); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", ctx_r13.isSaveAsDraftDisabled)("formToBeSaved", ctx_r13.addDegreeCourceForm);
} }
function AddEducationDetailsComponent_ng_container_1_ng_template_104_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 97);
    i0.ɵɵtext(1, "Related Courses");
    i0.ɵɵelementEnd();
} }
function AddEducationDetailsComponent_ng_container_1_mat_chip_114_mat_icon_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon", 101);
    i0.ɵɵtext(1, "cancel");
    i0.ɵɵelementEnd();
} }
function AddEducationDetailsComponent_ng_container_1_mat_chip_114_Template(rf, ctx) { if (rf & 1) {
    const _r30 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-chip", 98);
    i0.ɵɵlistener("removed", function AddEducationDetailsComponent_ng_container_1_mat_chip_114_Template_mat_chip_removed_0_listener() { i0.ɵɵrestoreView(_r30); const cource_r26 = ctx.$implicit; const ctx_r29 = i0.ɵɵnextContext(2); return ctx_r29.remove(cource_r26); });
    i0.ɵɵelementStart(1, "span", 99);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, AddEducationDetailsComponent_ng_container_1_mat_chip_114_mat_icon_3_Template, 2, 0, "mat-icon", 100);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const cource_r26 = ctx.$implicit;
    const i_r27 = ctx.index;
    const ctx_r16 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("selectable", ctx_r16.selectable)("removable", ctx_r16.removable);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "inputValueCourseName", i_r27, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(cource_r26.courseName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r16.removable);
} }
function AddEducationDetailsComponent_ng_container_1_div_122_tr_9_mat_icon_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon", 113);
    i0.ɵɵtext(1, "delete_forever");
    i0.ɵɵelementEnd();
} }
function AddEducationDetailsComponent_ng_container_1_div_122_tr_9_Template(rf, ctx) { if (rf & 1) {
    const _r36 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 107);
    i0.ɵɵelementStart(1, "td", 108);
    i0.ɵɵelementStart(2, "div", 109);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td", 110);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "td", 111);
    i0.ɵɵlistener("click", function AddEducationDetailsComponent_ng_container_1_div_122_tr_9_Template_td_click_6_listener() { i0.ɵɵrestoreView(_r36); const i_r33 = ctx.index; const ctx_r35 = i0.ɵɵnextContext(3); return ctx_r35.deleteEducation(i_r33); });
    i0.ɵɵtemplate(7, AddEducationDetailsComponent_ng_container_1_div_122_tr_9_mat_icon_7_Template, 2, 0, "mat-icon", 112);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const course_r32 = ctx.$implicit;
    const i_r33 = ctx.index;
    const ctx_r31 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("id", "tableValueCourseNo", i_r33, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i_r33 + 1, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "tableValueCourseName", i_r33, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(course_r32.courseName);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r31.viewMode);
} }
function AddEducationDetailsComponent_ng_container_1_div_122_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 102);
    i0.ɵɵelementStart(1, "table", 103);
    i0.ɵɵelementStart(2, "thead");
    i0.ɵɵelement(3, "th");
    i0.ɵɵelementStart(4, "th", 104);
    i0.ɵɵtext(5, "Course Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "th", 105);
    i0.ɵɵtext(7, "Action");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "tbody");
    i0.ɵɵtemplate(9, AddEducationDetailsComponent_ng_container_1_div_122_tr_9_Template, 8, 5, "tr", 106);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(9);
    i0.ɵɵproperty("ngForOf", ctx_r17.listCourses);
} }
function AddEducationDetailsComponent_ng_container_1_button_127_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 80);
    i0.ɵɵelementStart(1, "span", 114);
    i0.ɵɵtext(2, "Back");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function AddEducationDetailsComponent_ng_container_1_ng_template_133_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 115);
    i0.ɵɵtext(1, "Related Documents");
    i0.ɵɵelementEnd();
} }
function AddEducationDetailsComponent_ng_container_1_div_148_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r39 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 118);
    i0.ɵɵlistener("click", function AddEducationDetailsComponent_ng_container_1_div_148_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r39); i0.ɵɵnextContext(2); const _r3 = i0.ɵɵreference(9); const ctx_r38 = i0.ɵɵnextContext(); ctx_r38.addNewDegree(); return _r3.reset(); });
    i0.ɵɵelementStart(1, "span", 119);
    i0.ɵɵtext(2, "Add New Degree");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function AddEducationDetailsComponent_ng_container_1_div_148_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 116);
    i0.ɵɵtemplate(1, AddEducationDetailsComponent_ng_container_1_div_148_button_1_Template, 3, 0, "button", 117);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r20.viewMode);
} }
const _c0$2 = function (a0) { return { disabledView: a0 }; };
const _c1$2 = function (a0) { return { "im-input-error": a0 }; };
function AddEducationDetailsComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r41 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AddEducationDetailsComponent_ng_container_1_div_1_Template, 4, 0, "div", 2);
    i0.ɵɵelementStart(2, "mat-accordion");
    i0.ɵɵelementStart(3, "mat-expansion-panel", 3);
    i0.ɵɵelementStart(4, "mat-card");
    i0.ɵɵelementStart(5, "div", 4);
    i0.ɵɵelementStart(6, "i", 5);
    i0.ɵɵlistener("click", function AddEducationDetailsComponent_ng_container_1_Template_i_click_6_listener() { i0.ɵɵrestoreView(_r41); const ctx_r40 = i0.ɵɵnextContext(); return ctx_r40.handleClose(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 6);
    i0.ɵɵelementStart(8, "mat-horizontal-stepper", 7, 8);
    i0.ɵɵelementStart(10, "mat-step", 9);
    i0.ɵɵelementStart(11, "form", 10);
    i0.ɵɵtemplate(12, AddEducationDetailsComponent_ng_container_1_ng_template_12_Template, 2, 0, "ng-template", 11);
    i0.ɵɵelementStart(13, "div", 12);
    i0.ɵɵelementStart(14, "div", 13);
    i0.ɵɵelementStart(15, "div", 14);
    i0.ɵɵelementStart(16, "div", 15);
    i0.ɵɵelementStart(17, "label", 16);
    i0.ɵɵtext(18, "Degree");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(19, "p-dropdown", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "div", 14);
    i0.ɵɵelementStart(21, "div", 15);
    i0.ɵɵelementStart(22, "label", 18);
    i0.ɵɵtext(23, "Field of study");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(24, "input", 19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(25, "div", 14);
    i0.ɵɵelementStart(26, "div", 15);
    i0.ɵɵelementStart(27, "label", 20);
    i0.ɵɵtext(28, "Grade/CGPA/Percentage");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(29, "input", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(30, "div", 6);
    i0.ɵɵelementStart(31, "div", 14);
    i0.ɵɵelementStart(32, "div", 15);
    i0.ɵɵelementStart(33, "label", 22);
    i0.ɵɵtext(34, "University Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(35, "input", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(36, "div", 6);
    i0.ɵɵelementStart(37, "div", 24);
    i0.ɵɵelementStart(38, "div", 15);
    i0.ɵɵelementStart(39, "label", 25);
    i0.ɵɵtext(40, "Address Line 1");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(41, "input", 26);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(42, "div", 6);
    i0.ɵɵelementStart(43, "div", 24);
    i0.ɵɵelementStart(44, "div", 15);
    i0.ɵɵelementStart(45, "label", 27);
    i0.ɵɵtext(46, "Address Line 2");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(47, "input", 28);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(48, "div", 14);
    i0.ɵɵelementStart(49, "div", 15);
    i0.ɵɵelementStart(50, "label", 29);
    i0.ɵɵelementStart(51, "span", 30);
    i0.ɵɵtext(52, "ZIP / Postalcode");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(53, AddEducationDetailsComponent_ng_container_1_span_53_Template, 1, 0, "span", 1);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(54, "input", 31);
    i0.ɵɵtemplate(55, AddEducationDetailsComponent_ng_container_1_span_55_Template, 2, 1, "span", 32);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(56, "div", 6);
    i0.ɵɵelementStart(57, "div", 14);
    i0.ɵɵelementStart(58, "div", 15);
    i0.ɵɵelementStart(59, "label", 33);
    i0.ɵɵtext(60, "Country");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(61, "p-dropdown", 34);
    i0.ɵɵlistener("onChange", function AddEducationDetailsComponent_ng_container_1_Template_p_dropdown_onChange_61_listener() { i0.ɵɵrestoreView(_r41); const ctx_r42 = i0.ɵɵnextContext(); return ctx_r42.handleCountryChange(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(62, AddEducationDetailsComponent_ng_container_1_div_62_Template, 5, 1, "div", 35);
    i0.ɵɵtemplate(63, AddEducationDetailsComponent_ng_container_1_div_63_Template, 5, 0, "div", 35);
    i0.ɵɵelementStart(64, "div", 14);
    i0.ɵɵelementStart(65, "div", 15);
    i0.ɵɵelementStart(66, "label", 36);
    i0.ɵɵtext(67, "City");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(68, "input", 37);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(69, "div", 6);
    i0.ɵɵelementStart(70, "div", 14);
    i0.ɵɵelementStart(71, "div", 15);
    i0.ɵɵelementStart(72, "label", 38);
    i0.ɵɵtext(73, "Start Year");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(74, "year-date-picker-library", 39);
    i0.ɵɵtemplate(75, AddEducationDetailsComponent_ng_container_1_div_75_Template, 2, 1, "div", 40);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(76, AddEducationDetailsComponent_ng_container_1_div_76_Template, 6, 2, "div", 35);
    i0.ɵɵelementStart(77, "div", 14);
    i0.ɵɵelementStart(78, "div", 15);
    i0.ɵɵelementStart(79, "label", 41);
    i0.ɵɵtext(80, "Degree Awarded Date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(81, "mat-form-field", 42);
    i0.ɵɵelementStart(82, "input", 43);
    i0.ɵɵlistener("click", function AddEducationDetailsComponent_ng_container_1_Template_input_click_82_listener() { i0.ɵɵrestoreView(_r41); const _r11 = i0.ɵɵreference(85); return _r11.open(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(83, "mat-datepicker-toggle", 44);
    i0.ɵɵelement(84, "mat-datepicker", null, 45);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(86, AddEducationDetailsComponent_ng_container_1_div_86_Template, 2, 0, "div", 46);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(87, "div");
    i0.ɵɵelementStart(88, "div", 47);
    i0.ɵɵelementStart(89, "div", 48);
    i0.ɵɵtemplate(90, AddEducationDetailsComponent_ng_container_1_lib_save_as_draft_90_Template, 1, 2, "lib-save-as-draft", 49);
    i0.ɵɵelementStart(91, "button", 50);
    i0.ɵɵlistener("click", function AddEducationDetailsComponent_ng_container_1_Template_button_click_91_listener() { i0.ɵɵrestoreView(_r41); const ctx_r44 = i0.ɵɵnextContext(); return ctx_r44.saveDegreeDetails(); });
    i0.ɵɵelementStart(92, "span", 51);
    i0.ɵɵtext(93, "Save");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(94, "hr");
    i0.ɵɵelementStart(95, "div", 52);
    i0.ɵɵelementStart(96, "div", 53);
    i0.ɵɵelementStart(97, "button", 54);
    i0.ɵɵelementStart(98, "span", 55);
    i0.ɵɵtext(99, "Next");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(100, "div", 56);
    i0.ɵɵtext(101, " (Click on save button to save data) ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(102, "mat-step", 57);
    i0.ɵɵelementStart(103, "form", 10);
    i0.ɵɵtemplate(104, AddEducationDetailsComponent_ng_container_1_ng_template_104_Template, 2, 0, "ng-template", 11);
    i0.ɵɵelementStart(105, "div", 12);
    i0.ɵɵelementStart(106, "div", 58);
    i0.ɵɵelementStart(107, "label", 59);
    i0.ɵɵtext(108, "List of Courses");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(109, "div", 6);
    i0.ɵɵelementStart(110, "div", 60);
    i0.ɵɵelementStart(111, "mat-form-field", 61);
    i0.ɵɵelementStart(112, "mat-chip-list", 62, 63);
    i0.ɵɵtemplate(114, AddEducationDetailsComponent_ng_container_1_mat_chip_114_Template, 4, 5, "mat-chip", 64);
    i0.ɵɵelementStart(115, "input", 65);
    i0.ɵɵlistener("paste", function AddEducationDetailsComponent_ng_container_1_Template_input_paste_115_listener($event) { i0.ɵɵrestoreView(_r41); const ctx_r45 = i0.ɵɵnextContext(); return ctx_r45.pasteChips($event); })("matChipInputTokenEnd", function AddEducationDetailsComponent_ng_container_1_Template_input_matChipInputTokenEnd_115_listener($event) { i0.ɵɵrestoreView(_r41); const ctx_r46 = i0.ɵɵnextContext(); return ctx_r46.add($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(116, "mat-hint", 66);
    i0.ɵɵtext(117, "Please enter comma separated values");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(118, "div", 67);
    i0.ɵɵelementStart(119, "button", 68);
    i0.ɵɵlistener("click", function AddEducationDetailsComponent_ng_container_1_Template_button_click_119_listener() { i0.ɵɵrestoreView(_r41); const ctx_r47 = i0.ɵɵnextContext(); return ctx_r47.addCourses(); });
    i0.ɵɵelementStart(120, "span", 69);
    i0.ɵɵtext(121, "Add");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(122, AddEducationDetailsComponent_ng_container_1_div_122_Template, 10, 1, "div", 70);
    i0.ɵɵelement(123, "div", 71);
    i0.ɵɵelement(124, "hr");
    i0.ɵɵelementStart(125, "div", 6);
    i0.ɵɵelementStart(126, "div", 72);
    i0.ɵɵtemplate(127, AddEducationDetailsComponent_ng_container_1_button_127_Template, 3, 0, "button", 73);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(128, "div", 74);
    i0.ɵɵelementStart(129, "button", 75);
    i0.ɵɵelementStart(130, "span", 76);
    i0.ɵɵtext(131, "Next");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(132, "mat-step");
    i0.ɵɵtemplate(133, AddEducationDetailsComponent_ng_container_1_ng_template_133_Template, 2, 0, "ng-template", 11);
    i0.ɵɵelementStart(134, "div", 12);
    i0.ɵɵelementStart(135, "div", 6);
    i0.ɵɵelementStart(136, "p", 77);
    i0.ɵɵtext(137, " Select the related Degree documents and then click upload to save ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(138, "div", 6);
    i0.ɵɵelementStart(139, "div", 78);
    i0.ɵɵelementStart(140, "file-upload-deafult-library", 79);
    i0.ɵɵlistener("fileUploadSuccess", function AddEducationDetailsComponent_ng_container_1_Template_file_upload_deafult_library_fileUploadSuccess_140_listener() { i0.ɵɵrestoreView(_r41); const ctx_r48 = i0.ɵɵnextContext(); return ctx_r48.fileUploadSuccess(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(141, "div", 47);
    i0.ɵɵelement(142, "hr");
    i0.ɵɵelementStart(143, "div", 6);
    i0.ɵɵelementStart(144, "div", 14);
    i0.ɵɵelementStart(145, "button", 80);
    i0.ɵɵelementStart(146, "span", 81);
    i0.ɵɵtext(147, "Back");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(148, AddEducationDetailsComponent_ng_container_1_div_148_Template, 2, 1, "div", 82);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r11 = i0.ɵɵreference(85);
    const _r15 = i0.ɵɵreference(113);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.isEditMode);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("expanded", ctx_r0.expandPanel);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("linear", ctx_r0.isLinear);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("completed", ctx_r0.hasID);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formGroup", ctx_r0.addDegreeCourceForm);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(36, _c0$2, ctx_r0.isViewMode));
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("options", ctx_r0.degreeTypeList);
    i0.ɵɵadvance(34);
    i0.ɵɵproperty("ngIf", ctx_r0.iscountryUSA);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(38, _c1$2, ctx_r0.addDegreeCourceForm.get("postCode").touched && (ctx_r0.addDegreeCourceForm.get("postCode").errors == null ? null : ctx_r0.addDegreeCourceForm.get("postCode").errors.pattern)));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.addDegreeCourceForm.get("postCode").touched && (ctx_r0.addDegreeCourceForm.get("postCode").errors == null ? null : ctx_r0.addDegreeCourceForm.get("postCode").errors.required));
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("options", ctx_r0.listCountry);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.listStates.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.listStates.length <= 0);
    i0.ɵɵadvance(11);
    i0.ɵɵproperty("yearFormControl", ctx_r0.addDegreeCourceForm.controls.startYear);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showStartYearValidationError);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.iscaseRequest ? ctx_r0.currentItemDisplay.includes("EDUDTLS") ? true : false : true);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("min", ctx_r0.endYearValue)("matDatepicker", _r11);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("for", _r11);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.showAwardedYearValidationError);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r0.beneficiaryType === "self");
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("disabled", !ctx_r0.hasID);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("stepControl", ctx_r0.addRelatedCourceForm);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formGroup", ctx_r0.addRelatedCourceForm);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(40, _c0$2, ctx_r0.isViewMode));
    i0.ɵɵadvance(9);
    i0.ɵɵproperty("ngForOf", ctx_r0.courses);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matChipInputFor", _r15)("matChipInputSeparatorKeyCodes", ctx_r0.separatorKeysCodes);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("disabled", ctx_r0.courses && ctx_r0.courses.length === 0);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.listCourses && ctx_r0.listCourses.length > 0);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r0.iscaseRequest ? ctx_r0.currentItemDisplay.includes("DGRENAME") ? true : ctx_r0.currentItemDisplay.includes("EDUDTLS") ? true : ctx_r0.currentItemDisplay.includes("GRADE") ? true : ctx_r0.currentItemDisplay.includes("STUDYFIELD") ? true : ctx_r0.currentItemDisplay.includes("UNIVERSITYADR") ? true : ctx_r0.currentItemDisplay.includes("UNIVERSITYNAME") ? true : false : true);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(42, _c0$2, ctx_r0.isViewMode));
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("isWizard", ctx_r0.isWizard)("primaryData", ctx_r0.inputData)("configurations", ctx_r0.degreeFileUploadConfigurations);
    i0.ɵɵadvance(8);
    i0.ɵɵproperty("ngIf", !ctx_r0.viewMode);
} }
function AddEducationDetailsComponent_div_2_ng_container_6_th_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 131);
    i0.ɵɵelementStart(1, "span", 99);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r58 = i0.ɵɵnextContext();
    const indx_r55 = ctx_r58.index;
    const column_r54 = ctx_r58.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "tableHead", indx_r55, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", column_r54.header, " ");
} }
function AddEducationDetailsComponent_div_2_ng_container_6_td_2_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 136);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r66 = i0.ɵɵnextContext();
    const i_r60 = ctx_r66.renderIndex;
    const element_r59 = ctx_r66.$implicit;
    const ctx_r65 = i0.ɵɵnextContext();
    const indx_r55 = ctx_r65.index;
    const column_r54 = ctx_r65.$implicit;
    i0.ɵɵpropertyInterpolate2("id", "colTextLbl", indx_r55, "__", i_r60, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(column_r54.columnDef == "degreeType" ? element_r59 == null ? null : element_r59.degreeType == null ? null : element_r59.degreeType.description : element_r59[column_r54.columnDef]);
} }
function AddEducationDetailsComponent_div_2_ng_container_6_td_2_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 136);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r68 = i0.ɵɵnextContext();
    const i_r60 = ctx_r68.renderIndex;
    const element_r59 = ctx_r68.$implicit;
    const ctx_r67 = i0.ɵɵnextContext();
    const indx_r55 = ctx_r67.index;
    const column_r54 = ctx_r67.$implicit;
    i0.ɵɵpropertyInterpolate2("id", "colTextLblDate", indx_r55, "__", i_r60, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(element_r59[column_r54.columnDef] ? element_r59[column_r54.columnDef] : "");
} }
function AddEducationDetailsComponent_div_2_ng_container_6_td_2_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 137);
    i0.ɵɵelementStart(1, "mat-icon", 138);
    i0.ɵɵtext(2, "expand_more");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function AddEducationDetailsComponent_div_2_ng_container_6_td_2_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r71 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 139);
    i0.ɵɵelementStart(1, "mat-icon", 140);
    i0.ɵɵlistener("click", function AddEducationDetailsComponent_div_2_ng_container_6_td_2_div_5_Template_mat_icon_click_1_listener() { i0.ɵɵrestoreView(_r71); const element_r59 = i0.ɵɵnextContext().$implicit; const ctx_r69 = i0.ɵɵnextContext(3); return ctx_r69.editDegreeHandler(element_r59); });
    i0.ɵɵtext(2, "edit");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "mat-icon", 141);
    i0.ɵɵlistener("click", function AddEducationDetailsComponent_div_2_ng_container_6_td_2_div_5_Template_mat_icon_click_3_listener() { i0.ɵɵrestoreView(_r71); const element_r59 = i0.ɵɵnextContext().$implicit; const ctx_r72 = i0.ɵɵnextContext(3); return ctx_r72.handleDelete(element_r59, ctx_r72.addDegreeCourceForm); });
    i0.ɵɵtext(4, " delete_forever");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function AddEducationDetailsComponent_div_2_ng_container_6_td_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 132);
    i0.ɵɵtemplate(1, AddEducationDetailsComponent_div_2_ng_container_6_td_2_span_1_Template, 2, 3, "span", 133);
    i0.ɵɵtemplate(2, AddEducationDetailsComponent_div_2_ng_container_6_td_2_span_2_Template, 2, 3, "span", 133);
    i0.ɵɵtemplate(3, AddEducationDetailsComponent_div_2_ng_container_6_td_2_span_3_Template, 3, 0, "span", 134);
    i0.ɵɵelementStart(4, "div");
    i0.ɵɵtemplate(5, AddEducationDetailsComponent_div_2_ng_container_6_td_2_div_5_Template, 5, 0, "div", 135);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r54 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", column_r54.columnDef != "startYear" && column_r54.columnDef != "endYear" && column_r54.columnDef != "toggle" && column_r54.columnDef != "action");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", column_r54.columnDef == "startYear" || column_r54.columnDef == "endYear");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", column_r54.columnDef == "toggle");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", column_r54.columnDef == "action");
} }
function AddEducationDetailsComponent_div_2_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 129);
    i0.ɵɵtemplate(1, AddEducationDetailsComponent_div_2_ng_container_6_th_1_Template, 3, 2, "th", 130);
    i0.ɵɵtemplate(2, AddEducationDetailsComponent_div_2_ng_container_6_td_2_Template, 6, 4, "td", 125);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const column_r54 = ctx.$implicit;
    i0.ɵɵpropertyInterpolate("matColumnDef", column_r54.columnDef);
} }
function AddEducationDetailsComponent_div_2_td_8_div_2_tr_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 147);
    i0.ɵɵelementStart(1, "td", 108);
    i0.ɵɵelementStart(2, "div", 109);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td", 148);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r80 = ctx.$implicit;
    const i_r81 = ctx.index;
    const ixx_r76 = i0.ɵɵnextContext(2).renderIndex;
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate2("id", "courseNoForOuterSection", i_r81, "_", ixx_r76, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", i_r81 + 1, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate2("id", "courseNameForOuterSection", i_r81, "_", ixx_r76, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", item_r80.courseName, " ");
} }
function AddEducationDetailsComponent_div_2_td_8_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 144);
    i0.ɵɵelementStart(1, "h6", 99);
    i0.ɵɵtext(2, "List of Courses");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerStart(3);
    i0.ɵɵelementStart(4, "table", 145);
    i0.ɵɵtemplate(5, AddEducationDetailsComponent_div_2_td_8_div_2_tr_5_Template, 6, 6, "tr", 146);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r83 = i0.ɵɵnextContext();
    const ixx_r76 = ctx_r83.renderIndex;
    const element_r75 = ctx_r83.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "headListOfCourses1_", ixx_r76, "");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", element_r75.courses);
} }
function AddEducationDetailsComponent_div_2_td_8_div_3_ng_container_15_tr_1_Template(rf, ctx) { if (rf & 1) {
    const _r90 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td", 108);
    i0.ɵɵelementStart(2, "div", 109);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td");
    i0.ɵɵelementStart(5, "strong", 99);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td", 148);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "td", 153);
    i0.ɵɵelementStart(10, "button", 154);
    i0.ɵɵlistener("click", function AddEducationDetailsComponent_div_2_td_8_div_3_ng_container_15_tr_1_Template_button_click_10_listener() { i0.ɵɵrestoreView(_r90); const item_r85 = i0.ɵɵnextContext().$implicit; const ctx_r88 = i0.ɵɵnextContext(4); return ctx_r88.downloadDoc(item_r85); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r91 = i0.ɵɵnextContext();
    const i_r86 = ctx_r91.index;
    const item_r85 = ctx_r91.$implicit;
    const ixx_r76 = i0.ɵɵnextContext(2).renderIndex;
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("id", "tableValueDocNoOuter", i_r86, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", i_r86 + 1, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate2("id", "tableValueDocNameOuter", i_r86, "_", ixx_r76, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(item_r85 == null ? null : item_r85.fileName);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate2("id", "tableValueDocCategoryOuter", i_r86, "_", ixx_r76, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", (item_r85 == null ? null : item_r85.fileCategory == null ? null : item_r85.fileCategory.code) === "OTHER" ? item_r85 == null ? null : item_r85.fileCategoryOtherName : item_r85 == null ? null : item_r85.fileCategory == null ? null : item_r85.fileCategory.name, " ");
} }
function AddEducationDetailsComponent_div_2_td_8_div_3_ng_container_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AddEducationDetailsComponent_div_2_td_8_div_3_ng_container_15_tr_1_Template, 11, 8, "tr", 1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r85 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r85 == null ? null : item_r85.fileName);
} }
function AddEducationDetailsComponent_div_2_td_8_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 144);
    i0.ɵɵelementStart(1, "h6", 149);
    i0.ɵɵtext(2, "List of Documents ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerStart(3);
    i0.ɵɵelementStart(4, "table", 150);
    i0.ɵɵelementStart(5, "thead");
    i0.ɵɵelementStart(6, "tr");
    i0.ɵɵelement(7, "th", 108);
    i0.ɵɵelementStart(8, "th", 99);
    i0.ɵɵtext(9, "Document");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "th", 99);
    i0.ɵɵtext(11, "Document Type ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "th");
    i0.ɵɵelement(13, "i", 151);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "tbody");
    i0.ɵɵtemplate(15, AddEducationDetailsComponent_div_2_td_8_div_3_ng_container_15_Template, 2, 1, "ng-container", 152);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r93 = i0.ɵɵnextContext();
    const ixx_r76 = ctx_r93.renderIndex;
    const element_r75 = ctx_r93.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "headListOfDocs1", ixx_r76, "");
    i0.ɵɵadvance(7);
    i0.ɵɵpropertyInterpolate1("id", "tableHeadDocOuter1", ixx_r76, "");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("id", "tableHeadDocTypeOuter1", ixx_r76, "");
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngForOf", element_r75.documents);
} }
function AddEducationDetailsComponent_div_2_td_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 132);
    i0.ɵɵelementStart(1, "div", 142);
    i0.ɵɵtemplate(2, AddEducationDetailsComponent_div_2_td_8_div_2_Template, 6, 2, "div", 143);
    i0.ɵɵtemplate(3, AddEducationDetailsComponent_div_2_td_8_div_3_Template, 16, 4, "div", 143);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const element_r75 = ctx.$implicit;
    const ctx_r50 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("colspan", ctx_r50.columns.length);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("@detailExpand", element_r75 == ctx_r50.expandedElement ? "expanded" : "collapsed");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", element_r75 && element_r75.courses && element_r75.courses.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", element_r75 && element_r75.documents && element_r75.documents.length > 0);
} }
function AddEducationDetailsComponent_div_2_tr_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 155);
} }
function AddEducationDetailsComponent_div_2_tr_10_Template(rf, ctx) { if (rf & 1) {
    const _r96 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 156);
    i0.ɵɵlistener("click", function AddEducationDetailsComponent_div_2_tr_10_Template_tr_click_0_listener() { i0.ɵɵrestoreView(_r96); const element_r94 = ctx.$implicit; const ctx_r95 = i0.ɵɵnextContext(2); return ctx_r95.expandedElement = ctx_r95.expandedElement === element_r94 ? null : element_r94; });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const element_r94 = ctx.$implicit;
    const ctx_r52 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("example-expanded-row", ctx_r52.expandedElement === element_r94);
} }
function AddEducationDetailsComponent_div_2_tr_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 157);
} }
const _c2 = function () { return ["expandedDetail"]; };
function AddEducationDetailsComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 120);
    i0.ɵɵelementStart(2, "div", 121);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div");
    i0.ɵɵelementStart(5, "table", 122);
    i0.ɵɵtemplate(6, AddEducationDetailsComponent_div_2_ng_container_6_Template, 3, 1, "ng-container", 123);
    i0.ɵɵelementContainerStart(7, 124);
    i0.ɵɵtemplate(8, AddEducationDetailsComponent_div_2_td_8_Template, 4, 4, "td", 125);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵtemplate(9, AddEducationDetailsComponent_div_2_tr_9_Template, 1, 0, "tr", 126);
    i0.ɵɵtemplate(10, AddEducationDetailsComponent_div_2_tr_10_Template, 1, 2, "tr", 127);
    i0.ɵɵtemplate(11, AddEducationDetailsComponent_div_2_tr_11_Template, 1, 0, "tr", 128);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", ctx_r1.educationDetails.length > 0 ? ctx_r1.educationDetails.length : "No", " Degrees Added by you");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("dataSource", ctx_r1.dataSource);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r1.columns);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("matHeaderRowDef", ctx_r1.displayedColumns);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matRowDefColumns", ctx_r1.displayedColumns);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matRowDefColumns", i0.ɵɵpureFunction0(6, _c2));
} }
const DeleteDialogConfigurations$1 = {
    width: '50%',
    closeOnEscape: false,
    closable: false,
    showHeader: false,
    contentStyle: { "z-index": "1001" }
};
class AddEducationDetailsComponent {
    constructor(cacheCountryService, apiService, toastr, changeDetectorRef, referenceLibraryService, fb, route, dialog, store, 
    //public dynamicDialogConfig: DynamicDialogConfig,
    dialogService
    // private benServ: BeneficiaryQuestionnaireService
    ) {
        // this.referenceLibraryService.getReferenceData('BENEDUDOC').pipe(takeUntil(this.observableSubscription$))..subscribe((response: ReferenceLibrary[]) => {
        //   this.documentTypes = response;
        // });
        var _a, _b, _c, _d;
        this.cacheCountryService = cacheCountryService;
        this.apiService = apiService;
        this.toastr = toastr;
        this.changeDetectorRef = changeDetectorRef;
        this.referenceLibraryService = referenceLibraryService;
        this.fb = fb;
        this.route = route;
        this.dialog = dialog;
        this.store = store;
        this.dialogService = dialogService;
        this.isSyncPage = false;
        this.modeVal = false;
        this.showEditButton = false;
        this.isTabEmitter = new EventEmitter();
        this.submitted = false;
        this.updateBenProfile = true;
        this.listCourses = [];
        this.educationDetailsList = [];
        // auto chips
        this.visible = true;
        this.selectable = true;
        this.removable = true;
        this.addOnBlur = true;
        this.isEditMode = false;
        this.separatorKeysCodes = [ENTER, COMMA];
        this.courses = [];
        this.documentTypes = [];
        this.setYearValue = '2010';
        this.showEndYearValidationError = false;
        this.showStartYearValidationError = false;
        this.showAwardedYearValidationError = false;
        this.formSubmittd = false;
        this.viewMode = false;
        this.degreeFileUploadConfigurations = {
            inputMultipleFlag: true,
            fileType: acceptedFileTypes,
            isFileListRequired: true,
            categoryName: 'BENEDUDOC',
            entityId: 0,
            fileCategory: '',
            listUploadedFiles: [],
            documentTypeRequired: true,
            docummentTypeCode: 'BENEDUDOC',
            useCase: 'beneficiary',
            useCaseId: 0,
            useEntityId: false,
            familyId: null,
        };
        this.expandPanel = false;
        this.isListView = false;
        this.isTimeLineView = true;
        this.hasID = false;
        this.isLinear = true;
        this.iscountryUSA = false;
        this.destroy$ = new Subject();
        this.observableSubscription$ = new Subject();
        this.isSaveAsDraftDisabled = true;
        this.isLocked = false;
        this.currentItemDisplay = [];
        this.iscaseRequest = false;
        ///////////////// --------------------------------------------------------- LISTING CODE START ---------------------------------------------------//
        this.educationList = [];
        this.educationDetails = [];
        this.displayedColumns = [];
        this.dynamicDialogConfig = {};
        this.enableEdit = new EventEmitter();
        this.removeElement = new EventEmitter();
        this.columns = [
            { columnDef: 'toggle', header: 'toggle', columnType: 'icon', customClass: '' },
            { columnDef: 'degreeType', header: 'Degree', columnType: 'text', customClass: '' },
            { columnDef: 'fieldOfStudy', header: 'Field Of Study', columnType: 'text', customClass: '' },
            { columnDef: 'startYear', header: 'Start Year', columnType: 'text', customClass: '' },
            { columnDef: 'endYear', header: 'End Year', columnType: 'text', customClass: '' },
            { columnDef: 'grade', header: 'Grade', columnType: 'text', customClass: '' },
            { columnDef: 'university', header: 'University', columnType: 'text', customClass: '' },
            { columnDef: 'action', header: 'Action', columnType: 'icon', customClass: '' }
        ];
        ///////////////// --------------------------------------------------------- LISTING CODE END ---------------------------------------------------//
        this.showDegreeAwardedDateRequired = true;
        this.addDegreeCourceForm = this.fb.group({
            id: [],
            degree: [''],
            degreeType: ['', Validators.required],
            fieldOfStudy: ['', Validators.required],
            grade: [''],
            universityName: ['', Validators.required],
            addressLine1: ['', Validators.required],
            addressLine2: [''],
            postCode: [''],
            countryCode: ['', Validators.required],
            stateProvinceCode: [null],
            stateProvinceName: [''],
            city: ['', Validators.required],
            startYear: ['', Validators.required],
            endYear: ['', Validators.required],
            degreeAwardedDate: ['']
        });
        this.addRelatedCourceForm = this.fb.group({});
        this.listCountry = [];
        this.listStates = [];
        this.formChangesSubscriptions = [];
        this.inputData = {
            visaType: 'H1B',
            caseType: 'PETITION',
            caseId: JSON.parse(sessionStorage.getItem('tempPetitionId')),
            superTaskId: (_b = (_a = this.dynamicDialogConfig.data) === null || _a === void 0 ? void 0 : _a.superTaskId) !== null && _b !== void 0 ? _b : null,
            subTaskId: (_d = (_c = this.dynamicDialogConfig.data) === null || _c === void 0 ? void 0 : _c.subTaskId) !== null && _d !== void 0 ? _d : null
        };
    }
    translet() {
        setTimeout(() => {
            this.referenceLibraryService.transletConversion();
        }, 600);
    }
    tabChange() {
        this.translet();
    }
    handleClose() {
        this.isEditMode = false;
        this.expandPanel = false;
        this.isTabEmitter.emit(true);
        this.translet();
    }
    ngOnInit() {
        var _a, _b, _c;
        this.referenceLibraryService.getReferenceDataWithoutAuthentication('DEGR').pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            this.referenceLibraryService.translateArray(response, 'name')
                .then(translated => {
                this.degreeTypeList = translated;
            })
                .catch(error => console.error("Translation error:", error));
        });
        this.cacheCountryService.getCountry().pipe(takeUntil(this.observableSubscription$)).subscribe(data => {
            if (data.length > 0) {
                this.referenceLibraryService.translateArray([{ countryCode: '', countryName: 'Select', phoneCode: '' }, ...data], 'countryName')
                    .then(translated => {
                    this.listCountry = translated;
                })
                    .catch(error => console.error("Translation error:", error));
            }
        });
        this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
        this.onlyFormBuilder = this.route.snapshot.queryParams.pageFrom;
        if (this.onlyFormBuilder === 'FB') {
            this.beneficiaryId = (sessionStorage.getItem('FbEmployeeId')) ? parseInt(sessionStorage.getItem('FbEmployeeId')) : 0;
        }
        else {
            this.beneficiaryId = (sessionStorage.getItem('listBeneficiaryId')) ? parseInt(sessionStorage.getItem('listBeneficiaryId')) : (this.apiService.currentUserValue['beneficiaryId']);
        }
        this.modeVal = true;
        this.viewMode = sessionStorage.getItem('bene-profile-viewMode') == 'true' ? true : false;
        this.expandPanel = false;
        this.hasID = false;
        this.isLinear = true;
        this.afterLoadingNgInit();
        this.formStatusCheck();
        if (this.isProfile) {
            this.getEducationDetailsForProfile();
        }
        else if (((_a = this.editEduData) === null || _a === void 0 ? void 0 : _a.caseType) == 'I140' || ((_c = (_b = this.editEduData) === null || _b === void 0 ? void 0 : _b.caseType) === null || _c === void 0 ? void 0 : _c.toLowerCase()) == 'perm') {
            this.getEducationList();
        }
        else {
            this.getDegreeDetails();
        }
    }
    downloadDoc(doc) {
        this.apiService.downloadDocuments(environment.docs + doc.fileLocation.substring(23), doc.fileLocation.substring(23));
    }
    isFormFilled(form) {
        return form && form.controls
            ? Object.entries(form.controls).some(([key, control]) => {
                const value = control.value;
                return value !== null && value !== undefined && (typeof value === 'string' ? value.trim() !== '' : !!value);
            })
            : false;
    }
    formStatusCheck() {
        this.formChangesSubscriptions[0] = this.addDegreeCourceForm.valueChanges.pipe(map(() => this.addDegreeCourceForm.dirty && this.addDegreeCourceForm.enabled), distinctUntilChanged(), takeUntil(this.destroy$)).subscribe(dirty => {
            if (dirty) {
                this.store.dispatch(new MarkDirtyFormAction({
                    dirty: true,
                    message: 'If you leave before saving, all changes made on the \'Education\' form will be lost. Do you wish to continue?'
                }));
            }
            else {
                this.store.dispatch(new MarkCleanFormAction({
                    dirty: false,
                    message: ''
                }));
            }
        });
        this.formChangesSubscriptions[1] = this.addRelatedCourceForm.valueChanges.pipe(map(() => this.addRelatedCourceForm.dirty && this.addRelatedCourceForm.enabled), distinctUntilChanged(), takeUntil(this.destroy$)).subscribe(dirty => {
            if (dirty) {
                this.store.dispatch(new MarkDirtyFormAction({
                    dirty: true,
                    message: 'If you leave before saving, all changes made on the \'Related Course\' form will be lost. Do you wish to continue?'
                }));
            }
            else {
                this.store.dispatch(new MarkCleanFormAction({
                    dirty: false,
                    message: ''
                }));
            }
        });
    }
    afterLoadingNgInit() {
        if (this.route.snapshot.paramMap.get('listview')) {
            this.toggleListView(true);
        }
        if (sessionStorage.getItem('newFamilyId')) {
            this.familyId = sessionStorage.getItem('newFamilyId');
        }
        if (this.beneficiaryId) {
            this.degreeFileUploadConfigurations.useCaseId = this.beneficiaryId;
            this.degreeFileUploadConfigurations.familyId = this.familyId;
            this.degreeFileUploadConfigurations = Object.assign({}, this.degreeFileUploadConfigurations);
            this.getUpolodedFiles();
        }
        // this.cacheCountryService.getCachedCountryList().pipe(takeUntil(this.observableSubscription$)).subscribe(data => {
        //   if (data.listCountries.length > 0) {
        //     this.referenceLibraryService.translateArray(data.listCountries, 'countryName')
        //     .then(translated => {
        //       this.listCountry = translated;
        //     })
        //     .catch(error => console.error("Translation error:", error));
        //   }
        // });
        this.apiService.deletedfile$.pipe(takeUntil(this.observableSubscription$)).subscribe(status => {
            var _a, _b, _c;
            if (status === true) {
                if (this.isProfile) {
                    this.getEducationDetailsForProfile();
                }
                else if (((_a = this.editEduData) === null || _a === void 0 ? void 0 : _a.caseType) == 'I140' || ((_c = (_b = this.editEduData) === null || _b === void 0 ? void 0 : _b.caseType) === null || _c === void 0 ? void 0 : _c.toLowerCase()) == 'perm') {
                    this.getEducationList();
                }
                else {
                    this.getDegreeDetails();
                }
            }
        });
        this.addDegreeCourceForm.controls['endYear'].valueChanges.pipe(takeUntil(this.observableSubscription$)).subscribe(change => {
            this.degreeAwardedDateValidator();
        });
        this.addDegreeCourceForm.controls['startYear'].valueChanges.pipe(takeUntil(this.observableSubscription$)).subscribe(change => {
            this.degreeAwardedDateValidator();
        });
        // IM-3493 - System accepting Degree awarded date lesser than education end year
        this.addDegreeCourceForm.controls['degreeAwardedDate'].valueChanges.pipe(takeUntil(this.observableSubscription$)).subscribe(val => {
            this.showAwardedYearValidationError = false;
            if (this.addDegreeCourceForm.get('endYear').value && moment(this.addDegreeCourceForm.get('endYear').value).format('YYYY') > moment(val).format('YYYY')) {
                this.showAwardedYearValidationError = true;
            }
        });
        // if (localStorage.getItem('currentUserSelection') && (localStorage.getItem('currentUserSelection') != 'undefined' || localStorage.getItem('currentUserSelection') != 'null')) {
        //   this.selectedUser = JSON.parse(localStorage.getItem('currentUserSelection'));
        // }
        // if (localStorage.getItem('customQuestions')) {
        //   this.customQuestions = JSON.parse(localStorage.getItem('customQuestions'));
        // }
    }
    handleCountryChange() {
        const countryCode = this.addDegreeCourceForm.get('countryCode').value;
        this.apiService.getStates(countryCode).pipe(takeUntil(this.observableSubscription$)).subscribe((states) => {
            this.referenceLibraryService.translateArray(states, 'stateProvinceName')
                .then(translated => {
                this.listStates = translated;
                this.changeDetectorRef.markForCheck();
                this.addDegreeCourceForm.get('stateProvinceName').clearValidators();
                this.addDegreeCourceForm.get('stateProvinceCode').clearValidators();
                if (states.length > 0) {
                    this.addDegreeCourceForm.get('stateProvinceCode').setValidators([Validators.required]);
                }
                else {
                    this.addDegreeCourceForm.get('stateProvinceName').setValidators([Validators.required]);
                }
                this.addDegreeCourceForm.get('stateProvinceName').updateValueAndValidity();
                this.addDegreeCourceForm.get('stateProvinceCode').updateValueAndValidity();
                if (this.iscaseRequest) {
                    this.addDegreeCourceForm.get('stateProvinceName').clearValidators();
                    this.addDegreeCourceForm.get('stateProvinceCode').clearValidators();
                    this.addDegreeCourceForm.get('stateProvinceName').updateValueAndValidity();
                    this.addDegreeCourceForm.get('stateProvinceCode').updateValueAndValidity();
                }
            })
                .catch(error => console.error("Translation error:", error));
        });
        if (countryCode === 'USA') {
            this.iscountryUSA = true;
            this.addDegreeCourceForm.get('postCode').setValidators([Validators.required, Validators.pattern(/^[a-z0-9]+$/)]);
        }
        else {
            this.iscountryUSA = false;
            this.addDegreeCourceForm.get('postCode').clearValidators();
            this.addDegreeCourceForm.get('postCode').setValidators([Validators.pattern(/^[a-z0-9]+$/)]);
        }
        this.addDegreeCourceForm.get('postCode').updateValueAndValidity();
        if (this.iscaseRequest) {
            this.addDegreeCourceForm.get('postCode').clearValidators();
            this.addDegreeCourceForm.get('postCode').setValidators([Validators.pattern(/^[a-z0-9]+$/)]);
            this.addDegreeCourceForm.get('postCode').updateValueAndValidity();
        }
        this.degreeAwardedDateValidator();
    }
    addCourses() {
        this.listCourses = this.listCourses.concat(this.courses);
        this.saveDegreeDetails();
    }
    deleteEducation(index) {
        const deleteDialogRef = this.dialogService.open(DeleteDialogLibraryComponent, DeleteDialogConfigurations$1);
        deleteDialogRef.onClose.pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            if (response) {
                if (index !== -1) {
                    this.listCourses.splice(index, 1);
                }
                this.saveDegreeDetails(false, true);
            }
        });
    }
    getEducationList() {
        let url;
        if (this.editEduData.caseType == 'I140') {
            url = this.apiService.getBeneEducationInformation(this.dynamicDialogConfig.data ? this.dynamicDialogConfig.data.superTaskId : this.editEduData.superTaskId, this.dynamicDialogConfig.data ? this.dynamicDialogConfig.data.subTaskId : this.editEduData.subTaskId, this.isUsedForBeneEdit);
        }
        else if (this.editEduData.caseType.toLowerCase() == 'perm') {
            url = this.apiService.getBeneEducationInformationPerm(this.editEduData.caseId, this.isUsedForBeneEdit);
        }
        url.pipe(takeUntil(this.observableSubscription$)).subscribe((data) => {
            this.educationList = data;
            if (data['status'] === 200) {
                this.educationDetailsList = data['data'];
                if (this.educationDetailsList) {
                    this.educationDetails = this.educationDetailsList;
                    this.educationDetails = this.educationDetails.map(e1 => {
                        let _e1 = Object.assign({}, e1);
                        if (_e1.documents) {
                            _e1.documents = _e1.documents.filter(e => !!e.fileLocation).map(e2 => {
                                let _e2 = Object.assign({}, e2);
                                if (_e2.fileLocation) {
                                    _e2.fileLocationName = _e2.fileLocation.substring(23);
                                    this.courses = [];
                                    this.addDegreeCourceForm.controls['id'].setValue(_e1.id);
                                    return _e2;
                                }
                            });
                        }
                        else {
                            this.degreeFileUploadConfigurations.listUploadedFiles = [];
                        }
                        return _e1;
                    });
                    this.dataSource = new MatTableDataSource(this.educationDetails);
                }
            }
            if (data['status'] === 204) {
                this.educationDetailsList = [];
                this.educationDetails = [];
                this.dataSource = new MatTableDataSource([]);
            }
        });
        this.translet();
    }
    checkDocName(element) {
        var _a;
        if (!(element === null || element === void 0 ? void 0 : element.documents)) {
            return false;
        }
        else {
            return (_a = element === null || element === void 0 ? void 0 : element.documents) === null || _a === void 0 ? void 0 : _a.some(val => val === null || val === void 0 ? void 0 : val.fileName);
        }
    }
    getDegreeDetails() {
        // let petitionId = JSON.parse(sessionStorage.getItem('tempPetitionId'));
        this.apiService.getEducationDetails(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, sync_profile_code.SYNC_TASK_TYPE_EDUCATION, this.inputData.superTaskId, this.inputData.subTaskId, !this.isSyncPage)
            .pipe(take(1))
            .subscribe(data => {
            if (data['status'] === 200) {
                this.educationDetailsList = data['data'];
                if (this.educationDetailsList) {
                    this.educationDetails = this.educationDetailsList;
                    this.educationDetails = this.educationDetails.map(e1 => {
                        let _e1 = Object.assign({}, e1);
                        if (_e1.documents) {
                            _e1.documents = _e1.documents.map(e2 => {
                                let _e2 = Object.assign({}, e2);
                                if (_e2.fileLocation) {
                                    _e2.fileLocationName = _e2.fileLocation.substring(23);
                                    this.courses = [];
                                    this.addDegreeCourceForm.controls['id'].setValue(_e1.id);
                                    return _e2;
                                }
                            });
                        }
                        else {
                            this.degreeFileUploadConfigurations.listUploadedFiles = [];
                        }
                        return _e1;
                    });
                    this.dataSource = new MatTableDataSource(this.educationDetails);
                }
            }
            if (data['status'] === 204) {
                this.educationDetailsList = [];
                this.educationDetails = [];
                this.dataSource = new MatTableDataSource([]);
            }
        });
        this.translet();
    }
    getEducationDetailsForProfile() {
        if (sessionStorage.getItem('newFamilyId')) {
            this.familyId = sessionStorage.getItem('newFamilyId');
        }
        const getEducationReq = this.apiService.getEducationDetailsForProfile(this.beneficiaryId, this.familyId);
        getEducationReq.pipe(take(1))
            .subscribe(data => {
            var _a;
            if (data['status'] === 200) {
                this.educationDetailsList = (_a = data['data']) === null || _a === void 0 ? void 0 : _a['education'];
                if (this.educationDetailsList) {
                    this.educationDetails = this.educationDetailsList;
                    this.educationDetails = this.educationDetails.map(e1 => {
                        let _e1 = Object.assign({}, e1);
                        if (_e1.documents) {
                            _e1.documents = _e1.documents.map(e2 => {
                                let _e2 = Object.assign({}, e2);
                                if (_e2.fileLocation) {
                                    _e2.fileLocationName = _e2.fileLocation.substring(23);
                                    this.courses = [];
                                    this.addDegreeCourceForm.controls['id'].setValue(_e1.id);
                                    return _e2;
                                }
                            });
                        }
                        else {
                            this.degreeFileUploadConfigurations.listUploadedFiles = [];
                        }
                        return _e1;
                    });
                    this.dataSource = new MatTableDataSource(this.educationDetails);
                    this.translet();
                }
            }
            if (data['status'] === 204) {
                this.educationDetailsList = [];
                this.educationDetails = [];
                this.dataSource = new MatTableDataSource([]);
            }
        });
    }
    saveDegreeDetails(isDraft = false, isDel) {
        this.educationDegreeDetails = this.addDegreeCourceForm.value;
        this.createPayload(this.addDegreeCourceForm.value, isDraft, isDel);
        this.addDegreeCourceForm.reset(this.addDegreeCourceForm.value);
    }
    createPayload(degreeInfo, isDraft = false, isDel) {
        var _a, _b, _c, _d, _e;
        const reqObj = {
            isSaveAsDraft: isDraft,
            id: this.eduId || 0,
            country: {
                countryCode: degreeInfo.countryCode ? degreeInfo.countryCode : ''
            },
            //country: degreeInfo && degreeInfo.countryCode ? { countryCode: degreeInfo.countryCode } : null,
            university: degreeInfo.universityName ? degreeInfo.universityName : '',
            degree: degreeInfo.degree ? degreeInfo.degree : '',
            grade: degreeInfo.grade ? degreeInfo.grade : '',
            equivalance: degreeInfo.equivalance ? degreeInfo.equivalance : '',
            fieldOfStudy: degreeInfo.fieldOfStudy ? degreeInfo.fieldOfStudy : '',
            startYear: degreeInfo.startYear ? moment(degreeInfo.startYear).year().toString() : '',
            endYear: degreeInfo.endYear ? moment(degreeInfo.endYear).year().toString() : '',
            degreeAwardedDate: degreeInfo.degreeAwardedDate ? moment(degreeInfo.degreeAwardedDate).format('YYYY-MM-DD') : '',
            addressLine1: degreeInfo.addressLine1 ? degreeInfo.addressLine1 : '',
            addressLine2: degreeInfo.addressLine2 ? degreeInfo.addressLine2 : '',
            stateProvinceCode: degreeInfo.stateProvinceCode ? degreeInfo.stateProvinceCode : null,
            stateProvinceName: degreeInfo.stateProvinceName ? degreeInfo.stateProvinceName : '',
            postCode: degreeInfo.postCode ? degreeInfo.postCode : '',
            city: degreeInfo.city ? degreeInfo.city : '',
            degreeType: degreeInfo && degreeInfo.degreeType ? { id: degreeInfo.degreeType } : null,
            courses: this.listCourses
        };
        const reqPayload = { education: [reqObj] };
        let petitionId = JSON.parse(sessionStorage.getItem('tempPetitionId'));
        if (!this.isFormFilled(this.addDegreeCourceForm)) {
            this.toastr.warning('Empty records cannot be saved!', 'Warning');
            return;
        }
        let url;
        if (this.isProfile) {
            url = this.apiService.saveEducatinDegreeDetailsForProfile(this.beneficiaryId, reqPayload, this.familyId);
        }
        else if (((_a = this.inputData) === null || _a === void 0 ? void 0 : _a.caseType) == 'I140') {
            url = this.apiService.savegcI140DegreeDetails((_b = degreeInfo.gcI140CaseId) !== null && _b !== void 0 ? _b : this.inputData.caseId, reqPayload);
        }
        else if (((_d = (_c = this.inputData) === null || _c === void 0 ? void 0 : _c.caseType) === null || _d === void 0 ? void 0 : _d.toLowerCase()) == 'perm') {
            url = this.apiService.savePermDegreeDetails((_e = degreeInfo.gcI140CaseId) !== null && _e !== void 0 ? _e : this.inputData.caseId, reqPayload);
        }
        else {
            url = this.apiService.saveEducatinDegreeDetails(petitionId, reqPayload, this.familyId);
        }
        url.pipe(takeUntil(this.observableSubscription$)).subscribe(response => {
            var _a, _b, _c;
            if (response.status === 200) {
                if (this.isProfile) {
                    if (this.beneficiaryType === 'self') {
                        if (this.customQuestionsComponent) {
                            this.customQuestionsComponent.onClickSave(null);
                        }
                    }
                    else {
                        if (this.customQuestionsComponent) {
                            this.customQuestionsComponent.onClickSave(this.familyId);
                        }
                    }
                    const educationListing = response.data['education'];
                    educationListing.forEach(element => {
                        this.degreeFileUploadConfigurations.entityId = element.id;
                        this.degreeFileUploadConfigurations = Object.assign({}, this.degreeFileUploadConfigurations);
                        this.listCourses = element.courses;
                        // reqObj.id = element.id;
                        this.addDegreeCourceForm.controls['id'].setValue(element.id);
                        this.eduId = element === null || element === void 0 ? void 0 : element.id;
                        // this.addDegreeCourceForm.get('id').setValue=element.id;
                    });
                    this.degreeFileUploadConfigurations.useCase = 'beneficiary';
                }
                else {
                    this.degreeFileUploadConfigurations.entityId = response.data.id;
                    this.degreeFileUploadConfigurations = Object.assign({}, this.degreeFileUploadConfigurations);
                    this.listCourses = response.data.courses;
                    this.eduId = response.data.id;
                }
                if (isDel) {
                    this.toastr.success('Data deleted successfully!', 'Success');
                }
                else {
                    this.toastr.success(response.message, 'Success');
                }
                this.courses = [];
                // this.addDegreeCourceForm.controls['id'].patchValue(response.data.id);\
                this.hasID = true;
                this.isLinear = false;
                this.degreeFileUploadConfigurations.useCaseId = this.beneficiaryId;
                // this.resetForm();
                if (this.isProfile) {
                    this.getEducationDetailsForProfile();
                }
                else if (((_a = this.editEduData) === null || _a === void 0 ? void 0 : _a.caseType) == 'I140' || ((_c = (_b = this.editEduData) === null || _b === void 0 ? void 0 : _b.caseType) === null || _c === void 0 ? void 0 : _c.toLowerCase()) == 'perm') {
                    this.getEducationList();
                }
                else {
                    this.getDegreeDetails();
                }
            }
            else {
                CustomErrorToastComponent.showErrorToast(this.toastr, response.message);
            }
        });
    }
    editDegreeHandler(eduDegree) {
        this.expandPanel = true;
        this.isEditMode = true;
        this.isTabEmitter.emit(false);
        this.eduId = eduDegree.id;
        this.addDegreeCourceForm.setValue({
            id: eduDegree.id ? eduDegree.id : 0,
            degree: eduDegree.degree ? eduDegree.degree : '',
            degreeType: eduDegree && eduDegree.degreeType ? eduDegree.degreeType.id : null,
            fieldOfStudy: eduDegree.fieldOfStudy,
            grade: eduDegree.grade ? eduDegree.grade : '',
            universityName: eduDegree.university,
            addressLine1: eduDegree.addressLine1,
            addressLine2: eduDegree.addressLine2,
            postCode: eduDegree.postCode ? eduDegree.postCode : '',
            countryCode: eduDegree.country ? eduDegree.country.countryCode : null,
            stateProvinceCode: eduDegree.stateProvinceCode ? eduDegree.stateProvinceCode : null,
            stateProvinceName: eduDegree.stateProvinceName,
            city: eduDegree.city,
            startYear: eduDegree.startYear ? moment([eduDegree.startYear, 0, 1]) : '',
            endYear: eduDegree.endYear ? moment([eduDegree.endYear, 0, 1]) : '',
            degreeAwardedDate: eduDegree.degreeAwardedDate ? moment(eduDegree.degreeAwardedDate).toISOString() : ''
        });
        this.handleCountryChange();
        this.listCourses = eduDegree.courses ? eduDegree.courses : [];
        if (eduDegree.id) {
            this.degreeFileUploadConfigurations.listUploadedFiles = eduDegree.documents;
            this.degreeFileUploadConfigurations.useCaseId = this.beneficiaryId;
            this.degreeFileUploadConfigurations.entityId = eduDegree.id;
            this.degreeFileUploadConfigurations = Object.assign({}, this.degreeFileUploadConfigurations);
            this.hasID = true;
            this.isLinear = false;
        }
    }
    add(event) {
        const input = event.input;
        const value = event.value;
        // Add our fruit
        if ((value || '').trim()) {
            this.courses.push({
                courseName: value.trim(),
                courseId: ''
            });
        }
        // Reset the input value
        if (input) {
            input.value = '';
        }
    }
    pasteChips(event) {
        event.preventDefault(); // Prevents the default action
        event.clipboardData
            .getData('Text') // Gets the text pasted
            .split(/,/) // Splits it when a SEMICOLON or COMMA or NEWLINE
            .forEach(value => {
            if (value.trim()) {
                this.courses.push({
                    courseName: value.trim(),
                    courseId: ''
                }); // Push if valid
            }
        });
    }
    remove(fruit) {
        const index = this.courses.indexOf(fruit);
        if (index >= 0) {
            this.courses.splice(index, 1);
        }
    }
    // dynamically adding validator for degreeAwardedDate
    degreeAwardedDateValidator() {
        const countryCode = this.addDegreeCourceForm.get('countryCode').value;
        const degreeAwardedDateControl = this.addDegreeCourceForm.get('degreeAwardedDate');
        // const endYearControl = this.addDegreeCourceForm.get('endYear');
        let endYear;
        let startYear;
        if (this.addDegreeCourceForm.get('startYear').value) {
            startYear = (this.addDegreeCourceForm.get('startYear').value).year();
        }
        if (this.addDegreeCourceForm.get('endYear').value) {
            this.endYearValue = moment(this.addDegreeCourceForm.get('endYear').value).format('YYYY-MM-DD');
            endYear = (this.addDegreeCourceForm.get('endYear').value).year();
        }
        const currentYear = moment().year();
        if (endYear && countryCode) {
            if (countryCode !== 'USA' && (endYear < currentYear)) {
                this.showDegreeAwardedDateRequired = true;
                degreeAwardedDateControl.setValidators(Validators.required);
            }
            else {
                this.showDegreeAwardedDateRequired = false;
                degreeAwardedDateControl.clearValidators();
            }
        }
        if (startYear && endYear) {
            // IM-3850 -Education -> End year same as start year to be allowed
            if (endYear >= startYear) {
                this.showEndYearValidationError = false;
            }
            else {
                this.showEndYearValidationError = true;
            }
        }
        if (startYear) {
            if (startYear > (new Date()).getFullYear()) {
                this.showStartYearValidationError = true;
            }
            else {
                this.showStartYearValidationError = false;
            }
        }
        degreeAwardedDateControl.updateValueAndValidity();
    }
    toggleExpansion() {
        this.isEditMode = true;
        this.expandPanel = true;
        this.isTabEmitter.emit(false);
        if (this.expandPanel) {
            this.resetForm();
            this.hasID = false;
            this.isLinear = true;
        }
    }
    addNewDegree() {
        this.resetForm();
        this.hasID = false;
        this.isLinear = true;
    }
    resetForm() {
        // this.addDegreeCourceForm.clearValidators();
        // this.addDegreeCourceForm.updateValueAndValidity();
        this.addDegreeCourceForm.reset();
        // validators required for both new and edit form
        this.formSubmittd = true;
        this.listCourses = [];
        this.degreeFileUploadConfigurations.listUploadedFiles = [];
        this.degreeFileUploadConfigurations.useCaseId = 0;
        this.degreeFileUploadConfigurations.entityId = 0;
        this.degreeFileUploadConfigurations = Object.assign({}, this.degreeFileUploadConfigurations);
        this.showEndYearValidationError = false;
        this.showStartYearValidationError = false;
    }
    closeForm() {
        this.toggleExpansion();
        this.addDegreeCourceForm.reset();
    }
    fileUploadSuccess() {
        var _a, _b, _c;
        if (this.isProfile) {
            this.getEducationDetailsForProfile();
        }
        else if (((_a = this.editEduData) === null || _a === void 0 ? void 0 : _a.caseType) == 'I140' || ((_c = (_b = this.editEduData) === null || _b === void 0 ? void 0 : _b.caseType) === null || _c === void 0 ? void 0 : _c.toLowerCase()) == 'perm') {
            this.getEducationList();
        }
        else {
            this.getDegreeDetails();
        }
    }
    toggleListView(val) {
        if (!val) {
            this.isTimeLineView = true;
            this.isListView = false;
        }
        else {
            this.isTimeLineView = false;
            this.isListView = true;
        }
    }
    getGlobalErrorMessages(error) {
        return errorUtils.errorMessages.get(error);
    }
    onRefreshPage(event) {
        if (event) {
            this.ngOnInit();
        }
    }
    ngOnChanges(changes) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        if ((_a = changes === null || changes === void 0 ? void 0 : changes.editEduData) === null || _a === void 0 ? void 0 : _a.currentValue) {
            this.inputData = changes.editEduData.currentValue;
            const inputData = Object.assign(Object.assign({}, changes.editEduData.currentValue), { superTaskId: (_d = (_b = changes.editEduData.currentValue.superTaskId) !== null && _b !== void 0 ? _b : (_c = this.inputData) === null || _c === void 0 ? void 0 : _c.superTaskId) !== null && _d !== void 0 ? _d : null, subTaskId: (_g = (_e = changes.editEduData.currentValue.subTaskId) !== null && _e !== void 0 ? _e : (_f = this.inputData) === null || _f === void 0 ? void 0 : _f.subTaskId) !== null && _g !== void 0 ? _g : null });
            this.inputData = Object.assign({}, inputData);
            // if(this.isProfile) {
            //   this.getEducationDetailsForProfile()
            // }else if(this.editEduData?.caseType == 'I140' || this.editEduData?.caseType?.toLowerCase() == 'perm') {
            //   this.getEducationList();
            // }else {
            //   this.getDegreeDetails();
            // }
        }
        if ((_h = changes === null || changes === void 0 ? void 0 : changes.formDetailsData) === null || _h === void 0 ? void 0 : _h.currentValue) {
            if (this.documentTypeData == 'RESUME') {
                this.parsedJsonData = changes.formDetailsData.currentValue;
                if (Array.isArray((_k = (_j = this.parsedJsonData) === null || _j === void 0 ? void 0 : _j.data) === null || _k === void 0 ? void 0 : _k.education) && this.parsedJsonData.data.education.length) {
                    if (Array.isArray(this.dataSource) && this.dataSource.length) {
                        let deleteReqArray = [];
                        this.dataSource.forEach(educationElement => {
                            deleteReqArray.push(this.apiService.deleteEducatinDegreeDetails(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, sync_profile_code.SYNC_TASK_TYPE_EDUCATION, this.inputData.superTaskId, this.inputData.subTaskId, educationElement.id));
                        });
                        combineLatest([...deleteReqArray])
                            .pipe(take(1))
                            .subscribe(data => {
                            this.toastr.success('Deleted education details successfully!', 'Success');
                            this.resetForm();
                            this.getDegreeDetails();
                            this.addExportedDate();
                        });
                    }
                    else {
                        this.addExportedDate();
                    }
                }
            }
        }
    }
    addExportedDate() {
        this.parsedJsonData.data.education.forEach((education, index) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            let degreetype;
            if (education.degree) {
                const degreeTypeObj = this.degreeTypeList.find(x => x.name === education.degree || x.code === education.degree);
                degreetype = degreeTypeObj ? degreeTypeObj.id : null;
            }
            this.addDegreeCourceForm.patchValue({
                // id: education.id ?? 0,
                // degree: education.degree ?? null,
                degreetype: degreetype,
                fieldOfStudy: (_a = education.fieldOfStudy) !== null && _a !== void 0 ? _a : null,
                universityName: (_b = education.universityName) !== null && _b !== void 0 ? _b : null,
                addressLine1: (_c = education.addressLine1) !== null && _c !== void 0 ? _c : null,
                addressLine2: (_d = education.addressLine2) !== null && _d !== void 0 ? _d : null,
                postCode: (_e = education.postCode) !== null && _e !== void 0 ? _e : null,
                countryCode: (_f = education.countryCode) !== null && _f !== void 0 ? _f : null,
                stateProvinceCode: (_g = education.stateProvinceCode) !== null && _g !== void 0 ? _g : null,
                stateProvinceName: (_h = education.stateProvinceName) !== null && _h !== void 0 ? _h : null,
                city: (_j = education.city) !== null && _j !== void 0 ? _j : null
            });
            this.saveDegreeDetails((this.parsedJsonData.data.education.length - 1) === index);
        });
    }
    formValidation() {
        this.addDegreeCourceForm = this.fb.group({
            id: [],
            degree: [''],
            degreeType: [''],
            fieldOfStudy: [''],
            grade: [''],
            universityName: [''],
            addressLine1: [''],
            addressLine2: [''],
            postCode: [''],
            countryCode: [''],
            stateProvinceCode: [null],
            stateProvinceName: [''],
            city: [''],
            startYear: [''],
            endYear: [''],
            degreeAwardedDate: ['']
        });
    }
    ngAfterViewInit() {
        if (this.modeVal) {
            this.showFileUploadSection = true;
            this.toggleListView(true);
            this.translet();
            //this.toggleExpansion();
        }
    }
    ngOnDestroy() {
        this.addDegreeCourceForm.get('startYear').clearValidators();
        this.addDegreeCourceForm.get('endYear').clearValidators();
        this.addDegreeCourceForm.get('startYear').updateValueAndValidity();
        this.addDegreeCourceForm.get('endYear').updateValueAndValidity();
        if (this.formChangesSubscriptions.length > 0) {
            this.formChangesSubscriptions.forEach(element => {
                element.unsubscribe();
            });
        }
        if (this.dependentIdSubscription) {
            this.dependentIdSubscription.unsubscribe();
        }
        this.destroy$.next();
        this.destroy$.complete();
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
        this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
    }
    saveAsDraft(event) {
        this.saveDegreeDetails(event);
    }
    // ----------------------------------------------- LIST VIEW CODE START -----------------------------------------------//
    ngAfterContentInit() {
        this.displayedColumns = this.columns.map(c => c.columnDef);
    }
    handleEdit(educationElement) {
        this.enableEdit.emit(educationElement);
    }
    handleDelete(input, addDegreeCourceForm) {
        const deleteDialogRef = this.dialogService.open(DeleteDialogLibraryComponent, DeleteDialogConfigurations$1);
        deleteDialogRef.onClose.pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            var _a, _b, _c;
            if (response) {
                let url;
                let petitionId = JSON.parse(sessionStorage.getItem('tempPetitionId'));
                if (this.isProfile) {
                    url = this.apiService.deleteEducatinDegreeDetailsForProfile(this.beneficiaryId, parseInt(input.id), this.familyId);
                }
                else if (((_a = this.editEduData) === null || _a === void 0 ? void 0 : _a.caseType) == 'I140' || ((_c = (_b = this.editEduData) === null || _b === void 0 ? void 0 : _b.caseType) === null || _c === void 0 ? void 0 : _c.toLowerCase()) == 'perm') {
                    url = this.apiService.deletegcI140DegreeDetails(this.inputData.superTaskId, this.inputData.subTaskId, input.id);
                }
                else {
                    url = this.apiService.deleteEducatinDegreeDetails(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, sync_profile_code.SYNC_TASK_TYPE_EDUCATION, this.inputData.superTaskId, this.inputData.subTaskId, input.id);
                }
                url.pipe(takeUntil(this.observableSubscription$)).subscribe(data => {
                    var _a, _b, _c;
                    if (this.addDegreeCourceForm.get('id').value === input.id) {
                        this.resetForm();
                    }
                    this.toastr.success("Data deleted successfully!", 'Success');
                    if (this.isProfile) {
                        this.getEducationDetailsForProfile();
                    }
                    else if (((_a = this.editEduData) === null || _a === void 0 ? void 0 : _a.caseType) == 'I140' || ((_c = (_b = this.editEduData) === null || _b === void 0 ? void 0 : _b.caseType) === null || _c === void 0 ? void 0 : _c.toLowerCase()) == 'perm') {
                        this.getEducationList();
                    }
                    else {
                        this.getDegreeDetails();
                    }
                });
            }
        });
    }
    getUpolodedFiles() {
        this.apiService.genericGetUploadDocument(this.degreeFileUploadConfigurations.useCase, this.degreeFileUploadConfigurations.useCaseId, this.degreeFileUploadConfigurations.categoryName, this.degreeFileUploadConfigurations.entityId, this.degreeFileUploadConfigurations.useEntityId, this.degreeFileUploadConfigurations.familyId).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            if (response['status'] === 200) {
                this.listUploadedFiles = response['data'];
                // this.degreeFileUploadConfigurations.listUploadedFiles = response['data'];
                this.degreeFileUploadConfigurations = Object.assign({}, this.degreeFileUploadConfigurations);
            }
            else {
                this.listUploadedFiles = [];
                this.degreeFileUploadConfigurations.listUploadedFiles = [];
            }
        });
    }
}
AddEducationDetailsComponent.ɵfac = function AddEducationDetailsComponent_Factory(t) { return new (t || AddEducationDetailsComponent)(i0.ɵɵdirectiveInject(i1$1.CacheCountryListService), i0.ɵɵdirectiveInject(AddEducationDetailsService), i0.ɵɵdirectiveInject(i3.ToastrService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1$2.ReferenceLibraryService), i0.ɵɵdirectiveInject(i12.FormBuilder), i0.ɵɵdirectiveInject(i6.ActivatedRoute), i0.ɵɵdirectiveInject(i2$1.MatDialog), i0.ɵɵdirectiveInject(i8.Store), i0.ɵɵdirectiveInject(i9.DialogService)); };
AddEducationDetailsComponent.ɵcmp = i0.ɵɵdefineComponent({ type: AddEducationDetailsComponent, selectors: [["add-education-details"]], viewQuery: function AddEducationDetailsComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(MatPaginator, 3);
        i0.ɵɵviewQuery(MatSort, 3);
        i0.ɵɵviewQuery(MatAccordion, 1);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.paginator = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sort = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.accordion = _t);
    } }, inputs: { editEduData: "editEduData", mode: "mode", showFileUploadSection: "showFileUploadSection", isViewMode: "isViewMode", caseRequestShowDivs: "caseRequestShowDivs", isUsedForBeneEdit: "isUsedForBeneEdit", isSyncPage: "isSyncPage", formDetailsData: "formDetailsData", documentTypeData: "documentTypeData", educationList: "educationList", isProfile: "isProfile", isWizard: "isWizard" }, outputs: { isTabEmitter: "isTabEmitter", enableEdit: "enableEdit", removeElement: "removeElement" }, features: [i0.ɵɵNgOnChangesFeature], decls: 3, vars: 2, consts: [[1, "education-container"], [4, "ngIf"], ["class", "row mt-2 d-flex justify-content-end", 4, "ngIf"], ["hideToggle", "", 3, "expanded"], [1, "p-col-12", "text-right", "align-middle", "p-3"], [1, "close-icon", "pi", "pi-times", 3, "click"], [1, "row"], ["labelPosition", "bottom", 1, "pb-mat-stepper-custom-horizontal", 3, "linear"], ["stepper", ""], [3, "completed"], [3, "formGroup"], ["matStepLabel", ""], [1, "formBox", 3, "ngClass"], [1, "row", "paddingTop10"], [1, "col-4"], [1, "form-group"], ["id", "degreeLabel", 1, "label-cls", "common-bene-class-for-translation"], ["formControlName", "degreeType", "optionLabel", "name", "optionValue", "id", "placeholder", "Select Degree", 1, "w-100", 3, "options"], ["id", "studyLabel", 1, "label-cls", "common-bene-class-for-translation"], ["formControlName", "fieldOfStudy", "type", "text", "form", "", "placeholder", "Enter", 1, "im-input", "mw-100"], ["id", "gradeLabel", 1, "label-cls", "common-bene-class-for-translation"], ["type", "text", "name", "grade", "formControlName", "grade", "placeholder", "Enter", 1, "im-input", "mw-100"], ["id", "universityLabel", 1, "label-cls", "common-bene-class-for-translation"], ["formControlName", "universityName", "type", "text", "form", "", "placeholder", "Enter", 1, "im-input", "mw-100"], [1, "col-8"], ["id", "addr1Label", 1, "label-cls", "common-bene-class-for-translation"], ["maxlength", "99", "formControlName", "addressLine1", "type", "text", "form", "", "placeholder", "Enter", 1, "im-input", "mw-100"], ["id", "addr2Label", 1, "label-cls", "common-bene-class-for-translation"], ["maxlength", "99", "formControlName", "addressLine2", "type", "text", "form", "", "placeholder", "Enter", 1, "im-input", "mw-100"], [1, "label-cls"], ["id", "postalCodeLabel", 1, "common-bene-class-for-translation"], ["formControlName", "postCode", "type", "text", "form", "", "placeholder", "Enter", "maxlength", "10", 1, "im-input", "mw-100", 3, "ngClass"], ["class", "invalid-message common-bene-class-for-translation", "id", "postalCodeError", 4, "ngIf"], ["id", "countryLabel", 1, "label-cls", "common-bene-class-for-translation"], ["formControlName", "countryCode", "optionLabel", "countryName", "optionValue", "countryCode", "placeholder", "Select Country", 1, "w-100", 3, "options", "onChange"], ["class", "col-4", 4, "ngIf"], ["id", "cityLabel", 1, "label-cls", "common-bene-class-for-translation"], ["formControlName", "city", "type", "text", "form", "", "placeholder", "Enter", 1, "im-input", "mw-100"], ["id", "startYearLabel", 1, "label-cls", "d-block", "common-bene-class-for-translation"], [3, "yearFormControl"], ["class", "invalid-message common-bene-class-for-translation", "id", "startYearError", 4, "ngIf"], ["id", "degreeDateLabel", 1, "label-cls", "d-block", "common-bene-class-for-translation"], ["appearance", "outline", 1, "mt-0", "date-field", "w-100"], ["formControlName", "degreeAwardedDate", "matInput", "", "placeholder", "MM/DD/YYYY", 3, "min", "matDatepicker", "click"], ["matSuffix", "", 3, "for"], ["degreeAwardedDate", ""], ["class", "invalid-message common-bene-class-for-translation", "id", "degreeDateError", 4, "ngIf"], [1, "row", "paddingTop10", "dasheedTopBorder"], [1, "form-group", "col-md-6"], ["confirmModelKey", "savedraftdegree", "class", "mr-3", 3, "disabled", "formToBeSaved", "onClickSaveAsDraft", 4, "ngIf"], [1, "btn", "btn-success", 3, "click"], ["id", "saveForm1", 1, "common-bene-class-for-translation"], [1, "d-flex", "flex-row-reverse"], [1, "p-2"], ["matStepperNext", "", 1, "btn", "btn-primary", 3, "disabled"], ["id", "next1", 1, "common-bene-class-for-translation"], ["id", "save1Warning", 1, "p-2", "f10", "mTop10", "common-bene-class-for-translation"], [3, "stepControl"], [1, "row", "px-3"], ["id", "listLabelCourses", 1, "common-bene-class-for-translation"], [1, "col-10"], ["appearance", "outline", 1, "example-chip-list", "chips-contianer", "w100"], ["aria-label", "Course selection"], ["chipList", ""], [3, "selectable", "removable", "removed", 4, "ngFor", "ngForOf"], ["placeholder", "Enter Course", 3, "matChipInputFor", "matChipInputSeparatorKeyCodes", "paste", "matChipInputTokenEnd"], ["id", "hintCourseName", 1, "hint-text", "common-bene-class-for-translation"], [1, "col-2", "pt-3"], [1, "btn", "btn-success", 3, "disabled", "click"], ["id", "addCourses", 1, "common-bene-class-for-translation"], ["class", "row mt-4 px-3", 4, "ngIf"], [1, "row", "mt-2", "paddingTop10", "dasheedTopBorder"], [1, "col-6"], ["class", "back-button", "matStepperPrevious", "", 4, "ngIf"], [1, "col-6", "text-right"], ["matStepperNext", "", 1, "btn", "btn-success"], ["id", "next2", 1, "common-bene-class-for-translation"], ["id", "uploadDegreeWarning1", 1, "common-bene-class-for-translation"], [1, "col-12"], [1, "w-100", 3, "isWizard", "primaryData", "configurations", "fileUploadSuccess"], ["matStepperPrevious", "", 1, "back-button"], ["id", "back2", 1, "common-bene-class-for-translation"], ["class", "col-8 text-right", 4, "ngIf"], [1, "row", "mt-2", "d-flex", "justify-content-end"], ["type", "button", 1, "btn", "btn-primary", "mb-2", 3, "click"], ["id", "add-edu", 1, "common-bene-class-for-translation"], ["id", "sectionHeadEdu", 1, "common-bene-class-for-translation"], ["id", "postalCodeError", 1, "invalid-message", "common-bene-class-for-translation"], ["id", "stateLabel", 1, "label-cls", "common-bene-class-for-translation"], ["formControlName", "stateProvinceCode", "optionLabel", "stateProvinceName", "optionValue", "stateProvinceCode", "placeholder", "Select State", 1, "w-100", 3, "options"], ["name", "addState", "formControlName", "stateProvinceName", "type", "text", "placeholder", "State", 1, "im-input", "mw-100"], ["id", "startYearError", 1, "invalid-message", "common-bene-class-for-translation"], ["id", "endYearLabel", 1, "label-cls", "d-block", "common-bene-class-for-translation"], ["class", "invalid-message common-bene-class-for-translation", "id", "endYearError", 4, "ngIf"], ["id", "endYearError", 1, "invalid-message", "common-bene-class-for-translation"], ["id", "degreeDateError", 1, "invalid-message", "common-bene-class-for-translation"], ["confirmModelKey", "savedraftdegree", 1, "mr-3", 3, "disabled", "formToBeSaved", "onClickSaveAsDraft"], ["id", "sectionHeadCourses", 1, "common-bene-class-for-translation"], [3, "selectable", "removable", "removed"], [1, "common-bene-class-for-translation", 3, "id"], ["matTooltip", "Remove this item", "matChipRemove", "", 4, "ngIf"], ["matTooltip", "Remove this item", "matChipRemove", ""], [1, "row", "mt-4", "px-3"], [1, "im-card-no-border-table", 2, "width", "100%"], ["id", "tableHeadCourseName", 1, "common-bene-class-for-translation"], ["id", "tableHeadCourseAction", 1, "common-bene-class-for-translation"], ["class", "col-md-12", 4, "ngFor", "ngForOf"], [1, "col-md-12"], [1, "w40"], [1, "circleIndex", "rounded-circle", "common-bene-class-for-translation", 3, "id"], [1, "col-md-10", "common-bene-class-for-translation", 3, "id"], [1, "col-md-2", 2, "cursor", "pointer", 3, "click"], ["matTooltip", "Delete", 4, "ngIf"], ["matTooltip", "Delete"], ["id", "back1", 1, "common-bene-class-for-translation"], ["id", "sectionHeadDocs", 1, "common-bene-class-for-translation"], [1, "col-8", "text-right"], ["class", "btn btn-primary", "matStepperNext", "", 3, "click", 4, "ngIf"], ["matStepperNext", "", 1, "btn", "btn-primary", 3, "click"], ["id", "addNewDegree1", 1, "common-bene-class-for-translation"], [1, "p-3"], ["id", "educationLengthWaring", 1, "common-bene-class-for-translation"], ["mat-table", "", "multiTemplateDataRows", "", 1, "im-card-no-border-table", 3, "dataSource"], [3, "matColumnDef", 4, "ngFor", "ngForOf"], ["matColumnDef", "expandedDetail"], ["mat-cell", "", 4, "matCellDef"], ["mat-header-row", "", 4, "matHeaderRowDef"], ["mat-row", "", "class", "example-element-row", 3, "example-expanded-row", "click", 4, "matRowDef", "matRowDefColumns"], ["mat-row", "", "class", "example-detail-row", 4, "matRowDef", "matRowDefColumns"], [3, "matColumnDef"], ["mat-header-cell", "", 4, "matHeaderCellDef"], ["mat-header-cell", ""], ["mat-cell", ""], ["class", "common-bene-class-for-translation m-0", 3, "id", 4, "ngIf"], ["class", "toggle-col", 4, "ngIf"], ["class", "row", "style", "width:100px;", 4, "ngIf"], [1, "common-bene-class-for-translation", "m-0", 3, "id"], [1, "toggle-col"], ["matTooltip", "View more", 1, "mr-1", "icn"], [1, "row", 2, "width", "100px"], ["matTooltip", "Edit", 1, "im-table-verticle-icon", 3, "click"], ["matTooltip", "Delete", 1, "mr-1", "icn", 3, "click"], [1, "example-element-detail"], ["class", "w100 example-element-description py-1", 4, "ngIf"], [1, "w100", "example-element-description", "py-1"], [1, "table", "table-striped"], ["class", "border border-dark", 4, "ngFor", "ngForOf"], [1, "border", "border-dark"], ["nowrap", "", 1, "common-bene-class-for-translation", 3, "id"], [1, "header-tab", "common-bene-class-for-translation", 3, "id"], [1, "im-card-no-border-table", "border"], ["aria-hidden", "true", 1, "fa", "fa-download", "fa-lg", "icn"], [4, "ngFor", "ngForOf"], ["nowrap", ""], ["pButton", "", "type", "button", "icon", "pi pi-download", "pTooltip", "Download", 1, "p-button-text", "p-button-rounded", "p-3", 3, "click"], ["mat-header-row", ""], ["mat-row", "", 1, "example-element-row", 3, "click"], ["mat-row", "", 1, "example-detail-row"]], template: function AddEducationDetailsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, AddEducationDetailsComponent_ng_container_1_Template, 149, 44, "ng-container", 1);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(2, AddEducationDetailsComponent_div_2_Template, 12, 7, "div", 1);
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isExternalEmployeeId);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isEditMode);
    } }, directives: [i10.NgIf, i9$1.MatAccordion, i9$1.MatExpansionPanel, i10$1.MatCard, i11.MatHorizontalStepper, i11.MatStep, i12.ɵangular_packages_forms_forms_ba, i12.NgControlStatusGroup, i12.FormGroupDirective, i11.MatStepLabel, i10.NgClass, i14.Dropdown, i12.NgControlStatus, i12.FormControlName, i12.DefaultValueAccessor, i12.MaxLengthValidator, i15.YearDatePickerLibraryComponent, i16.MatFormField, i17.MatInput, i18.MatDatepickerInput, i18.MatDatepickerToggle, i16.MatSuffix, i18.MatDatepicker, i11.MatStepperNext, i19.MatChipList, i10.NgForOf, i19.MatChipInput, i16.MatHint, i20.FileUploadDeafultLibraryComponent, i11.MatStepperPrevious, i21.SaveAsDraftComponent, i19.MatChip, i22.MatIcon, i19.MatChipRemove, i23.MatTable, i23.MatColumnDef, i23.MatCellDef, i23.MatHeaderRowDef, i23.MatRowDef, i23.MatHeaderCellDef, i23.MatHeaderCell, i23.MatCell, i24.ButtonDirective, i25.Tooltip, i23.MatHeaderRow, i23.MatRow], styles: [".f10[_ngcontent-%COMP%]{font-size:12px;color:#afaaaa}.header-tab[_ngcontent-%COMP%]{font-weight:600;color:#425772!important}.dasheedTopBorder[_ngcontent-%COMP%]{border-top:1px dashed grey}.paddingTop10[_ngcontent-%COMP%]{padding-top:10px}.formBox[_ngcontent-%COMP%], .mTop10[_ngcontent-%COMP%]{margin-top:10px!important}.w100[_ngcontent-%COMP%]{width:100%!important}.mLeft[_ngcontent-%COMP%]{margin-left:2rem}.childBtn.firstBtn[_ngcontent-%COMP%]{border-radius:30px 0 0 30px!important;border-right:-1px solid #dedede!important;border-left:0!important}.childBtn.lastBtn[_ngcontent-%COMP%]{border-bottom-right-radius:30px!important;border-top-right-radius:30px!important;border-right:0!important;border-left:-1px solid #dedede!important}.viewType[_ngcontent-%COMP%] > .childBtn.firstBtn[_ngcontent-%COMP%]{border-right:.75px solid grey!important;border-left:none!important}.viewType[_ngcontent-%COMP%] > .childBtn.lastBtn[_ngcontent-%COMP%]{border-right:none!important;border-left:.75px solid grey!important}.add-placeholder[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]{padding:0 16px!important}.disabledView[_ngcontent-%COMP%]{pointer-events:none}.close-edit[_ngcontent-%COMP%]{position:absolute;right:15px}table[_ngcontent-%COMP%]{width:100%}tr.example-detail-row[_ngcontent-%COMP%]{height:0}tr.example-element-row[_ngcontent-%COMP%]:not(.example-expanded-row):hover{background:#f5f5f5}tr.example-element-row[_ngcontent-%COMP%]:not(.example-expanded-row):active{background:#efefef}.example-element-row[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{border-bottom-width:0}.example-element-detail[_ngcontent-%COMP%]{overflow:hidden}.example-element-diagram[_ngcontent-%COMP%]{min-width:80px;border:2px solid #000;padding:8px;font-weight:lighter;margin:8px 0;height:104px}.example-element-symbol[_ngcontent-%COMP%]{font-weight:700;font-size:40px;line-height:normal}.example-element-description[_ngcontent-%COMP%]{padding:16px}.example-element-description[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:nth-child(odd){background:#d3d3d3}.bgGray[_ngcontent-%COMP%]{background-color:#d3d3d3!important}.w40[_ngcontent-%COMP%]{width:40px!important}"], data: { animation: [
            trigger('detailExpand', [
                state('collapsed', style({ height: '0px', minHeight: '0' })),
                state('expanded', style({ height: '*' })),
                transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
            ]),
        ] } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AddEducationDetailsComponent, [{
        type: Component,
        args: [{
                selector: 'add-education-details',
                templateUrl: './add-education-details.component.html',
                styleUrls: ['./add-education-details.component.scss'],
                animations: [
                    trigger('detailExpand', [
                        state('collapsed', style({ height: '0px', minHeight: '0' })),
                        state('expanded', style({ height: '*' })),
                        transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
                    ]),
                ]
            }]
    }], function () { return [{ type: i1$1.CacheCountryListService }, { type: AddEducationDetailsService }, { type: i3.ToastrService }, { type: i0.ChangeDetectorRef }, { type: i1$2.ReferenceLibraryService }, { type: i12.FormBuilder }, { type: i6.ActivatedRoute }, { type: i2$1.MatDialog }, { type: i8.Store }, { type: i9.DialogService }]; }, { editEduData: [{
            type: Input
        }], mode: [{
            type: Input
        }], showFileUploadSection: [{
            type: Input
        }], isViewMode: [{
            type: Input
        }], caseRequestShowDivs: [{
            type: Input
        }], isUsedForBeneEdit: [{
            type: Input
        }], isSyncPage: [{
            type: Input
        }], formDetailsData: [{
            type: Input
        }], documentTypeData: [{
            type: Input
        }], isTabEmitter: [{
            type: Output
        }], accordion: [{
            type: ViewChildren,
            args: [MatAccordion]
        }], educationList: [{
            type: Input
        }], isProfile: [{
            type: Input
        }], isWizard: [{
            type: Input
        }], paginator: [{
            type: ViewChild,
            args: [MatPaginator, { static: true }]
        }], sort: [{
            type: ViewChild,
            args: [MatSort, { static: true }]
        }], enableEdit: [{
            type: Output
        }], removeElement: [{
            type: Output
        }] }); })();

class EditTrainingDetailsService {
    constructor(http, webStorage) {
        this.http = http;
        this.webStorage = webStorage;
        this.isExpired = false;
        this.statusChangeSubScriptionSubjectStep = new BehaviorSubject(1);
        this.formIsDirtySubject = new BehaviorSubject({ dirty: false, formName: '', formNumber: 1 });
        this.isExperienceChanged = new Subject();
        this.onLifeStorySubTabs = new Subject();
        this.deletedfile$ = new BehaviorSubject({});
        this.showBeneficiary = new BehaviorSubject(false);
        this.countryDataSource = new BehaviorSubject({ listCountries: [] });
        this.uploaded$ = new BehaviorSubject({});
        this.dependentProfileSubject = new BehaviorSubject({});
        this.selfBeneficiaryDetailChange = new Subject();
        this.currentUserSubject = new BehaviorSubject(this.webStorage.getWebStorageItem('currentUser'));
        this.currentUser = this.currentUserSubject.asObservable();
    }
    checkValidity() {
        return this.isExpired; /////
    }
    get currentUserValue() {
        return this.currentUserSubject.value;
    }
    changeDependentProfileID(dependentId, beneficiaryType) {
        this.dependentProfileSubject.next({ dependentId: dependentId, beneficiaryType: beneficiaryType });
    }
    checkBeneEditPermission() {
        const permission = JSON.parse(sessionStorage.getItem('currentUser'));
        return permission ? permission['permissions'].length > 0 && permission['permissions'].find(x => x === 'EDIT_BENEFICIARY') ? true : false : false;
        // return permission['permissions'].length>0 && permission['permissions'].find(x=> x === 'DELETE_BENEFICIARY')? true : false;
    }
    deletefile(beneficiaryId) {
        this.deletedfile$.next(true);
    }
    getTrainingsDetails(visatype, caseType, caseId, synctype, superTaskId, subTaskId, isUsedForBenEdit) {
        return this.http.get(`/${visatype}/${caseType}/${caseId}/${synctype}?superTaskId=${superTaskId}&taskId=${subTaskId}&isUsedForBenEdit=${isUsedForBenEdit}`).pipe(map$1((response) => {
            if (response && (response.status === 200 || response.status === 204)) {
                return response;
            }
        }));
    }
    deleteTrainingsDetails(visatype, caseType, caseId, synctype, superTaskId, subTaskId, educationId) {
        return this.http.delete(`/${visatype}/${caseType}/${caseId}/${synctype}/${educationId}?superTaskId=${superTaskId}&taskId=${subTaskId}`).pipe(map$1((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    saveTrainingDetails(petitionId, type, payload) {
        return this.http.post(`/petition/saveTrainingOrLicense/${petitionId}/${type}`, payload).pipe(map$1((response) => response));
    }
    saveTrainingDetailsForProfile(beneficiaryId, type, payload, familyId) {
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        return this.http.post(`/beneficiary/${beneficiaryId}/profile/professional/${type}${profileFamilyString}`, payload).pipe(map$1((response) => response));
    }
    deleteTrainingsDetailsForProfile(beneficiaryId, type, professionalId, familyId) {
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        return this.http.delete(`/beneficiary/${beneficiaryId}/profile/professional/${professionalId}/${type}${profileFamilyString}`).pipe(map$1((response) => {
            // IM-3066 - remove deleted file.
            this.deletefile(beneficiaryId);
            return response;
        }));
    }
    downloadDocuments(path, fileName) {
        this.http.get(path, { responseType: "arraybuffer" })
            .pipe(take(1))
            .subscribe(pdf => {
            const blob = new Blob([pdf], { type: 'application/pdf' });
            saveAs(blob, fileName);
        });
    }
    getTrainingInformation(superTaskId, subTaskId, isUsedForBenEdit = false) {
        return this.http.get(`/superTask/${superTaskId}/subTask/${subTaskId}/gc/i140Case/education/training?isUsedForBenEdit=${isUsedForBenEdit}`);
    }
    getTrainingInformationPerm(caseId, isUsedForBenEdit) {
        return this.http.get(`/gc/perm/${caseId}/educationDetails/education/training?isUsedForBenEdit=${isUsedForBenEdit}`);
    }
    savegcI140TrainingDetails(gcI140Id, payload, type) {
        const encriptedData = this.toEncrypt(type);
        return this.http.post(`/gcCase/saveTrainingOrLicense/${gcI140Id}/${encriptedData}?isGcI140Case=true&isGcPermCase=false`, payload);
    }
    savegcI140LicenseDetails(gcI140Id, payload, type) {
        const encriptedData = this.toEncrypt(type);
        return this.http.post(`/gcCase/saveTrainingOrLicense/${gcI140Id}/${encriptedData}?isGcI140Case=true&isGcPermCase=false`, payload);
    }
    savePermTrainingDetails(permId, payload, type) {
        const encriptedData = this.toEncrypt(type);
        return this.http.post(`/gcCase/saveTrainingOrLicense/${permId}/${encriptedData}?isGcI140Case=false&isGcPermCase=true`, payload);
    }
    savePermLicenseDetails(permId, payload, type) {
        const encriptedData = this.toEncrypt(type);
        return this.http.post(`/gcCase/saveTrainingOrLicense/${permId}/${encriptedData}?isGcI140Case=false&isGcPermCase=true`, payload);
    }
    deletei140TrainingDetails(superTaskId, subTaskId, trainingId) {
        return this.http.delete(`/superTask/${superTaskId}/subTask/${subTaskId}/gc/i140Case/education/training/${trainingId}/delete`).pipe(map$1((response) => {
            return response;
        }));
    }
    getTrainingsDetailsForProfile(beneficiaryId, type, familyId) {
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        return this.http.get(`/beneficiary/${beneficiaryId}/profile/professional/${type}${profileFamilyString}`).pipe(map$1((response) => response));
    }
    /** New */
    deleteLicensesInformation(superTaskId, subTaskId, licenseId) {
        return this.http.delete(`/superTask/${superTaskId}/subTask/${subTaskId}/gc/i140Case/education/license/${licenseId}/delete`).pipe(map$1((response) => {
            return response;
        }));
    }
    toEncrypt(_data) {
        var pharase = 'c63a423527b24f65';
        var data = _data;
        var key = CryptoJS.enc.Latin1.parse(pharase);
        var iv = CryptoJS.enc.Latin1.parse(pharase);
        var encrypted = CryptoJS.AES.encrypt(data, key, { iv: iv, mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.ZeroPadding
        }).toString();
        var e64 = CryptoJS.enc.Base64.parse(encrypted);
        var eHex = e64.toString(CryptoJS.enc.Hex);
        return this.encriptedData = eHex;
    }
}
EditTrainingDetailsService.ɵfac = function EditTrainingDetailsService_Factory(t) { return new (t || EditTrainingDetailsService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.ImagilityWebStorage)); };
EditTrainingDetailsService.ɵprov = i0.ɵɵdefineInjectable({ token: EditTrainingDetailsService, factory: EditTrainingDetailsService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EditTrainingDetailsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }, { type: i2.ImagilityWebStorage }]; }, null); })();

const _c0$1 = ["trainingForm"];
function EditTrainingDetailsComponent_div_2_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 71);
    i0.ɵɵtext(1, "No training details have been added yet");
    i0.ɵɵelementEnd();
} }
function EditTrainingDetailsComponent_div_2_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 72);
    i0.ɵɵlistener("click", function EditTrainingDetailsComponent_div_2_button_2_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r22); const ctx_r21 = i0.ɵɵnextContext(2); const _r1 = i0.ɵɵreference(9); const _r3 = i0.ɵɵreference(13); ctx_r21.toggleExpansion(); _r1.reset(); return ctx_r21.formCheck(_r3); });
    i0.ɵɵelementStart(1, "span", 73);
    i0.ɵɵtext(2, "Add Training");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function EditTrainingDetailsComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 68);
    i0.ɵɵtemplate(1, EditTrainingDetailsComponent_div_2_span_1_Template, 2, 0, "span", 69);
    i0.ɵɵtemplate(2, EditTrainingDetailsComponent_div_2_button_2_Template, 3, 0, "button", 70);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !(ctx_r0.dataSource == null ? null : ctx_r0.dataSource.data == null ? null : ctx_r0.dataSource.data.length));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.updateBenProfile && !ctx_r0.viewMode && ctx_r0.showEditButton);
} }
function EditTrainingDetailsComponent_ng_template_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 74);
    i0.ɵɵtext(1, "Training Details");
    i0.ɵɵelementEnd();
} }
function EditTrainingDetailsComponent_div_46_lib_save_as_draft_1_Template(rf, ctx) { if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "lib-save-as-draft", 80);
    i0.ɵɵlistener("onClickSaveAsDraft", function EditTrainingDetailsComponent_div_46_lib_save_as_draft_1_Template_lib_save_as_draft_onClickSaveAsDraft_0_listener($event) { i0.ɵɵrestoreView(_r27); const ctx_r26 = i0.ɵɵnextContext(2); return ctx_r26.saveAsDraft($event); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r23 = i0.ɵɵnextContext(2);
    const _r3 = i0.ɵɵreference(13);
    i0.ɵɵproperty("disabled", ctx_r23.isSaveAsDraftDisabled)("formToBeSaved", _r3["form"]);
} }
function EditTrainingDetailsComponent_div_46_button_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 60);
    i0.ɵɵelementStart(1, "span", 81);
    i0.ɵɵtext(2, "Next ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function EditTrainingDetailsComponent_div_46_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 82);
    i0.ɵɵelementStart(1, "i", 83);
    i0.ɵɵtext(2, "To proceed to the next tabs, please save the data in the current tab first.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function EditTrainingDetailsComponent_div_46_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵtemplate(1, EditTrainingDetailsComponent_div_46_lib_save_as_draft_1_Template, 1, 2, "lib-save-as-draft", 75);
    i0.ɵɵelementStart(2, "button", 76);
    i0.ɵɵelementStart(3, "span", 77);
    i0.ɵɵtext(4, "Save");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, EditTrainingDetailsComponent_div_46_button_5_Template, 3, 0, "button", 78);
    i0.ɵɵtemplate(6, EditTrainingDetailsComponent_div_46_div_6_Template, 3, 0, "div", 79);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r10.beneficiaryType === "self");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r10.hasID);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r10.hasID);
} }
function EditTrainingDetailsComponent_ng_template_48_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 84);
    i0.ɵɵtext(1, "Topics Covered");
    i0.ɵɵelementEnd();
} }
function EditTrainingDetailsComponent_mat_chip_64_mat_icon_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon", 88);
    i0.ɵɵtext(1, "cancel");
    i0.ɵɵelementEnd();
} }
function EditTrainingDetailsComponent_mat_chip_64_Template(rf, ctx) { if (rf & 1) {
    const _r32 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-chip", 85);
    i0.ɵɵlistener("removed", function EditTrainingDetailsComponent_mat_chip_64_Template_mat_chip_removed_0_listener() { i0.ɵɵrestoreView(_r32); const subject_r28 = ctx.$implicit; const ctx_r31 = i0.ɵɵnextContext(); return ctx_r31.remove(subject_r28); });
    i0.ɵɵelementStart(1, "span", 86);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, EditTrainingDetailsComponent_mat_chip_64_mat_icon_3_Template, 2, 0, "mat-icon", 87);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const subject_r28 = ctx.$implicit;
    const i_r29 = ctx.index;
    const ctx_r13 = i0.ɵɵnextContext();
    i0.ɵɵproperty("selectable", ctx_r13.selectable)("removable", ctx_r13.removable);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "inputValueSubjectNameTrn", i_r29, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(subject_r28);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r13.removable);
} }
function EditTrainingDetailsComponent_ng_container_74_th_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 92);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r37 = i0.ɵɵnextContext();
    const indx_r34 = ctx_r37.index;
    const column_r33 = ctx_r37.$implicit;
    i0.ɵɵpropertyInterpolate1("id", "colHeader3Lbl", indx_r34, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", column_r33.header, " ");
} }
function EditTrainingDetailsComponent_ng_container_74_td_2_span_1_Template(rf, ctx) { if (rf & 1) {
    const _r44 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 96);
    i0.ɵɵelementStart(1, "mat-icon", 97);
    i0.ɵɵlistener("click", function EditTrainingDetailsComponent_ng_container_74_td_2_span_1_Template_mat_icon_click_1_listener() { i0.ɵɵrestoreView(_r44); const ix_r39 = i0.ɵɵnextContext().index; const ctx_r42 = i0.ɵɵnextContext(2); return ctx_r42.deleteSubject(ix_r39); });
    i0.ɵɵtext(2, "delete_forever ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function EditTrainingDetailsComponent_ng_container_74_td_2_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 86);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r46 = i0.ɵɵnextContext();
    const ix_r39 = ctx_r46.index;
    const row_r38 = ctx_r46.$implicit;
    const ctx_r45 = i0.ɵɵnextContext();
    const indx_r34 = ctx_r45.index;
    const column_r33 = ctx_r45.$implicit;
    i0.ɵɵpropertyInterpolate2("id", "colTextLbl3", indx_r34, "_", ix_r39, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", row_r38[column_r33.columnDef], " ");
} }
function EditTrainingDetailsComponent_ng_container_74_td_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 93);
    i0.ɵɵtemplate(1, EditTrainingDetailsComponent_ng_container_74_td_2_span_1_Template, 3, 0, "span", 94);
    i0.ɵɵtemplate(2, EditTrainingDetailsComponent_ng_container_74_td_2_span_2_Template, 2, 3, "span", 95);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r33 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", column_r33.columnType == "icon");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", column_r33.columnType == "text");
} }
function EditTrainingDetailsComponent_ng_container_74_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 89);
    i0.ɵɵtemplate(1, EditTrainingDetailsComponent_ng_container_74_th_1_Template, 2, 2, "th", 90);
    i0.ɵɵtemplate(2, EditTrainingDetailsComponent_ng_container_74_td_2_Template, 3, 2, "td", 91);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const column_r33 = ctx.$implicit;
    i0.ɵɵproperty("matColumnDef", column_r33.columnDef);
} }
function EditTrainingDetailsComponent_tr_75_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 98);
} }
function EditTrainingDetailsComponent_tr_76_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 99);
} }
function EditTrainingDetailsComponent_ng_template_89_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 100);
    i0.ɵɵtext(1, "Upload Documents");
    i0.ɵɵelementEnd();
} }
function EditTrainingDetailsComponent_div_102_div_1_ng_container_2_th_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 111);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r59 = i0.ɵɵnextContext();
    const indx_r56 = ctx_r59.index;
    const column_r55 = ctx_r59.$implicit;
    i0.ɵɵpropertyInterpolate1("id", "colHeader5Lbl", indx_r56, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", column_r55.header, " ");
} }
function EditTrainingDetailsComponent_div_102_div_1_ng_container_2_td_2_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 113);
    i0.ɵɵelementStart(1, "a");
    i0.ɵɵelementStart(2, "mat-icon");
    i0.ɵɵtext(3, "expand_more");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function EditTrainingDetailsComponent_div_102_div_1_ng_container_2_td_2_div_2_span_1_mat_icon_2_Template(rf, ctx) { if (rf & 1) {
    const _r70 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-icon", 117);
    i0.ɵɵlistener("click", function EditTrainingDetailsComponent_div_102_div_1_ng_container_2_td_2_div_2_span_1_mat_icon_2_Template_mat_icon_click_0_listener() { i0.ɵɵrestoreView(_r70); const row_r60 = i0.ɵɵnextContext(3).$implicit; const ctx_r68 = i0.ɵɵnextContext(4); const _r3 = i0.ɵɵreference(13); ctx_r68.handleEdit(row_r60); return ctx_r68.formCheck(_r3); });
    i0.ɵɵtext(1, "edit ");
    i0.ɵɵelementEnd();
} }
function EditTrainingDetailsComponent_div_102_div_1_ng_container_2_td_2_div_2_span_1_mat_icon_3_Template(rf, ctx) { if (rf & 1) {
    const _r73 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-icon", 118);
    i0.ɵɵlistener("click", function EditTrainingDetailsComponent_div_102_div_1_ng_container_2_td_2_div_2_span_1_mat_icon_3_Template_mat_icon_click_0_listener() { i0.ɵɵrestoreView(_r73); const row_r60 = i0.ɵɵnextContext(3).$implicit; const ctx_r71 = i0.ɵɵnextContext(4); const _r3 = i0.ɵɵreference(13); return ctx_r71.handleDelete(row_r60, _r3); });
    i0.ɵɵtext(1, "delete_forever ");
    i0.ɵɵelementEnd();
} }
function EditTrainingDetailsComponent_div_102_div_1_ng_container_2_td_2_div_2_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 20);
    i0.ɵɵelementContainerStart(1);
    i0.ɵɵtemplate(2, EditTrainingDetailsComponent_div_102_div_1_ng_container_2_td_2_div_2_span_1_mat_icon_2_Template, 2, 0, "mat-icon", 115);
    i0.ɵɵtemplate(3, EditTrainingDetailsComponent_div_102_div_1_ng_container_2_td_2_div_2_span_1_mat_icon_3_Template, 2, 0, "mat-icon", 116);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r65 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r65.viewMode);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r65.viewMode);
} }
function EditTrainingDetailsComponent_div_102_div_1_ng_container_2_td_2_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, EditTrainingDetailsComponent_div_102_div_1_ng_container_2_td_2_div_2_span_1_Template, 4, 2, "span", 114);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r55 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", column_r55.columnDef == "action");
} }
function EditTrainingDetailsComponent_div_102_div_1_ng_container_2_td_2_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 86);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r76 = i0.ɵɵnextContext();
    const i_r61 = ctx_r76.renderIndex;
    const row_r60 = ctx_r76.$implicit;
    const ctx_r75 = i0.ɵɵnextContext();
    const indx_r56 = ctx_r75.index;
    const column_r55 = ctx_r75.$implicit;
    i0.ɵɵpropertyInterpolate2("id", "colText5Lbl_", indx_r56, "__", i_r61, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", row_r60[column_r55.columnDef], " ");
} }
function EditTrainingDetailsComponent_div_102_div_1_ng_container_2_td_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 93);
    i0.ɵɵtemplate(1, EditTrainingDetailsComponent_div_102_div_1_ng_container_2_td_2_span_1_Template, 4, 0, "span", 112);
    i0.ɵɵtemplate(2, EditTrainingDetailsComponent_div_102_div_1_ng_container_2_td_2_div_2_Template, 2, 1, "div", 102);
    i0.ɵɵtemplate(3, EditTrainingDetailsComponent_div_102_div_1_ng_container_2_td_2_span_3_Template, 2, 3, "span", 95);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r55 = i0.ɵɵnextContext().$implicit;
    const ctx_r58 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", column_r55.columnDef == "toggle");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r58.updateBenProfile && ctx_r58.showEditButton);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", column_r55.columnType == "text");
} }
function EditTrainingDetailsComponent_div_102_div_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 89);
    i0.ɵɵtemplate(1, EditTrainingDetailsComponent_div_102_div_1_ng_container_2_th_1_Template, 2, 2, "th", 110);
    i0.ɵɵtemplate(2, EditTrainingDetailsComponent_div_102_div_1_ng_container_2_td_2_Template, 4, 3, "td", 91);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const column_r55 = ctx.$implicit;
    i0.ɵɵproperty("matColumnDef", column_r55.columnDef);
} }
function EditTrainingDetailsComponent_div_102_div_1_td_7_div_2_tr_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 125);
    i0.ɵɵelementStart(1, "td", 126);
    i0.ɵɵelementStart(2, "div", 127);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td", 128);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const sub_r84 = ctx.$implicit;
    const ix_r85 = ctx.index;
    const i_r79 = i0.ɵɵnextContext(2).renderIndex;
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate2("id", "topicNoForOuterSectionTrn", i_r79, "_", ix_r85, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ix_r85 + 1, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate2("id", "topicNameForOuterSectionTrn", i_r79, "_", ix_r85, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", sub_r84, " ");
} }
function EditTrainingDetailsComponent_div_102_div_1_td_7_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 122);
    i0.ɵɵelementStart(1, "h6", 86);
    i0.ɵɵtext(2, "List of Topics ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerStart(3);
    i0.ɵɵelementStart(4, "table", 123);
    i0.ɵɵtemplate(5, EditTrainingDetailsComponent_div_102_div_1_td_7_div_2_tr_5_Template, 6, 6, "tr", 124);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r87 = i0.ɵɵnextContext();
    const i_r79 = ctx_r87.renderIndex;
    const element_r78 = ctx_r87.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "headListOfTopics4", i_r79, "");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", element_r78.subjects);
} }
function EditTrainingDetailsComponent_div_102_div_1_td_7_div_3_ng_container_15_tr_1_Template(rf, ctx) { if (rf & 1) {
    const _r94 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td", 126);
    i0.ɵɵelementStart(2, "div", 134);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td");
    i0.ɵɵelementStart(5, "strong", 83);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td", 128);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "td", 135);
    i0.ɵɵelementStart(10, "button", 136);
    i0.ɵɵlistener("click", function EditTrainingDetailsComponent_div_102_div_1_td_7_div_3_ng_container_15_tr_1_Template_button_click_10_listener() { i0.ɵɵrestoreView(_r94); const item_r89 = i0.ɵɵnextContext().$implicit; const ctx_r92 = i0.ɵɵnextContext(5); return ctx_r92.downloadDoc(item_r89); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r95 = i0.ɵɵnextContext();
    const i_r90 = ctx_r95.index;
    const item_r89 = ctx_r95.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i_r90 + 1, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(item_r89.fileName);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "tableValueTrnDocCategoryOuter", i_r90, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", (item_r89 == null ? null : item_r89.fileCategory == null ? null : item_r89.fileCategory.code) === "OTHER" ? item_r89 == null ? null : item_r89.fileCategoryOtherName : item_r89 == null ? null : item_r89.fileCategory == null ? null : item_r89.fileCategory.name, " ");
} }
function EditTrainingDetailsComponent_div_102_div_1_td_7_div_3_ng_container_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EditTrainingDetailsComponent_div_102_div_1_td_7_div_3_ng_container_15_tr_1_Template, 11, 4, "tr", 102);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r89 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r89 == null ? null : item_r89.fileName);
} }
function EditTrainingDetailsComponent_div_102_div_1_td_7_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 122);
    i0.ɵɵelementStart(1, "h6", 129);
    i0.ɵɵtext(2, " List of Documents");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerStart(3);
    i0.ɵɵelementStart(4, "table", 130);
    i0.ɵɵelementStart(5, "thead");
    i0.ɵɵelementStart(6, "tr");
    i0.ɵɵelement(7, "th", 126);
    i0.ɵɵelementStart(8, "th", 86);
    i0.ɵɵtext(9, "Document");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "th", 131);
    i0.ɵɵtext(11, "Document Type");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "th");
    i0.ɵɵelement(13, "i", 132);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "tbody");
    i0.ɵɵtemplate(15, EditTrainingDetailsComponent_div_102_div_1_td_7_div_3_ng_container_15_Template, 2, 1, "ng-container", 133);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r96 = i0.ɵɵnextContext();
    const i_r79 = ctx_r96.renderIndex;
    const element_r78 = ctx_r96.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "headListOfDocs3", i_r79, "");
    i0.ɵɵadvance(7);
    i0.ɵɵpropertyInterpolate1("id", "tableHeadDocOuter3", i_r79, "");
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("ngForOf", element_r78.documents);
} }
function EditTrainingDetailsComponent_div_102_div_1_td_7_div_4_tr_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 125);
    i0.ɵɵelementStart(1, "td", 126);
    i0.ɵɵelementStart(2, "div", 127);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td", 128);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const sub_r98 = ctx.$implicit;
    const i_r99 = ctx.index;
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("id", "topicNoForOuterSectionTrn", i_r99, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", i_r99 + 1, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "topicNameForOuterSectionTrn", i_r99, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", sub_r98, " ");
} }
function EditTrainingDetailsComponent_div_102_div_1_td_7_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 122);
    i0.ɵɵelementStart(1, "h6", 137);
    i0.ɵɵtext(2, "List of Topics");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerStart(3);
    i0.ɵɵelementStart(4, "table", 138);
    i0.ɵɵtemplate(5, EditTrainingDetailsComponent_div_102_div_1_td_7_div_4_tr_5_Template, 6, 4, "tr", 124);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const element_r78 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngForOf", element_r78.subjects);
} }
function EditTrainingDetailsComponent_div_102_div_1_td_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 119);
    i0.ɵɵelementStart(1, "div", 120);
    i0.ɵɵtemplate(2, EditTrainingDetailsComponent_div_102_div_1_td_7_div_2_Template, 6, 2, "div", 121);
    i0.ɵɵtemplate(3, EditTrainingDetailsComponent_div_102_div_1_td_7_div_3_Template, 16, 3, "div", 121);
    i0.ɵɵtemplate(4, EditTrainingDetailsComponent_div_102_div_1_td_7_div_4_Template, 6, 1, "div", 121);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const element_r78 = ctx.$implicit;
    const ctx_r51 = i0.ɵɵnextContext(3);
    i0.ɵɵattribute("colspan", ctx_r51.columns.length);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("@detailExpand", element_r78 == ctx_r51.expandedElement ? "expanded" : "collapsed");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (element_r78 == null ? null : element_r78.subjects == null ? null : element_r78.subjects.length) > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (element_r78 == null ? null : element_r78.documents == null ? null : element_r78.documents.length) > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (element_r78 == null ? null : element_r78.subjects == null ? null : element_r78.subjects.length) > 0);
} }
function EditTrainingDetailsComponent_div_102_div_1_tr_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 98);
} }
function EditTrainingDetailsComponent_div_102_div_1_tr_9_Template(rf, ctx) { if (rf & 1) {
    const _r103 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 139);
    i0.ɵɵlistener("click", function EditTrainingDetailsComponent_div_102_div_1_tr_9_Template_tr_click_0_listener() { i0.ɵɵrestoreView(_r103); const element_r101 = ctx.$implicit; const ctx_r102 = i0.ɵɵnextContext(3); return ctx_r102.expandedElement = ctx_r102.expandedElement === element_r101 ? null : element_r101; });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const element_r101 = ctx.$implicit;
    const ctx_r53 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("example-expanded-row", ctx_r53.expandedElement === element_r101);
} }
function EditTrainingDetailsComponent_div_102_div_1_tr_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 140);
} }
const _c1$1 = function () { return ["expandedDetail"]; };
function EditTrainingDetailsComponent_div_102_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "table", 103);
    i0.ɵɵtemplate(2, EditTrainingDetailsComponent_div_102_div_1_ng_container_2_Template, 3, 1, "ng-container", 52);
    i0.ɵɵelementStart(3, "div", 104);
    i0.ɵɵelementContainerStart(4, 105);
    i0.ɵɵelementStart(5, "label", 106);
    i0.ɵɵtext(6, " List of Topics ");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, EditTrainingDetailsComponent_div_102_div_1_td_7_Template, 5, 5, "td", 107);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, EditTrainingDetailsComponent_div_102_div_1_tr_8_Template, 1, 0, "tr", 53);
    i0.ɵɵtemplate(9, EditTrainingDetailsComponent_div_102_div_1_tr_9_Template, 1, 2, "tr", 108);
    i0.ɵɵtemplate(10, EditTrainingDetailsComponent_div_102_div_1_tr_10_Template, 1, 0, "tr", 109);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r49 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("dataSource", ctx_r49.dataSource);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r49.columns);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("matHeaderRowDef", ctx_r49.displayedColumns);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matRowDefColumns", ctx_r49.displayedColumns);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matRowDefColumns", i0.ɵɵpureFunction0(5, _c1$1));
} }
function EditTrainingDetailsComponent_div_102_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 101);
    i0.ɵɵtemplate(1, EditTrainingDetailsComponent_div_102_div_1_Template, 11, 6, "div", 102);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r18.dataSource == null ? null : ctx_r18.dataSource.data == null ? null : ctx_r18.dataSource.data.length);
} }
const DeleteDialogConfigurations = {
    width: '50%',
    closeOnEscape: false,
    closable: false,
    showHeader: false,
    contentStyle: { "z-index": "1001" }
};
class EditTrainingDetailsComponent {
    constructor(referenceLibraryService, toastr, dialog, store, route, dialogService, editTrainingDetailsService) {
        this.referenceLibraryService = referenceLibraryService;
        this.toastr = toastr;
        this.dialog = dialog;
        this.store = store;
        this.route = route;
        this.dialogService = dialogService;
        this.editTrainingDetailsService = editTrainingDetailsService;
        this.isTabEmitter = new EventEmitter();
        this.isEditMode = false;
        this.showEditButton = true;
        this.currentItemDisplay = [];
        this.expandPanel = false;
        this.updateBenProfile = true;
        this.selectedIndex = 0;
        this.listAddedSubjects = [];
        this.displayedColumns = [];
        this.subDisplayedColumns = [];
        this.training = new Tranings({});
        this.visible = true;
        this.selectable = true;
        this.removable = true;
        this.hasID = false;
        this.isLinear = true;
        this.today = new Date();
        this.isUsedForBeneEdit = false;
        this.separatorKeysCodes = [ENTER, COMMA];
        this.configurations = {
            inputMultipleFlag: true,
            fileType: acceptedFileTypes,
            isFileListRequired: true,
            categoryName: 'BENTRGDOC',
            entityId: 0,
            fileCategory: 'TCERT',
            listUploadedFiles: [],
            documentTypeRequired: true,
            docummentTypeCode: 'BENTRGDOC',
            useCase: 'beneficiary',
            useCaseId: 0,
            familyId: null
        };
        this.columns = [
            { columnDef: 'toggle', header: '', columnType: 'icon', customClass: '' },
            { columnDef: 'name', header: 'Name', columnType: 'text', customClass: '' },
            { columnDef: 'institution', header: 'Institution', columnType: 'text', customClass: '' },
            { columnDef: 'startDate', header: 'Start Date', columnType: 'text', customClass: '' },
            { columnDef: 'endDate', header: 'End Date', columnType: 'text', customClass: '' },
            { columnDef: 'action', header: 'Action', columnType: 'icon', customClass: '' }
        ];
        this.subjectsColumns = [
            { columnDef: 'subject', header: 'Added Topics', columnType: 'text', customClass: '' },
            { columnDef: 'action', header: 'Action', columnType: 'icon', customClass: '' }
        ];
        this.isListView = false;
        this.isTimeLineView = true;
        this.trainingsData = [];
        this.viewMode = false;
        this.destroy$ = new Subject();
        this.formChangesSubscriptions = [];
        this.observableSubscription$ = new Subject();
        this.isSaveAsDraftDisabled = true;
    }
    ngOnInit() {
        var _a, _b, _c;
        this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
        this.viewMode = sessionStorage.getItem('bene-profile-viewMode') == 'true' ? true : false;
        this.onlyFormBuilder = this.route.snapshot.queryParams.pageFrom;
        if (this.onlyFormBuilder === 'FB') {
            this.beneficiaryId = (sessionStorage.getItem('FbEmployeeId')) ? parseInt(sessionStorage.getItem('FbEmployeeId')) : 0;
        }
        else {
            this.beneficiaryId = (sessionStorage.getItem('listBeneficiaryId')) ? parseInt(sessionStorage.getItem('listBeneficiaryId')) : this.editTrainingDetailsService.currentUserValue['beneficiaryId'];
        }
        this.editTrainingDetailsService.currentUser.pipe(takeUntil(this.observableSubscription$)).subscribe((data) => {
            if (sessionStorage.getItem('userTypeRole') === Roles.ATTORNEY || sessionStorage.getItem('userTypeRole') === Roles.PETITIONER) {
                this.updateBenProfile = this.editTrainingDetailsService.checkBeneEditPermission();
                this.viewMode = !this.updateBenProfile;
            }
        });
        if (this.isProfile) {
            this.getTrainingDetailsForProfile();
        }
        else if (((_a = this.editTrainingData) === null || _a === void 0 ? void 0 : _a.caseType) == 'I140' || ((_c = (_b = this.editTrainingData) === null || _b === void 0 ? void 0 : _b.caseType) === null || _c === void 0 ? void 0 : _c.toLowerCase()) == 'perm') {
            this.getTrainingsForI140OrPerm();
        }
        else {
            this.getTrainings();
        }
        this.showEditButton = !this.editTrainingDetailsService.checkValidity();
        this.editTrainingDetailsService.onLifeStorySubTabs.next();
        this.envPath = environment.docs;
        //IM-3066 - remove deleted file.
        this.editTrainingDetailsService.deletedfile$.pipe(takeUntil(this.observableSubscription$)).subscribe(status => {
            var _a, _b, _c;
            if (status === true) {
                if (this.isProfile) {
                    this.getTrainingDetailsForProfile();
                }
                else if (((_a = this.editTrainingData) === null || _a === void 0 ? void 0 : _a.caseType) == 'I140' || ((_c = (_b = this.editTrainingData) === null || _b === void 0 ? void 0 : _b.caseType) === null || _c === void 0 ? void 0 : _c.toLowerCase()) == 'perm') {
                    this.getTrainingsForI140OrPerm();
                }
                else {
                    this.getTrainings();
                }
            }
        });
        this.editTrainingDetailsService.uploaded$.pipe(takeUntil(this.observableSubscription$)).subscribe(status => {
            var _a, _b, _c;
            if (status === true) {
                if (this.isProfile) {
                    this.getTrainingDetailsForProfile();
                }
                else if (((_a = this.editTrainingData) === null || _a === void 0 ? void 0 : _a.caseType) == 'I140' || ((_c = (_b = this.editTrainingData) === null || _b === void 0 ? void 0 : _b.caseType) === null || _c === void 0 ? void 0 : _c.toLowerCase()) == 'perm') {
                    this.getTrainingsForI140OrPerm();
                }
                else {
                    this.getTrainings();
                }
            }
        });
        if (sessionStorage.getItem('newFamilyId')) {
            this.familyId = sessionStorage.getItem('newFamilyId');
        }
    }
    ngAfterContentInit() {
        this.displayedColumns = this.columns.map(c => c.columnDef);
        this.subDisplayedColumns = this.subjectsColumns.map(c => c.columnDef);
    }
    ngOnChanges(changes) {
        var _a, _b, _c;
        if (changes.editTrainingData.currentValue) {
            this.inputData = changes.editTrainingData.currentValue;
            if (this.isProfile) {
                this.getTrainingDetailsForProfile();
            }
            else if (((_a = this.editTrainingData) === null || _a === void 0 ? void 0 : _a.caseType) == 'I140' || ((_c = (_b = this.editTrainingData) === null || _b === void 0 ? void 0 : _b.caseType) === null || _c === void 0 ? void 0 : _c.toLowerCase()) == 'perm') {
                this.getTrainingsForI140OrPerm();
            }
            else {
                this.getTrainings();
            }
        }
    }
    checkDocName(element) {
        if (!(element === null || element === void 0 ? void 0 : element.documents)) {
            return false;
        }
        else {
            return element === null || element === void 0 ? void 0 : element.documents.some(val => val.fileName);
        }
    }
    handleClose() {
        this.isEditMode = false;
        this.expandPanel = false;
        this.isTabEmitter.emit(true);
        this.translet();
    }
    translet() {
        setTimeout(() => {
            this.referenceLibraryService.transletConversion();
        }, 600);
    }
    formCheck(trainingForm) {
        var _a;
        this.trainingForm = trainingForm;
        this.formChangesSubscriptions[0] = trainingForm.statusChanges.pipe(takeUntil(this.observableSubscription$)).subscribe(() => {
            if (trainingForm.dirty) {
                this.store.dispatch(new MarkDirtyFormAction({
                    dirty: true,
                    message: "If you leave before saving, all changes made on the 'Training' form will be lost. Do you wish to continue?"
                }));
            }
            else {
                this.store.dispatch(new MarkCleanFormAction({
                    dirty: false,
                    message: ''
                }));
            }
        });
        this.formChangesSubscriptions[1] = (_a = this.trainingForm.valueChanges) === null || _a === void 0 ? void 0 : _a.pipe(takeUntil(this.observableSubscription$)).subscribe(formValues => {
            this.isSaveAsDraftDisabled = !Object.values(formValues).some((val) => !!val || val === 0);
        });
    }
    onNewTopicEnter(event) {
        this.store.dispatch(new MarkDirtyFormAction({
            dirty: true,
            message: "If you leave before saving, all changes made on the 'Topic Covered' section will be lost. Do you wish to continue?"
        }));
    }
    toggleExpansion() {
        this.isEditMode = true;
        this.expandPanel = true;
        this.isTabEmitter.emit(false);
        this.training = {
            id: 0,
            name: '',
            subjects: '',
            institution: '',
            startDate: '',
            endDate: ''
        };
        this.listSubjects = new MatTableDataSource();
        this.configurations.listUploadedFiles = [];
        this.configurations.useCaseId = 0;
        this.configurations.entityId = 0;
        this.configurations.familyId = this.familyId;
        this.configurations = Object.assign({}, this.configurations);
        this.hasID = false;
        this.isLinear = true;
        //this.trainingForm.resetForm();
        //this.trainingForm.form.reset();
    }
    getTrainings() {
        this.editTrainingDetailsService.getTrainingsDetails(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, 'TRAINING', this.inputData.superTaskId, this.inputData.subTaskId, this.isUsedForBeneEdit).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            var _a;
            if (!response.data) {
                response.data = [];
            }
            response.data.map((item) => {
                if (item.subjects) {
                    item.subjects = item.subjects.split(',');
                }
            });
            response.data.map((item) => {
                item.startDate = item.startDate ? moment__default(item.startDate).format('DD-MMM-YYYY') : '';
                item.endDate = item.endDate ? moment__default(item.endDate).format('DD-MMM-YYYY') : '';
            });
            this.trainingsData = response.data;
            this.dataSource = new MatTableDataSource(this.trainingsData);
            this.editTrainingDetailsService.getTrainingsDetails((_a = this.inputData.visaType) !== null && _a !== void 0 ? _a : this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, 'TRAINING', this.inputData.superTaskId, this.inputData.subTaskId, this.isUsedForBeneEdit).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
                if (!response.data) {
                    response.data = [];
                }
                if (response === null || response === void 0 ? void 0 : response.data) {
                    response.data.map((item) => {
                        if (item.subjects) {
                            item.subjects = item.subjects.split(',');
                        }
                    });
                    response.data.map((item) => {
                        item.startDate = item.startDate ? moment__default(item.startDate).format('DD-MMM-YYYY') : '';
                        item.endDate = item.endDate ? moment__default(item.endDate).format('DD-MMM-YYYY') : '';
                    });
                    this.trainingsData = response.data;
                    this.dataSource = new MatTableDataSource(this.trainingsData);
                    this.translet();
                }
            });
        });
    }
    getTrainingDetailsForProfile() {
        if (sessionStorage.getItem('newFamilyId')) {
            this.familyId = sessionStorage.getItem('newFamilyId');
        }
        let getTrainingApi = this.editTrainingDetailsService.getTrainingsDetailsForProfile(this.beneficiaryId, 'TRAINING', this.familyId).pipe(takeUntil(this.observableSubscription$));
        getTrainingApi.pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            var _a, _b;
            if (response === null || response === void 0 ? void 0 : response.data) {
                if ((_a = response.data) === null || _a === void 0 ? void 0 : _a.profEducation) {
                    response.data = (_b = response.data) === null || _b === void 0 ? void 0 : _b.profEducation;
                }
                this.trainingsData = response.data.map((item) => {
                    let _item = Object.assign({}, item);
                    _item.subjects = item.subjects.split(',');
                    // _item.documents = item.documents?.filter(e => !!e.fileLocation);
                    _item.startDate = item.startDate ? moment__default(item.startDate, 'YYYY-MMM-DD').format('DD-MMM-YYYY') : '';
                    _item.endDate = item.endDate ? moment__default(item.endDate, 'YYYY-MMM-DD').format('DD-MMM-YYYY') : '';
                    return _item;
                });
                this.dataSource = new MatTableDataSource(this.trainingsData);
                this.translet();
            }
        });
    }
    getTrainingsForI140OrPerm() {
        var _a;
        let url;
        if (this.inputData.caseType == 'I140') {
            url = this.editTrainingDetailsService.getTrainingInformation(this.inputData.superTaskId, this.inputData.subTaskId, this.isUsedForBeneEdit);
        }
        else if (((_a = this.inputData.caseType) === null || _a === void 0 ? void 0 : _a.toLowerCase()) == 'perm') {
            url = this.editTrainingDetailsService.getTrainingInformationPerm(this.inputData.caseId, this.isUsedForBeneEdit);
        }
        url.pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            if (!response.data) {
                response.data = [];
            }
            if (response === null || response === void 0 ? void 0 : response.data) {
                this.trainingsData = response.data.map((item) => {
                    let _item = Object.assign({}, item);
                    _item.subjects = item.subjects.split(',');
                    _item.documents = item.documents.filter(e => !!e.fileLocation);
                    _item.startDate = item.startDate ? moment__default(item.startDate, 'YYYY-MMM-DD').format('DD-MMM-YYYY') : '';
                    _item.endDate = item.endDate ? moment__default(item.endDate, 'YYYY-MMM-DD').format('DD-MMM-YYYY') : '';
                    return _item;
                });
                this.dataSource = new MatTableDataSource(this.trainingsData);
                this.translet();
            }
        });
    }
    handleEdit(input) {
        this.isEditMode = true;
        this.expandPanel = true;
        this.isTabEmitter.emit(false);
        this.training = {
            id: input.id,
            name: input.name,
            subjects: input.subjects,
            institution: input.institution,
            startDate: input.startDate ? moment__default(input.startDate).toISOString() : '',
            endDate: input.endDate ? moment__default(input.endDate).toISOString() : ''
        };
        const obj = [];
        if (input.subjects) {
            input.subjects.forEach((item) => {
                obj.push({ 'subject': item });
            });
        }
        this.hasID = true;
        this.isLinear = false;
        this.listSubjects = new MatTableDataSource(obj);
        this.training.subjects = input.subjects && input.subjects.length > 0 ? input.subjects.join() : "";
        this.configurations.entityId = input.id;
        this.configurations.familyId = this.familyId;
        this.configurations.listUploadedFiles = input.documents ? this.configurations.listUploadedFiles.concat(input.documents) : [];
        this.configurations = Object.assign({}, this.configurations);
    }
    handleDelete(input, trainingForm) {
        const deleteDialogRef = this.dialogService.open(DeleteDialogLibraryComponent, DeleteDialogConfigurations);
        deleteDialogRef.onClose.pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            var _a, _b, _c;
            if (response) {
                let url;
                if (this.isProfile) {
                    url = this.editTrainingDetailsService.deleteTrainingsDetailsForProfile(this.beneficiaryId, 'TRAINING', input.id, this.familyId).pipe(takeUntil(this.observableSubscription$));
                }
                else if (((_a = this.editTrainingData) === null || _a === void 0 ? void 0 : _a.caseType) == 'I140' || ((_c = (_b = this.editTrainingData) === null || _b === void 0 ? void 0 : _b.caseType) === null || _c === void 0 ? void 0 : _c.toLowerCase()) == 'perm') {
                    url = this.editTrainingDetailsService.deletei140TrainingDetails(this.inputData.superTaskId, this.inputData.subTaskId, input.id);
                }
                else {
                    url = this.editTrainingDetailsService.deleteTrainingsDetails(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, 'TRAINING', this.inputData.superTaskId, this.inputData.subTaskId, input.id);
                }
                url.pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
                    var _a, _b, _c;
                    if (this.training.id === input.id) {
                        this.resetForm(trainingForm);
                    }
                    this.toastr.success(response.message, 'Success');
                    if (this.isProfile) {
                        this.getTrainingDetailsForProfile();
                    }
                    else if (((_a = this.editTrainingData) === null || _a === void 0 ? void 0 : _a.caseType) == 'I140' || ((_c = (_b = this.editTrainingData) === null || _b === void 0 ? void 0 : _b.caseType) === null || _c === void 0 ? void 0 : _c.toLowerCase()) == 'perm') {
                        this.getTrainingsForI140OrPerm();
                    }
                    else {
                        this.getTrainings();
                    }
                });
            }
        });
    }
    downloadDoc(doc) {
        this.editTrainingDetailsService.downloadDocuments(environment.docs + doc.fileLocation.substring(23), doc.fileLocation.substring(23));
    }
    resetForm(trainingForm) {
        trainingForm.resetForm();
        trainingForm.form.reset();
        this.training = {
            id: 0,
            name: '',
            subjects: '',
            institution: '',
            startDate: '',
            endDate: ''
        };
        this.listSubjects = new MatTableDataSource();
        this.configurations.listUploadedFiles = [];
        this.configurations.useCaseId = 0;
        this.configurations.entityId = 0;
        this.configurations.familyId = this.familyId;
        this.configurations = Object.assign({}, this.configurations);
        this.hasID = false;
        this.isLinear = true;
    }
    closeForm(f) {
        // console.log(f);
        this.resetForm(f);
        this.toggleExpansion();
    }
    saveTrianing(trainingForm, isDraft = false) {
        var _a;
        const payload = {
            id: this.training.id || 0,
            name: this.training.name,
            subjects: this.training.subjects,
            institution: this.training.institution,
            startDate: this.training.startDate ? moment__default(this.training.startDate).format('YYYY-MM-DD') : null,
            endDate: this.training.endDate ? moment__default(this.training.endDate).format('YYYY-MM-DD') : null,
            isSaveAsDraft: isDraft
        };
        if (!this.isFormFilled(trainingForm)) {
            this.toastr.warning('Empty records cannot be saved!', 'Warning');
            return;
        }
        let url;
        if (this.isProfile) {
            url = this.editTrainingDetailsService.saveTrainingDetailsForProfile(this.beneficiaryId, 'TRAINING', payload, this.familyId);
        }
        else if (this.inputData.caseType == 'I140') {
            url = this.editTrainingDetailsService.savegcI140TrainingDetails(this.inputData.caseId, payload, 'TRAINING');
        }
        else if (((_a = this.inputData.caseType) === null || _a === void 0 ? void 0 : _a.toLowerCase()) == 'perm') {
            url = this.editTrainingDetailsService.savePermTrainingDetails(this.inputData.caseId, payload, 'TRAINING');
        }
        else {
            url = this.editTrainingDetailsService.saveTrainingDetails(this.inputData.caseId, 'TRAINING', payload);
        }
        url.pipe(takeUntil(this.observableSubscription$)).subscribe(response => {
            var _a, _b, _c, _d, _e;
            if (response.status === 200) {
                if ((_a = response.data) === null || _a === void 0 ? void 0 : _a.profEducation) {
                    response.data = (_b = response.data) === null || _b === void 0 ? void 0 : _b.profEducation;
                }
                this.training.id = response.data[0].id;
                this.toastr.success(response.message, 'Success');
                response.data.forEach(element => {
                    this.configurations.entityId = element.id;
                    if (this.isProfile) {
                        this.configurations.familyId = this.familyId;
                        this.configurations.useCaseId = this.beneficiaryId;
                    }
                    this.configurations = Object.assign({}, this.configurations);
                });
                if (this.isProfile) {
                    this.getTrainingDetailsForProfile();
                }
                else if (((_c = this.editTrainingData) === null || _c === void 0 ? void 0 : _c.caseType) == 'I140' || ((_e = (_d = this.editTrainingData) === null || _d === void 0 ? void 0 : _d.caseType) === null || _e === void 0 ? void 0 : _e.toLowerCase()) == 'perm') {
                    this.getTrainingsForI140OrPerm();
                }
                else {
                    this.getTrainings();
                }
                this.hasID = true;
                this.isLinear = false;
                trainingForm.reset(trainingForm.value);
            }
            else {
                CustomErrorToastComponent.showErrorToast(this.toastr, response.message);
            }
        });
    }
    isFormFilled(form) {
        return form && form.controls
            ? Object.entries(form.controls).some(([key, control]) => {
                const value = control.value;
                return value !== null && value !== undefined && (typeof value === 'string' ? value.trim() !== '' : !!value);
            })
            : false;
    }
    redirectToDocs() {
        this.selectedIndex = 1;
    }
    handleTabChange(tab) {
        this.selectedIndex = tab.index;
    }
    add(event) {
        const input = event.input;
        const value = event.value;
        // Add subject
        if ((value || '').trim()) {
            this.listAddedSubjects.push(value.trim());
        }
        // Reset the input value
        if (input) {
            input.value = '';
        }
    }
    pasteChips(event) {
        event.preventDefault(); //Prevents the default action
        event.clipboardData
            .getData('Text') //Gets the text pasted
            .split(/,/) //Splits it when a SEMICOLON or COMMA or NEWLINE
            .forEach(value => {
            if (value.trim()) {
                this.listAddedSubjects.push(value.trim()); //Push if valid
            }
        });
    }
    remove(fruit) {
        const index = this.listAddedSubjects.indexOf(fruit);
        if (index >= 0) {
            this.listAddedSubjects.splice(index, 1);
        }
    }
    addSubjects(isDel) {
        var _a;
        if (!this.training.id) {
            this.toastr.info('Please add the training details first, then proceed to topics');
            return;
        }
        const payload = {
            id: this.training.id || 0,
            name: this.training.name,
            subjects: this.training.subjects,
            institution: this.training.institution,
            startDate: this.training.startDate ? moment__default(this.training.startDate).format('YYYY-MM-DD') : null,
            endDate: this.training.endDate ? moment__default(this.training.endDate).format('YYYY-MM-DD') : null,
        };
        const subs = [];
        if (this.listSubjects) {
            this.listSubjects.data.forEach((item) => {
                subs.push(item.subject);
            });
        }
        payload.subjects = subs.concat(this.listAddedSubjects).join();
        let url;
        if (this.isProfile) {
            url = this.editTrainingDetailsService.saveTrainingDetailsForProfile(this.beneficiaryId, 'TRAINING', payload, this.familyId);
        }
        else if (this.inputData.caseType == 'I140') {
            url = this.editTrainingDetailsService.savegcI140TrainingDetails(this.inputData.caseId, payload, 'TRAINING');
        }
        else if (((_a = this.inputData.caseType) === null || _a === void 0 ? void 0 : _a.toLowerCase()) == 'perm') {
            url = this.editTrainingDetailsService.savePermTrainingDetails(this.inputData.caseId, payload, 'TRAINING');
        }
        else {
            url = this.editTrainingDetailsService.saveTrainingDetails(this.inputData.caseId, 'TRAINING', payload);
        }
        url.pipe(takeUntil(this.observableSubscription$)).subscribe(response => {
            var _a, _b, _c, _d, _e;
            if (response.status === 200) {
                if ((_a = response.data) === null || _a === void 0 ? void 0 : _a.profEducation) {
                    response.data = (_b = response.data) === null || _b === void 0 ? void 0 : _b.profEducation;
                }
                this.listAddedSubjects = [];
                if (isDel) {
                    this.toastr.success('Data deleted successfully!', 'Success');
                }
                else {
                    this.toastr.success(response.message, 'Success');
                }
                this.store.dispatch(new MarkCleanFormAction({
                    dirty: false,
                    message: ''
                }));
                response.data.forEach(element => {
                    this.configurations.entityId = element.id;
                    this.configurations.familyId = this.familyId;
                    this.configurations = Object.assign({}, this.configurations);
                });
                const obj = [];
                if (response.data[0]['subjects']) {
                    response.data[0]['subjects'].split(',').map((item) => {
                        obj.push({ 'subject': item });
                    });
                }
                this.listSubjects = new MatTableDataSource(obj);
                if (this.isProfile) {
                    this.getTrainingDetailsForProfile();
                }
                else if (((_c = this.editTrainingData) === null || _c === void 0 ? void 0 : _c.caseType) == 'I140' || ((_e = (_d = this.editTrainingData) === null || _d === void 0 ? void 0 : _d.caseType) === null || _e === void 0 ? void 0 : _e.toLowerCase()) == 'perm') {
                    this.getTrainingsForI140OrPerm();
                }
                else {
                    this.getTrainings();
                }
            }
            else {
                CustomErrorToastComponent.showErrorToast(this.toastr, response.message);
            }
        });
    }
    deleteSubject(index) {
        this.listSubjects.data.splice(index, 1);
        this.addSubjects(true);
    }
    fileUploadSuccess() {
        var _a, _b, _c;
        if (this.isProfile) {
            this.getTrainingDetailsForProfile();
        }
        else if (((_a = this.editTrainingData) === null || _a === void 0 ? void 0 : _a.caseType) == 'I140' || ((_c = (_b = this.editTrainingData) === null || _b === void 0 ? void 0 : _b.caseType) === null || _c === void 0 ? void 0 : _c.toLowerCase()) == 'perm') {
            this.getTrainingsForI140OrPerm();
        }
        else {
            this.getTrainings();
        }
    }
    getGlobalErrorMessages(error) {
        return errorUtils.errorMessages.get(error);
    }
    saveAsDraft(event) {
        this.saveTrianing(this.trainingForm, event);
    }
    ngOnDestroy() {
        if (this.formChangesSubscriptions) {
            this.formChangesSubscriptions.forEach(element => { element.unsubscribe(); });
        }
        this.destroy$.next();
        this.destroy$.complete();
        if (this.dependentIdSubscription) {
            this.dependentIdSubscription.unsubscribe();
        }
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
        this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
    }
}
EditTrainingDetailsComponent.ɵfac = function EditTrainingDetailsComponent_Factory(t) { return new (t || EditTrainingDetailsComponent)(i0.ɵɵdirectiveInject(i1$2.ReferenceLibraryService), i0.ɵɵdirectiveInject(i3.ToastrService), i0.ɵɵdirectiveInject(i2$1.MatDialog), i0.ɵɵdirectiveInject(i8.Store), i0.ɵɵdirectiveInject(i6.ActivatedRoute), i0.ɵɵdirectiveInject(i9.DialogService), i0.ɵɵdirectiveInject(EditTrainingDetailsService)); };
EditTrainingDetailsComponent.ɵcmp = i0.ɵɵdefineComponent({ type: EditTrainingDetailsComponent, selectors: [["edit-training-details"]], viewQuery: function EditTrainingDetailsComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$1, 3);
        i0.ɵɵviewQuery(MatPaginator, 3);
        i0.ɵɵviewQuery(MatSort, 3);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.trainingForm = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.paginator = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sort = _t.first);
    } }, inputs: { editTrainingData: "editTrainingData", isWizard: "isWizard", isProfile: "isProfile", isUsedForBeneEdit: "isUsedForBeneEdit" }, outputs: { isTabEmitter: "isTabEmitter" }, features: [i0.ɵɵNgOnChangesFeature], decls: 103, vars: 29, consts: [[1, "trainingContainer", "custom-stepper"], ["class", "row mt-2 d-flex justify-content-end", 4, "ngIf"], ["hideToggle", "", 3, "expanded", "ngClass"], [1, "close-edit"], [1, "close-icon", "pi", "pi-times", 3, "click"], ["labelPosition", "bottom", 1, "pb-mat-stepper-custom-horizontal", 3, "linear"], ["stepper", ""], [3, "completed"], ["matStepLabel", ""], [3, "ngSubmit"], ["trainingForm", "ngForm"], [1, "formBox"], [1, "form-group", "col-md-12", "mt-2"], ["id", "trnNameLabel", 1, "label-cls", "common-bene-class-for-translation"], ["type", "text", "name", "name", "placeholder", "Enter", 1, "im-input", 3, "ngModel", "ngModelChange"], ["name", "ngModel"], [1, "form-group", "col-md-12"], ["id", "trnInstLabel", 1, "label-cls", "common-bene-class-for-translation"], ["type", "text", "name", "institution", "placeholder", "Enter", 1, "im-input", 3, "ngModel", "ngModelChange"], ["institution", "ngModel"], [1, "row"], [1, "form-group", "col-md-6"], ["id", "trnStartDatelabel", 1, "label-cls", "common-bene-class-for-translation"], ["appearance", "outline", 1, "mt-0", "date-field"], ["name", "startDt", "matInput", "", 3, "ngModel", "max", "matDatepicker", "ngModelChange", "click"], ["startDt", "ngModel"], ["matSuffix", "", 3, "for"], ["startDate", ""], ["id", "trnEndDatelabel", 1, "label-cls", "common-bene-class-for-translation"], ["name", "endDt", "matInput", "", 3, "ngModel", "min", "matDatepicker", "ngModelChange", "click"], ["endDt", "ngModel"], ["endDate", ""], [1, "row", "paddingTop10", "dasheedTopBorder"], ["class", "form-group col-md-6", 4, "ngIf"], [1, "row", "formBox"], ["id", "topicsInstruction3", 1, "row", "common-bene-class-for-translation"], ["id", "topicsInstruction4", 1, "common-bene-class-for-translation", "ml-3"], [1, "col-md-12", "margin-adjust"], [1, "row", "paddingTop10"], ["id", "smallHeadTopic1", 1, "col-md-12", "required", "common-bene-class-for-translation"], [1, "col-md-12"], ["appearance", "outline", 1, "example-chip-list", "chips-contianer"], ["aria-label", "Fruit selection"], ["chipList", ""], [3, "selectable", "removable", "removed", 4, "ngFor", "ngForOf"], ["placeholder", "New subject...", "name", "topic", 3, "matChipInputFor", "matChipInputSeparatorKeyCodes", "ngModel", "paste", "ngModelChange", "input", "matChipInputTokenEnd"], ["id", "hintCourseName2", 1, "hint-text", "common-bene-class-for-translation"], [1, "col-md-2", "mt-3"], ["type", "button", 1, "btn", "btn-success", 3, "disabled", "click"], ["id", "addSubjectsTrn", 1, "common-bene-class-for-translation"], [1, "spacing", "im-card-no-border-table", "px-3", "mt-4"], ["mat-table", "", "matSort", "", 1, "im-card-no-border-table", 3, "dataSource"], [3, "matColumnDef", 4, "ngFor", "ngForOf"], ["mat-header-row", "", 4, "matHeaderRowDef"], ["mat-row", "", 4, "matRowDef", "matRowDefColumns"], [2, "width", "100%"], [1, "row", "margin-adjust"], [1, "col-md-6"], ["type", "button", "matStepperPrevious", "", 1, "back-button"], ["id", "back5", 1, "common-bene-class-for-translation"], ["type", "button", "matStepperNext", "", 1, "btn", "btn-primary", "ml-3"], ["id", "next6", 1, "common-bene-class-for-translation"], [1, "col-md-12", "mt-2"], [1, "w-100", 3, "isWizard", "configurations", "primaryData", "fileUploadSuccess"], ["id", "back6", 1, "common-bene-class-for-translation"], ["type", "button", 1, "btn", "btn-primary", "ml-3", 3, "click"], ["id", "addNextTrn", 1, "common-bene-class-for-translation"], ["class", "spacing im-card-no-border-table list-view-table", 4, "ngIf"], [1, "row", "mt-2", "d-flex", "justify-content-end"], ["class", "text-danger mt-2 mr-3 common-bene-class-for-translation", 4, "ngIf"], ["class", "btn btn-primary mb-2", "type", "button", 3, "click", 4, "ngIf"], [1, "text-danger", "mt-2", "mr-3", "common-bene-class-for-translation"], ["type", "button", 1, "btn", "btn-primary", "mb-2", 3, "click"], ["id", "add-trn", 1, "common-bene-class-for-translation"], ["id", "sectionHeadTrn", 1, "common-bene-class-for-translation"], ["confirmModelKey", "savedrafttraining", "class", "mr-3", 3, "disabled", "formToBeSaved", "onClickSaveAsDraft", 4, "ngIf"], ["type", "submit", 1, "btn", "btn-success"], ["id", "saveForm3", 1, "common-bene-class-for-translation"], ["type", "button", "class", "btn btn-primary ml-3", "matStepperNext", "", 4, "ngIf"], ["class", "mt-2", 4, "ngIf"], ["confirmModelKey", "savedrafttraining", 1, "mr-3", 3, "disabled", "formToBeSaved", "onClickSaveAsDraft"], ["id", "next5", 1, "common-bene-class-for-translation"], [1, "mt-2"], [1, "common-bene-class-for-translation"], ["id", "sectionHeadTopic3", 1, "common-bene-class-for-translation"], [3, "selectable", "removable", "removed"], [1, "common-bene-class-for-translation", 3, "id"], ["matChipRemove", "", 4, "ngIf"], ["matChipRemove", ""], [3, "matColumnDef"], ["class", "common-bene-class-for-translation", "mat-header-cell", "", "mat-sort-header", "", 3, "id", 4, "matHeaderCellDef"], ["mat-cell", "", 4, "matCellDef"], ["mat-header-cell", "", "mat-sort-header", "", 1, "common-bene-class-for-translation", 3, "id"], ["mat-cell", ""], ["class", "column.customClass", 4, "ngIf"], ["class", "common-bene-class-for-translation", 3, "id", 4, "ngIf"], [1, "column.customClass"], [1, "mr-1", "icn", 3, "click"], ["mat-header-row", ""], ["mat-row", ""], ["id", "sectionHeadDocsTrn", 1, "common-bene-class-for-translation"], [1, "spacing", "im-card-no-border-table", "list-view-table"], [4, "ngIf"], ["multiTemplateDataRows", "", "mat-table", "", 1, "im-card-no-border-table", 3, "dataSource"], [1, "example-element-description"], ["matColumnDef", "expandedDetail"], ["id", "headListOfTopics3", 1, "common-bene-class-for-translation"], ["class", "w40", "mat-cell", "", 4, "matCellDef"], ["mat-row", "", "class", "example-element-row", 3, "example-expanded-row", "click", 4, "matRowDef", "matRowDefColumns"], ["mat-row", "", "class", "example-detail-row", 4, "matRowDef", "matRowDefColumns"], ["class", "common-bene-class-for-translation", "mat-header-cell", "", 3, "id", 4, "matHeaderCellDef"], ["mat-header-cell", "", 1, "common-bene-class-for-translation", 3, "id"], ["class", "row", "class", "toggle-col", 4, "ngIf"], [1, "toggle-col"], ["class", "row", 4, "ngIf"], ["class", "mr-1 icn", "title", "edit", "class", "im-table-verticle-icon", 3, "click", 4, "ngIf"], ["class", "mr-1 icn", "title", "delete", 3, "click", 4, "ngIf"], ["title", "edit", 1, "im-table-verticle-icon", 3, "click"], ["title", "delete", 1, "mr-1", "icn", 3, "click"], ["mat-cell", "", 1, "w40"], [1, "example-element-detail"], ["class", "w100 example-element-description py-1", 4, "ngIf"], [1, "w100", "example-element-description", "py-1"], [1, "table", "table-striped"], ["class", "border border-dark", 4, "ngFor", "ngForOf"], [1, "border", "border-dark"], [1, "w40"], [1, "circleIndex", "rounded-circle", "common-bene-class-for-translation", 3, "id"], ["nowrap", "", 1, "common-bene-class-for-translation", 3, "id"], [1, "header-tab", "common-bene-class-for-translation", 3, "id"], [1, "im-card-no-border-table"], ["id", "tableHeadDocTypeOuter3{{i}]}", 1, "common-bene-class-for-translation"], ["aria-hidden", "true", 1, "fa", "fa-download", "fa-lg", "icn"], [4, "ngFor", "ngForOf"], [1, "circleIndex", "rounded-circle", "common-bene-class-for-translation"], ["nowrap", ""], ["pButton", "", "type", "button", "icon", "pi pi-download", "pTooltip", "Download", 1, "p-button-text", "p-button-rounded", "p-3", 3, "click"], ["id", "headListOfTopics4", 1, "common-bene-class-for-translation", "header-tab"], [1, "table", "table-striped", "border"], ["mat-row", "", 1, "example-element-row", 3, "click"], ["mat-row", "", 1, "example-detail-row"]], template: function EditTrainingDetailsComponent_Template(rf, ctx) { if (rf & 1) {
        const _r105 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementContainerStart(1);
        i0.ɵɵtemplate(2, EditTrainingDetailsComponent_div_2_Template, 3, 2, "div", 1);
        i0.ɵɵelementStart(3, "mat-accordion");
        i0.ɵɵelementStart(4, "mat-expansion-panel", 2);
        i0.ɵɵelementStart(5, "mat-card");
        i0.ɵɵelementStart(6, "div", 3);
        i0.ɵɵelementStart(7, "i", 4);
        i0.ɵɵlistener("click", function EditTrainingDetailsComponent_Template_i_click_7_listener() { return ctx.handleClose(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "mat-horizontal-stepper", 5, 6);
        i0.ɵɵelementStart(10, "mat-step", 7);
        i0.ɵɵtemplate(11, EditTrainingDetailsComponent_ng_template_11_Template, 2, 0, "ng-template", 8);
        i0.ɵɵelementStart(12, "form", 9, 10);
        i0.ɵɵlistener("ngSubmit", function EditTrainingDetailsComponent_Template_form_ngSubmit_12_listener() { i0.ɵɵrestoreView(_r105); const _r3 = i0.ɵɵreference(13); return ctx.saveTrianing(_r3); });
        i0.ɵɵelementStart(14, "div", 11);
        i0.ɵɵelementStart(15, "div", 12);
        i0.ɵɵelementStart(16, "label", 13);
        i0.ɵɵtext(17, "Name");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(18, "input", 14, 15);
        i0.ɵɵlistener("ngModelChange", function EditTrainingDetailsComponent_Template_input_ngModelChange_18_listener($event) { return ctx.training.name = $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(20, "div", 16);
        i0.ɵɵelementStart(21, "label", 17);
        i0.ɵɵtext(22, "Institution");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(23, "input", 18, 19);
        i0.ɵɵlistener("ngModelChange", function EditTrainingDetailsComponent_Template_input_ngModelChange_23_listener($event) { return ctx.training.institution = $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(25, "div", 20);
        i0.ɵɵelementStart(26, "div", 21);
        i0.ɵɵelementStart(27, "label", 22);
        i0.ɵɵtext(28, "Start Date");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(29, "mat-form-field", 23);
        i0.ɵɵelementStart(30, "input", 24, 25);
        i0.ɵɵlistener("ngModelChange", function EditTrainingDetailsComponent_Template_input_ngModelChange_30_listener($event) { return ctx.training.startDate = $event; })("click", function EditTrainingDetailsComponent_Template_input_click_30_listener() { i0.ɵɵrestoreView(_r105); const _r7 = i0.ɵɵreference(34); return _r7.open(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelement(32, "mat-datepicker-toggle", 26);
        i0.ɵɵelement(33, "mat-datepicker", null, 27);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(35, "div", 21);
        i0.ɵɵelementStart(36, "label", 28);
        i0.ɵɵtext(37, "End Date");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(38, "mat-form-field", 23);
        i0.ɵɵelementStart(39, "input", 29, 30);
        i0.ɵɵlistener("ngModelChange", function EditTrainingDetailsComponent_Template_input_ngModelChange_39_listener($event) { return ctx.training.endDate = $event; })("click", function EditTrainingDetailsComponent_Template_input_click_39_listener() { i0.ɵɵrestoreView(_r105); const _r9 = i0.ɵɵreference(43); return _r9.open(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelement(41, "mat-datepicker-toggle", 26);
        i0.ɵɵelement(42, "mat-datepicker", null, 31);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(44, "div");
        i0.ɵɵelementStart(45, "div", 32);
        i0.ɵɵtemplate(46, EditTrainingDetailsComponent_div_46_Template, 7, 3, "div", 33);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(47, "mat-step");
        i0.ɵɵtemplate(48, EditTrainingDetailsComponent_ng_template_48_Template, 2, 0, "ng-template", 8);
        i0.ɵɵelementStart(49, "div", 34);
        i0.ɵɵelementStart(50, "div", 12);
        i0.ɵɵelementStart(51, "div", 20);
        i0.ɵɵelementStart(52, "label", 35);
        i0.ɵɵtext(53, "Add topics or subjects covered in the Training");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(54, "small", 36);
        i0.ɵɵtext(55, "Enter all relevant Topics or Subjects Covered as a part of your training using a comma to separate.");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(56, "div", 37);
        i0.ɵɵelementStart(57, "div", 38);
        i0.ɵɵelementStart(58, "label", 39);
        i0.ɵɵtext(59, "Topics Or Subjects Covered");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(60, "div", 40);
        i0.ɵɵelementStart(61, "mat-form-field", 41);
        i0.ɵɵelementStart(62, "mat-chip-list", 42, 43);
        i0.ɵɵtemplate(64, EditTrainingDetailsComponent_mat_chip_64_Template, 4, 5, "mat-chip", 44);
        i0.ɵɵelementStart(65, "input", 45);
        i0.ɵɵlistener("paste", function EditTrainingDetailsComponent_Template_input_paste_65_listener($event) { return ctx.pasteChips($event); })("ngModelChange", function EditTrainingDetailsComponent_Template_input_ngModelChange_65_listener($event) { return ctx.topic = $event; })("input", function EditTrainingDetailsComponent_Template_input_input_65_listener($event) { return ctx.onNewTopicEnter($event); })("matChipInputTokenEnd", function EditTrainingDetailsComponent_Template_input_matChipInputTokenEnd_65_listener($event) { return ctx.add($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(66, "mat-hint", 46);
        i0.ɵɵtext(67, "Please enter comma separated values");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(68, "div", 47);
        i0.ɵɵelementStart(69, "button", 48);
        i0.ɵɵlistener("click", function EditTrainingDetailsComponent_Template_button_click_69_listener() { return ctx.addSubjects(); });
        i0.ɵɵelementStart(70, "span", 49);
        i0.ɵɵtext(71, "Add");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(72, "div", 50);
        i0.ɵɵelementStart(73, "table", 51);
        i0.ɵɵtemplate(74, EditTrainingDetailsComponent_ng_container_74_Template, 3, 1, "ng-container", 52);
        i0.ɵɵtemplate(75, EditTrainingDetailsComponent_tr_75_Template, 1, 0, "tr", 53);
        i0.ɵɵtemplate(76, EditTrainingDetailsComponent_tr_76_Template, 1, 0, "tr", 54);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(77, "div", 55);
        i0.ɵɵelement(78, "hr");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(79, "div", 40);
        i0.ɵɵelementStart(80, "div", 56);
        i0.ɵɵelementStart(81, "div", 57);
        i0.ɵɵelementStart(82, "button", 58);
        i0.ɵɵelementStart(83, "span", 59);
        i0.ɵɵtext(84, "Back");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(85, "button", 60);
        i0.ɵɵelementStart(86, "span", 61);
        i0.ɵɵtext(87, "Next");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(88, "mat-step");
        i0.ɵɵtemplate(89, EditTrainingDetailsComponent_ng_template_89_Template, 2, 0, "ng-template", 8);
        i0.ɵɵelementStart(90, "div", 34);
        i0.ɵɵelementStart(91, "div", 62);
        i0.ɵɵelementStart(92, "file-upload-deafult-library", 63);
        i0.ɵɵlistener("fileUploadSuccess", function EditTrainingDetailsComponent_Template_file_upload_deafult_library_fileUploadSuccess_92_listener() { return ctx.fileUploadSuccess(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(93, "div", 40);
        i0.ɵɵelementStart(94, "div", 56);
        i0.ɵɵelementStart(95, "div", 57);
        i0.ɵɵelementStart(96, "button", 58);
        i0.ɵɵelementStart(97, "span", 64);
        i0.ɵɵtext(98, "Back");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(99, "button", 65);
        i0.ɵɵlistener("click", function EditTrainingDetailsComponent_Template_button_click_99_listener() { i0.ɵɵrestoreView(_r105); const _r3 = i0.ɵɵreference(13); const _r1 = i0.ɵɵreference(9); ctx.resetForm(_r3); return _r1.reset(); });
        i0.ɵɵelementStart(100, "span", 66);
        i0.ɵɵtext(101, "Add Next Training");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementContainerEnd();
        i0.ɵɵtemplate(102, EditTrainingDetailsComponent_div_102_Template, 2, 1, "div", 67);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r7 = i0.ɵɵreference(34);
        const _r9 = i0.ɵɵreference(43);
        const _r12 = i0.ɵɵreference(63);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.isEditMode);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("expanded", ctx.expandPanel)("ngClass", ctx.expandPanel ? "" : "border-0");
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("linear", ctx.isLinear);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("completed", ctx.hasID);
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("ngModel", ctx.training.name);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngModel", ctx.training.institution);
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("ngModel", ctx.training.startDate)("max", ctx.today)("matDatepicker", _r7);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("for", _r7);
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("ngModel", ctx.training.endDate)("min", ctx.training.startDate)("matDatepicker", _r9);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("for", _r9);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngIf", !ctx.viewMode);
        i0.ɵɵadvance(18);
        i0.ɵɵproperty("ngForOf", ctx.listAddedSubjects);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("matChipInputFor", _r12)("matChipInputSeparatorKeyCodes", ctx.separatorKeysCodes)("ngModel", ctx.topic);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("disabled", ctx.listAddedSubjects.length === 0);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("dataSource", ctx.listSubjects);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.subjectsColumns);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("matHeaderRowDef", ctx.subDisplayedColumns);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("matRowDefColumns", ctx.subDisplayedColumns);
        i0.ɵɵadvance(16);
        i0.ɵɵproperty("isWizard", ctx.isWizard)("configurations", ctx.configurations)("primaryData", ctx.inputData);
        i0.ɵɵadvance(10);
        i0.ɵɵproperty("ngIf", !ctx.isEditMode);
    } }, directives: [i10.NgIf, i9$1.MatAccordion, i9$1.MatExpansionPanel, i10.NgClass, i10$1.MatCard, i11.MatHorizontalStepper, i11.MatStep, i11.MatStepLabel, i12.ɵangular_packages_forms_forms_ba, i12.NgControlStatusGroup, i12.NgForm, i12.DefaultValueAccessor, i12.NgControlStatus, i12.NgModel, i16.MatFormField, i17.MatInput, i18.MatDatepickerInput, i18.MatDatepickerToggle, i16.MatSuffix, i18.MatDatepicker, i19.MatChipList, i10.NgForOf, i19.MatChipInput, i16.MatHint, i23.MatTable, i23.MatHeaderRowDef, i23.MatRowDef, i11.MatStepperPrevious, i11.MatStepperNext, i20.FileUploadDeafultLibraryComponent, i21.SaveAsDraftComponent, i19.MatChip, i22.MatIcon, i19.MatChipRemove, i23.MatColumnDef, i23.MatHeaderCellDef, i23.MatCellDef, i23.MatHeaderCell, i23.MatCell, i23.MatHeaderRow, i23.MatRow, i24.ButtonDirective, i25.Tooltip], styles: [".trainingContainer .margin-adjust{margin-left:-15px}.trainingContainer .header-tab{font-weight:600;color:#425772!important}.trainingContainer .mat-form-field{font-size:14px;width:100%}.trainingContainer .training-chip-list{padding:10px}.trainingContainer .icn{cursor:pointer}.trainingContainer .spacing{margin:10px 0}.trainingContainer .f10{font-size:12px;color:#afaaaa}.trainingContainer .dasheedTopBorder{border-top:1px dashed grey}.trainingContainer .paddingTop10{padding-top:10px}.trainingContainer .formBox,.trainingContainer .mTop10{margin-top:10px!important}.trainingContainer .w100{width:100%!important}.trainingContainer table{width:100%}.trainingContainer tr.example-detail-row{height:0}.trainingContainer tr.example-element-row:not(.example-expanded-row):hover{background:#f5f5f5}.trainingContainer tr.example-element-row:not(.example-expanded-row):active{background:#efefef}.trainingContainer .example-element-row td{border-bottom-width:0}.trainingContainer .example-element-detail{overflow:hidden}.trainingContainer .example-element-diagram{min-width:80px;border:2px solid #000;padding:8px;font-weight:lighter;margin:8px 0;height:104px}.trainingContainer .example-element-symbol{font-weight:700;font-size:40px;line-height:normal}.trainingContainer .example-element-description{padding:16px}.trainingContainer .example-element-description-attribution{opacity:.5}.trainingContainer .topics-list-item{line-height:40px;width:80%;border:1px solid #d3d3d3;padding-left:25px}.trainingContainer .circleIndex{width:20px;height:20px;background-color:#8ecdd6;text-align:center}.trainingContainer .w40{width:40px!important}.trainingContainer .mLeft{margin-left:2rem}.trainingContainer .disabledView{pointer-events:none}.trainingContainer .close-edit{position:absolute;right:15px}"], encapsulation: 2, data: { animation: [
            trigger('detailExpand', [
                state('collapsed', style({ height: '0px', minHeight: '0' })),
                state('expanded', style({ height: '*' })),
                transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
            ]),
        ] } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EditTrainingDetailsComponent, [{
        type: Component,
        args: [{
                selector: 'edit-training-details',
                templateUrl: './edit-training-details.component.html',
                styleUrls: ['./edit-training-details.component.scss'],
                encapsulation: ViewEncapsulation.None,
                animations: [
                    trigger('detailExpand', [
                        state('collapsed', style({ height: '0px', minHeight: '0' })),
                        state('expanded', style({ height: '*' })),
                        transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
                    ]),
                ],
            }]
    }], function () { return [{ type: i1$2.ReferenceLibraryService }, { type: i3.ToastrService }, { type: i2$1.MatDialog }, { type: i8.Store }, { type: i6.ActivatedRoute }, { type: i9.DialogService }, { type: EditTrainingDetailsService }]; }, { editTrainingData: [{
            type: Input
        }], isWizard: [{
            type: Input
        }], isProfile: [{
            type: Input
        }], isTabEmitter: [{
            type: Output
        }], trainingForm: [{
            type: ViewChild,
            args: ['trainingForm', { static: true }]
        }], isUsedForBeneEdit: [{
            type: Input
        }], paginator: [{
            type: ViewChild,
            args: [MatPaginator, { static: true }]
        }], sort: [{
            type: ViewChild,
            args: [MatSort, { static: true }]
        }] }); })();

class ConfirmationModalComponent {
    constructor(referenceLibraryService, dialogRef, dialogData, store) {
        this.referenceLibraryService = referenceLibraryService;
        this.dialogRef = dialogRef;
        this.dialogData = dialogData;
        this.store = store;
        this.buttons = [];
        this.observableSubscription$ = new Subject();
        this.dialogRef.disableClose = true;
    }
    ngOnInit() {
        this.title = this.dialogData.update.title;
        this.message = this.dialogData.update.message;
        this.buttons = (this.dialogData.buttons) ? this.dialogData.buttons : ['No', 'Yes'];
    }
    onConfirm() {
        // Close the dialog, return true
        this.dialogRef.close(true);
        this.store.dispatch(new MarkCleanFormAction({
            dirty: false
        }));
    }
    translet() {
        setTimeout(() => {
            this.referenceLibraryService.transletConversion();
        }, 600);
    }
    ngAfterViewInit() {
        this.translet();
    }
    onDismiss() {
        // Close the dialog, return false
        this.dialogRef.close(false);
    }
    handleNo() {
        this.dialogRef.close(false);
    }
}
ConfirmationModalComponent.ɵfac = function ConfirmationModalComponent_Factory(t) { return new (t || ConfirmationModalComponent)(i0.ɵɵdirectiveInject(i1$2.ReferenceLibraryService), i0.ɵɵdirectiveInject(i2$1.MatDialogRef), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA), i0.ɵɵdirectiveInject(i8.Store)); };
ConfirmationModalComponent.ɵcmp = i0.ɵɵdefineComponent({ type: ConfirmationModalComponent, selectors: [["app-confirmation-modal"]], decls: 14, vars: 4, consts: [["mat-dialog-title", ""], [1, "col-md-12", "p-0", "row", "delete-header"], ["id", "confTitle", 1, "col-md-10", "p-0", "common-bene-class-for-translation"], [1, "col-md-2", "p-0", "justify-content-end", "d-flex"], [1, "close-icon", "pi", "pi-times", 3, "click"], ["mat-dialog-content", "", 1, "message"], ["id", "confMsg", 1, "common-bene-class-for-translation"], ["mat-dialog-actions", "", 1, "float-right"], ["mat-raised-button", "", "id", "confBtn1", "color", "primary", 1, "btnCustom", "mr-3", "common-bene-class-for-translation", 3, "click"], ["mat-button", "", "id", "confBtn2", 1, "btnCustom", "common-bene-class-for-translation", 3, "click"]], template: function ConfirmationModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "h5", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵelementStart(5, "i", 4);
        i0.ɵɵlistener("click", function ConfirmationModalComponent_Template_i_click_5_listener() { return ctx.handleNo(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 5);
        i0.ɵɵelementStart(7, "p", 6);
        i0.ɵɵtext(8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "div", 7);
        i0.ɵɵelementStart(10, "button", 8);
        i0.ɵɵlistener("click", function ConfirmationModalComponent_Template_button_click_10_listener() { return ctx.onConfirm(); });
        i0.ɵɵtext(11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "button", 9);
        i0.ɵɵlistener("click", function ConfirmationModalComponent_Template_button_click_12_listener() { return ctx.onDismiss(); });
        i0.ɵɵtext(13);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", ctx.title, " ");
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate(ctx.message);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.buttons[1]);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.buttons[0]);
    } }, directives: [i2$1.MatDialogTitle, i2$1.MatDialogContent, i2$1.MatDialogActions], styles: ["h5[_ngcontent-%COMP%]{color:#475f7b}.message[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{padding:20px 0;margin-bottom:0;font-size:18px}button[_ngcontent-%COMP%]:last-child{margin-left:5px}.close-icon[_ngcontent-%COMP%]{color:#fff;background-color:#553b7c;padding:10px;border-radius:20px;cursor:pointer;font-size:10px}.delete-header[_ngcontent-%COMP%]{color:#01a0da;border-bottom:1px dashed #707070;font-size:22px;font-weight:600;text-align:left;padding:0 0 15px!important}.btnCustom[_ngcontent-%COMP%]{color:#fff;background:#2196f3;border:1px solid #2196f3;padding:.5rem 1rem;font-size:1rem;transition:background-color .2s,color .2s,border-color .2s,box-shadow .2s}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ConfirmationModalComponent, [{
        type: Component,
        args: [{
                selector: 'app-confirmation-modal',
                templateUrl: './confirmation-modal.component.html',
                styleUrls: ['./confirmation-modal.component.scss']
            }]
    }], function () { return [{ type: i1$2.ReferenceLibraryService }, { type: i2$1.MatDialogRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }, { type: i8.Store }]; }, null); })();

class EditLicenseDetailsService {
    constructor(http, webStorage) {
        this.http = http;
        this.webStorage = webStorage;
        this.uploaded$ = new BehaviorSubject({});
        this.deletedfile$ = new BehaviorSubject({});
        this.showBeneficiary = new BehaviorSubject(false);
        this.currentUserSubject = new BehaviorSubject(this.webStorage.getWebStorageItem('currentUser'));
        this.currentUser = this.currentUserSubject.asObservable();
    }
    getBeneDetails(visatype, caseType, caseId, synctype, superTaskId, subTaskId, isUsedForBeneEdit) {
        return this.http.get(`/${visatype}/${caseType}/${caseId}/${synctype}?superTaskId=${superTaskId}&taskId=${subTaskId}&isUsedForBenEdit=true`).pipe(map((response) => {
            if (response && (response.status === 200 || response.status === 204)) {
                return response;
            }
        }));
    }
    get currentUserValue() {
        return this.currentUserSubject.value;
    }
    saveTrainingDetails(payload) {
        let petitionId = JSON.parse(sessionStorage.getItem('tempPetitionId'));
        return this.http.post(`/petition/saveTrainingOrLicense/${petitionId}/LICENSE`, payload).pipe(map((response) => response));
    }
    getLicenceDetails(beneficiaryId, type, familyId) {
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        return this.http.get(`/beneficiary/${beneficiaryId}/profile/professional/${type}${profileFamilyString}`).pipe(map((response) => response.data));
    }
    deleteLicenceDocuments(visatype, caseType, caseId, synctype, superTaskId, subTaskId, educationId) {
        return this.http.delete(`/${visatype}/${caseType}/${caseId}/${synctype}/${educationId}?superTaskId=${superTaskId}&taskId=${subTaskId}`).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    // IM-3066 - remove deleted file.
    deletefile(beneficiaryId) {
        this.deletedfile$.next(true);
    }
    uploaded() {
        this.uploaded$.next(true);
    }
    genericGetUploadDocument(useCase, useCaseId, categoryName, entityId, useEntityId, familyId) {
        const entityUrlString = (useEntityId) ? `/entity/${entityId}` : '';
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        return this.http.get(`/document/${useCase}/${useCaseId}/category/${categoryName}${entityUrlString}${profileFamilyString}`).pipe(map((response) => {
            if (response.status === 200) {
                response.data = response.data.filter(x => x.fileLocation !== null);
                return response;
            }
            return response;
        }));
    }
    getLicensesInformation(superTaskId, subTaskId, isUsedForBenEdit = false) {
        return this.http.get(`/superTask/${superTaskId}/subTask/${subTaskId}/gc/i140Case/education/license?isUsedForBenEdit=${isUsedForBenEdit}`);
    }
    getLicensesInformationPerm(caseId, isUsedForBenEdit = false) {
        return this.http.get(`/gc/perm/${caseId}/educationDetails/education/license?isUsedForBenEdit=${isUsedForBenEdit}`);
    }
    savegcI140LicenseDetails(gcI140Id, payload, type) {
        const encriptedData = this.toEncrypt(type);
        return this.http.post(`/gcCase/saveTrainingOrLicense/${gcI140Id}/${encriptedData}?isGcI140Case=true&isGcPermCase=false`, payload);
    }
    savePermLicenseDetails(permId, payload, type) {
        const encriptedData = this.toEncrypt(type);
        return this.http.post(`/gcCase/saveTrainingOrLicense/${permId}/${encriptedData}?isGcI140Case=false&isGcPermCase=true`, payload);
    }
    deleteLicensesInformation(superTaskId, subTaskId, licenseId) {
        return this.http.delete(`/superTask/${superTaskId}/subTask/${subTaskId}/gc/i140Case/education/license/${licenseId}/delete`).pipe(map((response) => {
            return response;
        }));
    }
    getLicenceDetailsForProfile(beneficiaryId, type, familyId) {
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        return this.http.get(`/beneficiary/${beneficiaryId}/profile/professional/${type}${profileFamilyString}`).pipe(map((response) => response));
    }
    saveLicenceDetailsForProfile(beneficiaryId, type, payload, familyId) {
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        return this.http.post(`/beneficiary/${beneficiaryId}/profile/professional/${type}${profileFamilyString}`, payload).pipe(map((response) => response));
    }
    deleteLicenceDetailsForProfile(beneficiaryId, type, professionalId, familyId) {
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        return this.http.delete(`/beneficiary/${beneficiaryId}/profile/professional/${professionalId}/${type}${profileFamilyString}`).pipe(map((response) => {
            // IM-3066 - remove deleted file.
            this.deletefile(beneficiaryId);
            return response;
        }));
    }
    toEncrypt(_data) {
        var pharase = 'c63a423527b24f65';
        var data = _data;
        var key = CryptoJS.enc.Latin1.parse(pharase);
        var iv = CryptoJS.enc.Latin1.parse(pharase);
        var encrypted = CryptoJS.AES.encrypt(data, key, { iv: iv, mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.ZeroPadding
        }).toString();
        var e64 = CryptoJS.enc.Base64.parse(encrypted);
        var eHex = e64.toString(CryptoJS.enc.Hex);
        return this.encriptedData = eHex;
    }
}
EditLicenseDetailsService.ɵfac = function EditLicenseDetailsService_Factory(t) { return new (t || EditLicenseDetailsService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.ImagilityWebStorage)); };
EditLicenseDetailsService.ɵprov = i0.ɵɵdefineInjectable({ token: EditLicenseDetailsService, factory: EditLicenseDetailsService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EditLicenseDetailsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }, { type: i2.ImagilityWebStorage }]; }, null); })();

function EditLicenseDetailsComponent_div_0_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵelementStart(1, "button", 9);
    i0.ɵɵlistener("click", function EditLicenseDetailsComponent_div_0_div_3_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(2); return ctx_r5.toggleListView(false); });
    i0.ɵɵelementStart(2, "mat-icon", 10);
    i0.ɵɵtext(3, "timeline");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 11);
    i0.ɵɵtext(5, "Timeline View");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "button", 12);
    i0.ɵɵlistener("click", function EditLicenseDetailsComponent_div_0_div_3_Template_button_click_6_listener() { i0.ɵɵrestoreView(_r6); const ctx_r7 = i0.ɵɵnextContext(2); return ctx_r7.toggleListView(true); });
    i0.ɵɵelementStart(7, "mat-icon", 13);
    i0.ɵɵtext(8, "list");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "span", 14);
    i0.ɵɵtext(10, "List View");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵclassProp("activebtn", ctx_r1.isTimeLineView);
    i0.ɵɵadvance(5);
    i0.ɵɵclassProp("activebtn", ctx_r1.isListView);
} }
function EditLicenseDetailsComponent_div_0_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 15);
} }
function EditLicenseDetailsComponent_div_0_div_5_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 18);
    i0.ɵɵlistener("click", function EditLicenseDetailsComponent_div_0_div_5_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(3); return ctx_r9.toggleListView(true); });
    i0.ɵɵelementStart(1, "mat-icon", 19);
    i0.ɵɵtext(2, "add_circle_outline");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function EditLicenseDetailsComponent_div_0_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtemplate(1, EditLicenseDetailsComponent_div_0_div_5_button_1_Template, 3, 0, "button", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r3.viewMode);
} }
function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 91);
    i0.ɵɵtext(1, "No licenses or certification details have been added yet");
    i0.ɵɵelementEnd();
} }
function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r34 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 92);
    i0.ɵɵlistener("click", function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_button_3_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r34); i0.ɵɵnextContext(); const _r15 = i0.ɵɵreference(10); const _r17 = i0.ɵɵreference(14); const ctx_r33 = i0.ɵɵnextContext(3); ctx_r33.toggleExpansion(); _r15.reset(); return ctx_r33.formCheck(_r17); });
    i0.ɵɵelementStart(1, "span", 93);
    i0.ɵɵtext(2, "Add License / Certificate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_ng_template_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 94);
    i0.ɵɵtext(1, "Licenses Or Certifications");
    i0.ɵɵelementEnd();
} }
function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_span_40_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 95);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r22.getGlobalErrorMessages("INVALID_DATE"), " ");
} }
function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_div_41_span_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 101);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r37 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r37.getGlobalErrorMessages("INVALID_DATE"), " ");
} }
function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_div_41_Template(rf, ctx) { if (rf & 1) {
    const _r39 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 44);
    i0.ɵɵelementStart(1, "label", 96);
    i0.ɵɵtext(2, "End Date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "mat-form-field", 46);
    i0.ɵɵelementStart(4, "input", 97, 98);
    i0.ɵɵlistener("ngModelChange", function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_div_41_Template_input_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r39); const ctx_r38 = i0.ɵɵnextContext(4); return ctx_r38.license.endDate = $event; })("click", function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_div_41_Template_input_click_4_listener() { i0.ɵɵrestoreView(_r39); const _r36 = i0.ɵɵreference(8); return _r36.open(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "mat-datepicker-toggle", 49);
    i0.ɵɵelement(7, "mat-datepicker", null, 99);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, EditLicenseDetailsComponent_div_0_div_6_ng_container_1_div_41_span_9_Template, 2, 1, "span", 100);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r35 = i0.ɵɵreference(5);
    const _r36 = i0.ɵɵreference(8);
    const ctx_r23 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngModel", ctx_r23.license.endDate)("min", ctx_r23.license.startDate)("matDatepicker", _r36);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("for", _r36);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", _r35.touched && _r35.errors && !_r35.errors.required);
} }
function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_button_47_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 84);
    i0.ɵɵelementStart(1, "span", 85);
    i0.ɵɵtext(2, "Next");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_div_48_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 102);
    i0.ɵɵelementStart(1, "i", 103);
    i0.ɵɵtext(2, "To proceed to the next tabs, please save the data in the current tab first.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_ng_template_50_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 104);
    i0.ɵɵtext(1, "Topics or Subjects Covered");
    i0.ɵɵelementEnd();
} }
function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_mat_chip_66_mat_icon_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon", 108);
    i0.ɵɵtext(1, "cancel");
    i0.ɵɵelementEnd();
} }
function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_mat_chip_66_Template(rf, ctx) { if (rf & 1) {
    const _r45 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-chip", 105);
    i0.ɵɵlistener("removed", function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_mat_chip_66_Template_mat_chip_removed_0_listener() { i0.ɵɵrestoreView(_r45); const subject_r41 = ctx.$implicit; const ctx_r44 = i0.ɵɵnextContext(4); return ctx_r44.remove(subject_r41); });
    i0.ɵɵelementStart(1, "span", 106);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, EditLicenseDetailsComponent_div_0_div_6_ng_container_1_mat_chip_66_mat_icon_3_Template, 2, 0, "mat-icon", 107);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const subject_r41 = ctx.$implicit;
    const i_r42 = ctx.index;
    const ctx_r28 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("selectable", ctx_r28.selectable)("removable", ctx_r28.removable);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "inputValueSubjectName", i_r42, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(subject_r41);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r28.removable);
} }
function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_ng_container_76_th_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 112);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r50 = i0.ɵɵnextContext();
    const indx_r47 = ctx_r50.index;
    const column_r46 = ctx_r50.$implicit;
    i0.ɵɵpropertyInterpolate1("id", "colHeader2Lbl", indx_r47, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", column_r46.header, " ");
} }
function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_ng_container_76_td_2_span_1_Template(rf, ctx) { if (rf & 1) {
    const _r57 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 116);
    i0.ɵɵelementStart(1, "mat-icon", 117);
    i0.ɵɵlistener("click", function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_ng_container_76_td_2_span_1_Template_mat_icon_click_1_listener() { i0.ɵɵrestoreView(_r57); const i_r52 = i0.ɵɵnextContext().index; const ctx_r55 = i0.ɵɵnextContext(5); return ctx_r55.deleteSubject(i_r52); });
    i0.ɵɵtext(2, "delete_forever ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_ng_container_76_td_2_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 106);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r59 = i0.ɵɵnextContext();
    const i_r52 = ctx_r59.index;
    const row_r51 = ctx_r59.$implicit;
    const ctx_r58 = i0.ɵɵnextContext();
    const indx_r47 = ctx_r58.index;
    const column_r46 = ctx_r58.$implicit;
    i0.ɵɵpropertyInterpolate2("id", "colTextLbl2_", indx_r47, "__", i_r52, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", row_r51[column_r46.columnDef], " ");
} }
function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_ng_container_76_td_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 113);
    i0.ɵɵtemplate(1, EditLicenseDetailsComponent_div_0_div_6_ng_container_1_ng_container_76_td_2_span_1_Template, 3, 0, "span", 114);
    i0.ɵɵtemplate(2, EditLicenseDetailsComponent_div_0_div_6_ng_container_1_ng_container_76_td_2_span_2_Template, 2, 3, "span", 115);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r46 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", column_r46.columnType == "icon");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", column_r46.columnType == "text");
} }
function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_ng_container_76_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 109);
    i0.ɵɵtemplate(1, EditLicenseDetailsComponent_div_0_div_6_ng_container_1_ng_container_76_th_1_Template, 2, 2, "th", 110);
    i0.ɵɵtemplate(2, EditLicenseDetailsComponent_div_0_div_6_ng_container_1_ng_container_76_td_2_Template, 3, 2, "td", 111);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const column_r46 = ctx.$implicit;
    i0.ɵɵproperty("matColumnDef", column_r46.columnDef);
} }
function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_tr_77_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 118);
} }
function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_tr_78_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 119);
} }
function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_ng_template_91_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 120);
    i0.ɵɵtext(1, "Upload Documents");
    i0.ɵɵelementEnd();
} }
const _c0 = function (a0) { return { disabledView: a0 }; };
function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r63 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 21);
    i0.ɵɵtemplate(2, EditLicenseDetailsComponent_div_0_div_6_ng_container_1_span_2_Template, 2, 0, "span", 22);
    i0.ɵɵtemplate(3, EditLicenseDetailsComponent_div_0_div_6_ng_container_1_button_3_Template, 3, 0, "button", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "mat-accordion");
    i0.ɵɵelementStart(5, "mat-expansion-panel", 24);
    i0.ɵɵelementStart(6, "mat-card");
    i0.ɵɵelementStart(7, "div", 25);
    i0.ɵɵelementStart(8, "i", 26);
    i0.ɵɵlistener("click", function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_Template_i_click_8_listener() { i0.ɵɵrestoreView(_r63); const ctx_r62 = i0.ɵɵnextContext(3); return ctx_r62.handleClose(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "mat-horizontal-stepper", 27, 28);
    i0.ɵɵelementStart(11, "mat-step", 29);
    i0.ɵɵtemplate(12, EditLicenseDetailsComponent_div_0_div_6_ng_container_1_ng_template_12_Template, 2, 0, "ng-template", 30);
    i0.ɵɵelementStart(13, "form", 31, 32);
    i0.ɵɵlistener("ngSubmit", function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_Template_form_ngSubmit_13_listener() { i0.ɵɵrestoreView(_r63); const _r17 = i0.ɵɵreference(14); const ctx_r64 = i0.ɵɵnextContext(3); return _r17.form.valid && ctx_r64.saveLicenseTrianing(_r17); });
    i0.ɵɵelementStart(15, "div", 33);
    i0.ɵɵelementStart(16, "div", 34);
    i0.ɵɵelementStart(17, "label", 35);
    i0.ɵɵtext(18, "Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "input", 36, 37);
    i0.ɵɵlistener("ngModelChange", function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_Template_input_ngModelChange_19_listener($event) { i0.ɵɵrestoreView(_r63); const ctx_r65 = i0.ɵɵnextContext(3); return ctx_r65.license.name = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "div", 38);
    i0.ɵɵelementStart(22, "label", 39);
    i0.ɵɵtext(23, "Issuing Organization");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(24, "input", 40, 41);
    i0.ɵɵlistener("ngModelChange", function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_Template_input_ngModelChange_24_listener($event) { i0.ɵɵrestoreView(_r63); const ctx_r66 = i0.ɵɵnextContext(3); return ctx_r66.license.institution = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(26, "div", 38);
    i0.ɵɵelementStart(27, "mat-checkbox", 42);
    i0.ɵɵlistener("ngModelChange", function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_Template_mat_checkbox_ngModelChange_27_listener($event) { i0.ɵɵrestoreView(_r63); const ctx_r67 = i0.ɵɵnextContext(3); return ctx_r67.infiniteDtFlag = $event; });
    i0.ɵɵelementStart(28, "span", 43);
    i0.ɵɵtext(29, "This credentials does not expire");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(30, "div", 15);
    i0.ɵɵelementStart(31, "div", 44);
    i0.ɵɵelementStart(32, "label", 45);
    i0.ɵɵtext(33, "Start Date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(34, "mat-form-field", 46);
    i0.ɵɵelementStart(35, "input", 47, 48);
    i0.ɵɵlistener("ngModelChange", function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_Template_input_ngModelChange_35_listener($event) { i0.ɵɵrestoreView(_r63); const ctx_r68 = i0.ɵɵnextContext(3); return ctx_r68.license.startDate = $event; })("click", function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_Template_input_click_35_listener() { i0.ɵɵrestoreView(_r63); const _r21 = i0.ɵɵreference(39); return _r21.open(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(37, "mat-datepicker-toggle", 49);
    i0.ɵɵelement(38, "mat-datepicker", null, 50);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(40, EditLicenseDetailsComponent_div_0_div_6_ng_container_1_span_40_Template, 2, 1, "span", 51);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(41, EditLicenseDetailsComponent_div_0_div_6_ng_container_1_div_41_Template, 10, 5, "div", 52);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(42, "div", 53);
    i0.ɵɵelementStart(43, "div", 44);
    i0.ɵɵelementStart(44, "button", 54);
    i0.ɵɵelementStart(45, "span", 55);
    i0.ɵɵtext(46, "Save");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(47, EditLicenseDetailsComponent_div_0_div_6_ng_container_1_button_47_Template, 3, 0, "button", 56);
    i0.ɵɵtemplate(48, EditLicenseDetailsComponent_div_0_div_6_ng_container_1_div_48_Template, 3, 0, "div", 57);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(49, "mat-step");
    i0.ɵɵtemplate(50, EditLicenseDetailsComponent_div_0_div_6_ng_container_1_ng_template_50_Template, 2, 0, "ng-template", 30);
    i0.ɵɵelementStart(51, "div", 58);
    i0.ɵɵelementStart(52, "div", 34);
    i0.ɵɵelementStart(53, "div", 15);
    i0.ɵɵelementStart(54, "label", 59);
    i0.ɵɵtext(55, "Add topics or subjects covered in the Licenses or Certifications");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(56, "small", 60);
    i0.ɵɵtext(57, "Enter all relevant Topics or Subjects Covered as a part of your Certifications using a comma to separate.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(58, "div", 61);
    i0.ɵɵelementStart(59, "div", 62);
    i0.ɵɵelementStart(60, "label", 63);
    i0.ɵɵtext(61, "Topics Or Subjects Covered");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(62, "div", 64);
    i0.ɵɵelementStart(63, "mat-form-field", 65);
    i0.ɵɵelementStart(64, "mat-chip-list", 66, 67);
    i0.ɵɵtemplate(66, EditLicenseDetailsComponent_div_0_div_6_ng_container_1_mat_chip_66_Template, 4, 5, "mat-chip", 68);
    i0.ɵɵelementStart(67, "input", 69);
    i0.ɵɵlistener("paste", function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_Template_input_paste_67_listener($event) { i0.ɵɵrestoreView(_r63); const ctx_r70 = i0.ɵɵnextContext(3); return ctx_r70.pasteChips($event); })("ngModelChange", function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_Template_input_ngModelChange_67_listener($event) { i0.ɵɵrestoreView(_r63); const ctx_r71 = i0.ɵɵnextContext(3); return ctx_r71.topic = $event; })("input", function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_Template_input_input_67_listener($event) { i0.ɵɵrestoreView(_r63); const ctx_r72 = i0.ɵɵnextContext(3); return ctx_r72.onNewTopicEnter($event); })("matChipInputTokenEnd", function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_Template_input_matChipInputTokenEnd_67_listener($event) { i0.ɵɵrestoreView(_r63); const ctx_r73 = i0.ɵɵnextContext(3); return ctx_r73.add($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(68, "mat-hint", 70);
    i0.ɵɵtext(69, "Please enter comma separated values");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(70, "div", 71);
    i0.ɵɵelementStart(71, "button", 72);
    i0.ɵɵlistener("click", function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_Template_button_click_71_listener() { i0.ɵɵrestoreView(_r63); const ctx_r74 = i0.ɵɵnextContext(3); return ctx_r74.addSubjects(); });
    i0.ɵɵelementStart(72, "span", 73);
    i0.ɵɵtext(73, "Add");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(74, "div", 74);
    i0.ɵɵelementStart(75, "table", 75);
    i0.ɵɵtemplate(76, EditLicenseDetailsComponent_div_0_div_6_ng_container_1_ng_container_76_Template, 3, 1, "ng-container", 76);
    i0.ɵɵtemplate(77, EditLicenseDetailsComponent_div_0_div_6_ng_container_1_tr_77_Template, 1, 0, "tr", 77);
    i0.ɵɵtemplate(78, EditLicenseDetailsComponent_div_0_div_6_ng_container_1_tr_78_Template, 1, 0, "tr", 78);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(79, "div", 79);
    i0.ɵɵelement(80, "hr");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(81, "div", 64);
    i0.ɵɵelementStart(82, "div", 80);
    i0.ɵɵelementStart(83, "div", 81);
    i0.ɵɵelementStart(84, "button", 82);
    i0.ɵɵelementStart(85, "span", 83);
    i0.ɵɵtext(86, "Back");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(87, "button", 84);
    i0.ɵɵelementStart(88, "span", 85);
    i0.ɵɵtext(89, "Next");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(90, "mat-step");
    i0.ɵɵtemplate(91, EditLicenseDetailsComponent_div_0_div_6_ng_container_1_ng_template_91_Template, 2, 0, "ng-template", 30);
    i0.ɵɵelementStart(92, "div", 58);
    i0.ɵɵelementStart(93, "div", 86);
    i0.ɵɵelementStart(94, "file-upload-deafult-library", 87);
    i0.ɵɵlistener("fileUploadSuccess", function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_Template_file_upload_deafult_library_fileUploadSuccess_94_listener() { i0.ɵɵrestoreView(_r63); const ctx_r75 = i0.ɵɵnextContext(3); return ctx_r75.fileUploadSuccess(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(95, "div", 64);
    i0.ɵɵelementStart(96, "div", 80);
    i0.ɵɵelementStart(97, "div", 81);
    i0.ɵɵelementStart(98, "button", 82);
    i0.ɵɵelementStart(99, "span", 88);
    i0.ɵɵtext(100, "Back");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(101, "button", 89);
    i0.ɵɵlistener("click", function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_Template_button_click_101_listener() { i0.ɵɵrestoreView(_r63); const _r17 = i0.ɵɵreference(14); const _r15 = i0.ɵɵreference(10); const ctx_r76 = i0.ɵɵnextContext(3); ctx_r76.resetForm(_r17); return _r15.reset(); });
    i0.ɵɵelementStart(102, "span", 90);
    i0.ɵɵtext(103, "Add Next");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(104, " Licenses");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r17 = i0.ɵɵreference(14);
    const _r20 = i0.ɵɵreference(36);
    const _r21 = i0.ɵɵreference(39);
    const _r27 = i0.ɵɵreference(65);
    const ctx_r11 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !(ctx_r11.dataSource == null ? null : ctx_r11.dataSource.data == null ? null : ctx_r11.dataSource.data.length) && !ctx_r11.isEditMode);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r11.updateBenProfile && !ctx_r11.viewMode && ctx_r11.showEditButton && !ctx_r11.isEditMode);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("expanded", ctx_r11.expandPanel)("ngClass", ctx_r11.expandPanel ? "" : "border-0");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("linear", ctx_r11.isLinear);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("completed", ctx_r11.hasID);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(33, _c0, ctx_r11.isViewMode));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngModel", ctx_r11.license.name);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngModel", ctx_r11.license.institution);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngModel", ctx_r11.infiniteDtFlag);
    i0.ɵɵadvance(8);
    i0.ɵɵproperty("ngModel", ctx_r11.license.startDate)("max", ctx_r11.today)("matDatepicker", _r21);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("for", _r21);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", _r20.touched && _r20.errors && !_r20.errors.required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r11.infiniteDtFlag === false);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("disabled", _r17.invalid);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r11.hasID);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r11.hasID);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(35, _c0, ctx_r11.isViewMode));
    i0.ɵɵadvance(15);
    i0.ɵɵproperty("ngForOf", ctx_r11.listAddedSubjects);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matChipInputFor", _r27)("matChipInputSeparatorKeyCodes", ctx_r11.separatorKeysCodes)("ngModel", ctx_r11.topic);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("disabled", ctx_r11.listAddedSubjects.length === 0);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("dataSource", ctx_r11.listSubjects);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r11.subjectsColumns);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matHeaderRowDef", ctx_r11.subDisplayedColumns);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matRowDefColumns", ctx_r11.subDisplayedColumns);
    i0.ɵɵadvance(14);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(37, _c0, ctx_r11.isViewMode));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("isWizard", ctx_r11.isWizard)("primaryData", ctx_r11.inputData)("configurations", ctx_r11.configurations);
} }
function EditLicenseDetailsComponent_div_0_div_6_div_2_div_1_ng_container_2_th_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 130);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r87 = i0.ɵɵnextContext();
    const indx_r84 = ctx_r87.index;
    const column_r83 = ctx_r87.$implicit;
    i0.ɵɵpropertyInterpolate1("id", "colHeader4Lbl", indx_r84, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", column_r83.header, " ");
} }
function EditLicenseDetailsComponent_div_0_div_6_div_2_div_1_ng_container_2_td_2_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 132);
    i0.ɵɵelementStart(1, "a");
    i0.ɵɵelementStart(2, "mat-icon", 133);
    i0.ɵɵtext(3, "expand_more");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function EditLicenseDetailsComponent_div_0_div_6_div_2_div_1_ng_container_2_td_2_div_2_span_1_ng_container_1_mat_icon_1_Template(rf, ctx) { if (rf & 1) {
    const _r98 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-icon", 135);
    i0.ɵɵlistener("click", function EditLicenseDetailsComponent_div_0_div_6_div_2_div_1_ng_container_2_td_2_div_2_span_1_ng_container_1_mat_icon_1_Template_mat_icon_click_0_listener() { i0.ɵɵrestoreView(_r98); const row_r88 = i0.ɵɵnextContext(4).$implicit; const ctx_r96 = i0.ɵɵnextContext(6); ctx_r96.handleEdit(row_r88); return ctx_r96.formCheck(ctx_r96.licForm); });
    i0.ɵɵtext(1, "edit ");
    i0.ɵɵelementEnd();
} }
function EditLicenseDetailsComponent_div_0_div_6_div_2_div_1_ng_container_2_td_2_div_2_span_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r101 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EditLicenseDetailsComponent_div_0_div_6_div_2_div_1_ng_container_2_td_2_div_2_span_1_ng_container_1_mat_icon_1_Template, 2, 0, "mat-icon", 134);
    i0.ɵɵelementStart(2, "mat-icon", 117);
    i0.ɵɵlistener("click", function EditLicenseDetailsComponent_div_0_div_6_div_2_div_1_ng_container_2_td_2_div_2_span_1_ng_container_1_Template_mat_icon_click_2_listener() { i0.ɵɵrestoreView(_r101); const row_r88 = i0.ɵɵnextContext(3).$implicit; const ctx_r99 = i0.ɵɵnextContext(6); return ctx_r99.handleDelete(row_r88, ctx_r99.licForm); });
    i0.ɵɵtext(3, " delete_forever ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r94 = i0.ɵɵnextContext(9);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r94.viewMode);
} }
function EditLicenseDetailsComponent_div_0_div_6_div_2_div_1_ng_container_2_td_2_div_2_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 15);
    i0.ɵɵtemplate(1, EditLicenseDetailsComponent_div_0_div_6_div_2_div_1_ng_container_2_td_2_div_2_span_1_ng_container_1_Template, 4, 1, "ng-container", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r93 = i0.ɵɵnextContext(8);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r93.isExternalEmployeeId);
} }
function EditLicenseDetailsComponent_div_0_div_6_div_2_div_1_ng_container_2_td_2_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, EditLicenseDetailsComponent_div_0_div_6_div_2_div_1_ng_container_2_td_2_div_2_span_1_Template, 2, 1, "span", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r83 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", column_r83.columnDef == "action");
} }
function EditLicenseDetailsComponent_div_0_div_6_div_2_div_1_ng_container_2_td_2_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 106);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r104 = i0.ɵɵnextContext();
    const i_r89 = ctx_r104.renderIndex;
    const row_r88 = ctx_r104.$implicit;
    const ctx_r103 = i0.ɵɵnextContext();
    const indx_r84 = ctx_r103.index;
    const column_r83 = ctx_r103.$implicit;
    i0.ɵɵpropertyInterpolate2("id", "colText4Lbl_", indx_r84, "__", i_r89, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", row_r88[column_r83.columnDef], " ");
} }
function EditLicenseDetailsComponent_div_0_div_6_div_2_div_1_ng_container_2_td_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 113);
    i0.ɵɵtemplate(1, EditLicenseDetailsComponent_div_0_div_6_div_2_div_1_ng_container_2_td_2_span_1_Template, 4, 0, "span", 131);
    i0.ɵɵtemplate(2, EditLicenseDetailsComponent_div_0_div_6_div_2_div_1_ng_container_2_td_2_div_2_Template, 2, 1, "div", 7);
    i0.ɵɵtemplate(3, EditLicenseDetailsComponent_div_0_div_6_div_2_div_1_ng_container_2_td_2_span_3_Template, 2, 3, "span", 115);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r83 = i0.ɵɵnextContext().$implicit;
    const ctx_r86 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", column_r83.columnDef == "toggle");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r86.updateBenProfile && ctx_r86.showEditButton);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", column_r83.columnType == "text");
} }
function EditLicenseDetailsComponent_div_0_div_6_div_2_div_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 109);
    i0.ɵɵtemplate(1, EditLicenseDetailsComponent_div_0_div_6_div_2_div_1_ng_container_2_th_1_Template, 2, 2, "th", 129);
    i0.ɵɵtemplate(2, EditLicenseDetailsComponent_div_0_div_6_div_2_div_1_ng_container_2_td_2_Template, 4, 3, "td", 111);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const column_r83 = ctx.$implicit;
    i0.ɵɵproperty("matColumnDef", column_r83.columnDef);
} }
function EditLicenseDetailsComponent_div_0_div_6_div_2_div_1_td_7_div_2_tr_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 142);
    i0.ɵɵelementStart(1, "td", 143);
    i0.ɵɵelementStart(2, "div", 144);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td", 145);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const sub_r112 = ctx.$implicit;
    const i_r113 = ctx.index;
    const ix_r107 = i0.ɵɵnextContext(2).renderIndex;
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate2("id", "topicNoForOuterSection", i_r113, "_", ix_r107, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", i_r113 + 1, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate2("id", "topicNameForOuterSection", i_r113, "_", ix_r107, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", sub_r112, " ");
} }
function EditLicenseDetailsComponent_div_0_div_6_div_2_div_1_td_7_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 139);
    i0.ɵɵelementStart(1, "h6", 106);
    i0.ɵɵtext(2, "List of Topics");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerStart(3);
    i0.ɵɵelementStart(4, "table", 140);
    i0.ɵɵtemplate(5, EditLicenseDetailsComponent_div_0_div_6_div_2_div_1_td_7_div_2_tr_5_Template, 6, 6, "tr", 141);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r115 = i0.ɵɵnextContext();
    const ix_r107 = ctx_r115.renderIndex;
    const element_r106 = ctx_r115.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "headListOfTopics2", ix_r107, "");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", element_r106.subjects);
} }
function EditLicenseDetailsComponent_div_0_div_6_div_2_div_1_td_7_div_3_tr_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td", 143);
    i0.ɵɵelementStart(2, "div", 144);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td");
    i0.ɵɵelementStart(5, "strong", 106);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td", 145);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "td", 152);
    i0.ɵɵelement(10, "file-download-library", 153);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r117 = ctx.$implicit;
    const i_r118 = ctx.index;
    const ctx_r116 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("id", "tableValueLicDocNoOuter", i_r118, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", i_r118 + 1, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("id", "tableValueLicDocNameOuter", i_r118, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(item_r117.fileName);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "tableValueLicDocCategoryOuter", i_r118, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", (item_r117 == null ? null : item_r117.fileCategory == null ? null : item_r117.fileCategory.code) === "OTHER" ? item_r117 == null ? null : item_r117.fileCategoryOtherName : item_r117 == null ? null : item_r117.fileCategory == null ? null : item_r117.fileCategory.name, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("fileName", item_r117.fileLocation == null ? null : item_r117.fileLocation.substring(23))("Path", ctx_r116.envPath + (item_r117.fileLocation == null ? null : item_r117.fileLocation.substring(23)));
} }
function EditLicenseDetailsComponent_div_0_div_6_div_2_div_1_td_7_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 139);
    i0.ɵɵelementStart(1, "h6", 146);
    i0.ɵɵtext(2, "List of Documents");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerStart(3);
    i0.ɵɵelementStart(4, "table", 147);
    i0.ɵɵelementStart(5, "thead");
    i0.ɵɵelementStart(6, "tr");
    i0.ɵɵelement(7, "th", 143);
    i0.ɵɵelementStart(8, "th", 148);
    i0.ɵɵtext(9, "Document");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "th", 149);
    i0.ɵɵtext(11, "Document Type");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "th");
    i0.ɵɵelement(13, "i", 150);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "tbody");
    i0.ɵɵtemplate(15, EditLicenseDetailsComponent_div_0_div_6_div_2_div_1_td_7_div_3_tr_15_Template, 11, 8, "tr", 151);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const element_r106 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(15);
    i0.ɵɵproperty("ngForOf", element_r106.documents);
} }
function EditLicenseDetailsComponent_div_0_div_6_div_2_div_1_td_7_div_4_tr_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 142);
    i0.ɵɵelementStart(1, "td", 143);
    i0.ɵɵelementStart(2, "div", 144);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td", 145);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const sub_r121 = ctx.$implicit;
    const i_r122 = ctx.index;
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("id", "topicNoForOuterSection", i_r122, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", i_r122 + 1, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "topicNameForOuterSection", i_r122, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", sub_r121, " ");
} }
function EditLicenseDetailsComponent_div_0_div_6_div_2_div_1_td_7_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 139);
    i0.ɵɵelementStart(1, "h6", 154);
    i0.ɵɵtext(2, "List of Topics");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerStart(3);
    i0.ɵɵelementStart(4, "table", 140);
    i0.ɵɵtemplate(5, EditLicenseDetailsComponent_div_0_div_6_div_2_div_1_td_7_div_4_tr_5_Template, 6, 4, "tr", 141);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const element_r106 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngForOf", element_r106.subjects);
} }
function EditLicenseDetailsComponent_div_0_div_6_div_2_div_1_td_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 136);
    i0.ɵɵelementStart(1, "div", 137);
    i0.ɵɵtemplate(2, EditLicenseDetailsComponent_div_0_div_6_div_2_div_1_td_7_div_2_Template, 6, 2, "div", 138);
    i0.ɵɵtemplate(3, EditLicenseDetailsComponent_div_0_div_6_div_2_div_1_td_7_div_3_Template, 16, 1, "div", 138);
    i0.ɵɵtemplate(4, EditLicenseDetailsComponent_div_0_div_6_div_2_div_1_td_7_div_4_Template, 6, 1, "div", 138);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const element_r106 = ctx.$implicit;
    const ctx_r79 = i0.ɵɵnextContext(5);
    i0.ɵɵattribute("colspan", ctx_r79.columns.length);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("@detailExpand", element_r106 == ctx_r79.expandedElement ? "expanded" : "collapsed");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (element_r106 == null ? null : element_r106.subjects == null ? null : element_r106.subjects.length) > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (element_r106 == null ? null : element_r106.documents == null ? null : element_r106.documents.length) > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (element_r106 == null ? null : element_r106.subjects == null ? null : element_r106.subjects.length) > 0);
} }
function EditLicenseDetailsComponent_div_0_div_6_div_2_div_1_tr_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 118);
} }
function EditLicenseDetailsComponent_div_0_div_6_div_2_div_1_tr_9_Template(rf, ctx) { if (rf & 1) {
    const _r126 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 155);
    i0.ɵɵlistener("click", function EditLicenseDetailsComponent_div_0_div_6_div_2_div_1_tr_9_Template_tr_click_0_listener() { i0.ɵɵrestoreView(_r126); const element_r124 = ctx.$implicit; const ctx_r125 = i0.ɵɵnextContext(5); return ctx_r125.expandedElement = ctx_r125.expandedElement === element_r124 ? null : element_r124; });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const element_r124 = ctx.$implicit;
    const ctx_r81 = i0.ɵɵnextContext(5);
    i0.ɵɵclassProp("example-expanded-row", ctx_r81.expandedElement === element_r124);
} }
function EditLicenseDetailsComponent_div_0_div_6_div_2_div_1_tr_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 156);
} }
const _c1 = function () { return ["expandedDetail"]; };
function EditLicenseDetailsComponent_div_0_div_6_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "table", 122);
    i0.ɵɵtemplate(2, EditLicenseDetailsComponent_div_0_div_6_div_2_div_1_ng_container_2_Template, 3, 1, "ng-container", 76);
    i0.ɵɵelementStart(3, "div", 123);
    i0.ɵɵelementContainerStart(4, 124);
    i0.ɵɵelementStart(5, "label", 125);
    i0.ɵɵtext(6, " List of Topics ");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, EditLicenseDetailsComponent_div_0_div_6_div_2_div_1_td_7_Template, 5, 5, "td", 126);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, EditLicenseDetailsComponent_div_0_div_6_div_2_div_1_tr_8_Template, 1, 0, "tr", 77);
    i0.ɵɵtemplate(9, EditLicenseDetailsComponent_div_0_div_6_div_2_div_1_tr_9_Template, 1, 2, "tr", 127);
    i0.ɵɵtemplate(10, EditLicenseDetailsComponent_div_0_div_6_div_2_div_1_tr_10_Template, 1, 0, "tr", 128);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r77 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("dataSource", ctx_r77.dataSource);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r77.columns);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("matHeaderRowDef", ctx_r77.displayedColumns);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matRowDefColumns", ctx_r77.displayedColumns);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matRowDefColumns", i0.ɵɵpureFunction0(5, _c1));
} }
function EditLicenseDetailsComponent_div_0_div_6_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 121);
    i0.ɵɵtemplate(1, EditLicenseDetailsComponent_div_0_div_6_div_2_div_1_Template, 11, 6, "div", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r12.dataSource == null ? null : ctx_r12.dataSource.data == null ? null : ctx_r12.dataSource.data.length);
} }
function EditLicenseDetailsComponent_div_0_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, EditLicenseDetailsComponent_div_0_div_6_ng_container_1_Template, 105, 39, "ng-container", 7);
    i0.ɵɵtemplate(2, EditLicenseDetailsComponent_div_0_div_6_div_2_Template, 2, 1, "div", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r4.isExternalEmployeeId);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r4.isEditMode);
} }
function EditLicenseDetailsComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelementStart(1, "div", 2);
    i0.ɵɵelement(2, "div", 3);
    i0.ɵɵtemplate(3, EditLicenseDetailsComponent_div_0_div_3_Template, 11, 4, "div", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, EditLicenseDetailsComponent_div_0_div_4_Template, 1, 0, "div", 5);
    i0.ɵɵtemplate(5, EditLicenseDetailsComponent_div_0_div_5_Template, 2, 1, "div", 6);
    i0.ɵɵtemplate(6, EditLicenseDetailsComponent_div_0_div_6_Template, 3, 2, "div", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r0.modeVal);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.isTimeLineView && (ctx_r0.licenseData == null ? null : ctx_r0.licenseData.length) > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.isTimeLineView && (ctx_r0.licenseData == null ? null : ctx_r0.licenseData.length) == 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.isListView);
} }
class EditLicenseDetailsComponent {
    constructor(referenceLibraryService, apiService, toastr, dialog, store, route) {
        this.referenceLibraryService = referenceLibraryService;
        this.apiService = apiService;
        this.toastr = toastr;
        this.dialog = dialog;
        this.store = store;
        this.route = route;
        this.isTabEmitter = new EventEmitter();
        this.isEditMode = false;
        this.iscaseRequest = false;
        this.currentItemDisplay = [];
        this.modeVal = false;
        this.showEditButton = true;
        this.expandPanel = false;
        this.updateBenProfile = true;
        this.selectedIndex = 0;
        this.license = new License({});
        this.categoryName = 'BENLICDOC';
        this.listUploadedFiles = [];
        this.infiniteDtFlag = false;
        this.visible = true;
        this.selectable = true;
        this.removable = true;
        this.addOnBlur = true;
        this.hasID = false;
        this.isLinear = true;
        this.today = new Date();
        this.separatorKeysCodes = [ENTER, COMMA];
        this.listAddedSubjects = [];
        this.viewMode = false;
        this.configurations = {
            inputMultipleFlag: true,
            fileType: acceptedFileTypes,
            isFileListRequired: true,
            categoryName: 'BENLICDOC',
            entityId: 0,
            fileCategory: '',
            listUploadedFiles: [],
            documentTypeRequired: true,
            docummentTypeCode: 'BENLICDOC',
            useCase: 'beneficiary',
            useCaseId: 0,
            useEntityId: false,
            isDeleteEnabled: this.viewMode ? false : true,
            isUploadEnabled: this.viewMode ? false : true,
            familyId: null
        };
        this.isUsedForBeneEdit = false;
        this.displayedColumns = [];
        this.subDisplayedColumns = [];
        this.subjectsColumns = [
            { columnDef: 'subject', header: 'Added Topics', columnType: 'text', customClass: '' },
            { columnDef: 'action', header: 'Action', columnType: 'icon', customClass: '' }
        ];
        this.columns = [
            { columnDef: 'toggle', header: '', columnType: 'icon', customClass: '' },
            { columnDef: 'name', header: 'Name', columnType: 'text', customClass: '' },
            { columnDef: 'institution', header: 'Organization', columnType: 'text', customClass: '' },
            { columnDef: 'startDate', header: 'Start Date', columnType: 'text', customClass: '' },
            { columnDef: 'endDate', header: 'End Date', columnType: 'text', customClass: '' },
            { columnDef: 'action', header: 'Action', columnType: 'icon', customClass: '' }
        ];
        this.isListView = false;
        this.isTimeLineView = true;
        this.licenseData = [];
        this.destroy$ = new Subject();
        this.formChangesSubscriptions = [];
        this.observableSubscription$ = new Subject();
        this.isSaveAsDraftDisabled = true;
        this.isLocked = false;
        this.isExternalEmployeeId = sessionStorage.getItem('_isExternalEmployeeId');
        if (this.isExternalEmployeeId) {
            this.isLocked = true;
        }
    }
    ngOnInit() {
        var _a, _b, _c;
        this.showLifeStoryTimeLineSection = true;
        this.modeVal = true;
        this.beneficiaryType = 'self';
        this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
        this.viewMode = false;
        if (sessionStorage.getItem('userTypeRole') === Roles.ATTORNEY || sessionStorage.getItem('userTypeRole') === Roles.PETITIONER) {
            const permission = JSON.parse(sessionStorage.getItem('currentUser'));
            permission ? permission['permissions'].length > 0 && permission['permissions'].find(x => x === 'EDIT_BENEFICIARY') ? true : false : false;
            this.updateBenProfile = permission;
            this.viewMode = !this.updateBenProfile;
        }
        this.onlyFormBuilder = this.route.snapshot.queryParams.pageFrom;
        if (this.onlyFormBuilder === 'FB') {
            this.beneficiaryId = (sessionStorage.getItem('FbEmployeeId')) ? parseInt(sessionStorage.getItem('FbEmployeeId')) : 0;
        }
        else {
            this.beneficiaryId = (sessionStorage.getItem('listBeneficiaryId')) ? parseInt(sessionStorage.getItem('listBeneficiaryId')) : this.apiService.currentUserValue['beneficiaryId'];
        }
        // this.getLicense();
        if (this.isProfile) {
            this.getLicensesForProfile();
        }
        else if (((_a = this.editLicenceData) === null || _a === void 0 ? void 0 : _a.caseType) == 'I140' || ((_c = (_b = this.editLicenceData) === null || _b === void 0 ? void 0 : _b.caseType) === null || _c === void 0 ? void 0 : _c.toLowerCase()) == 'perm') {
            this.getLicenseForPermOrI140();
        }
        else {
            this.getLicense();
        }
        this.envPath = environment.docs;
        // IM-3066 - remove deleted file.
        this.apiService.deletedfile$.pipe(takeUntil(this.observableSubscription$)).subscribe(status => {
            var _a, _b, _c;
            if (status === true) {
                if (this.isProfile) {
                    this.getLicensesForProfile();
                }
                else if (((_a = this.editLicenceData) === null || _a === void 0 ? void 0 : _a.caseType) == 'I140' || ((_c = (_b = this.editLicenceData) === null || _b === void 0 ? void 0 : _b.caseType) === null || _c === void 0 ? void 0 : _c.toLowerCase()) == 'perm') {
                    this.getLicenseForPermOrI140();
                }
                else {
                    this.getLicense();
                }
            }
        });
        this.apiService.uploaded$.pipe(takeUntil(this.observableSubscription$)).subscribe(status => {
            var _a, _b, _c;
            if (status === true) {
                if (this.isProfile) {
                    this.getLicensesForProfile();
                }
                else if (((_a = this.editLicenceData) === null || _a === void 0 ? void 0 : _a.caseType) == 'I140' || ((_c = (_b = this.editLicenceData) === null || _b === void 0 ? void 0 : _b.caseType) === null || _c === void 0 ? void 0 : _c.toLowerCase()) == 'perm') {
                    this.getLicenseForPermOrI140();
                }
                else {
                    this.getLicense();
                }
            }
        });
        if (sessionStorage.getItem('newFamilyId')) {
            this.familyId = sessionStorage.getItem('newFamilyId');
        }
    }
    handleClose() {
        this.isEditMode = false;
        this.expandPanel = false;
        this.isTabEmitter.emit(true);
        this.translet();
    }
    ngAfterContentInit() {
        this.displayedColumns = this.columns.map(c => c.columnDef);
        this.subDisplayedColumns = this.subjectsColumns.map(c => c.columnDef);
    }
    translet() {
        setTimeout(() => {
            this.referenceLibraryService.transletConversion();
        }, 600);
    }
    formCheck(licForm) {
        var _a;
        this.licForm = licForm;
        this.formChangesSubscriptions[0] = licForm.statusChanges.pipe(takeUntil(this.observableSubscription$)).subscribe(() => {
            if (licForm.dirty) {
                this.store.dispatch(new MarkDirtyFormAction({
                    dirty: true
                }));
            }
            else {
                this.store.dispatch(new MarkCleanFormAction({
                    dirty: false
                }));
            }
        });
        this.formChangesSubscriptions[1] = (_a = this.licForm.valueChanges) === null || _a === void 0 ? void 0 : _a.pipe(takeUntil(this.observableSubscription$)).subscribe(formValues => {
            this.isSaveAsDraftDisabled = !Object.values(formValues).some((val) => !!val || val === 0);
        });
    }
    onNewTopicEnter(event) {
        this.store.dispatch(new MarkDirtyFormAction({
            dirty: true
        }));
    }
    toggleExpansion() {
        this.isEditMode = true;
        this.expandPanel = true;
        this.isTabEmitter.emit(false);
        this.hasID = false;
        this.isLinear = true;
        this.infiniteDtFlag = false;
        this.license = {
            id: 0,
            name: '',
            subjects: '',
            institution: '',
            startDate: '',
            endDate: ''
        };
        this.listUploadedFiles = [];
        this.configurations.listUploadedFiles = [];
        this.configurations.entityId = 0;
        this.configurations.familyId = this.familyId ? this.familyId : null;
        this.configurations = Object.assign({}, this.configurations);
        this.listSubjects = new MatTableDataSource();
    }
    getLicenseForPermOrI140() {
        var _a, _b, _c;
        let url;
        if (((_a = this.editLicenceData) === null || _a === void 0 ? void 0 : _a.caseType) == 'I140') {
            url = this.apiService.getLicensesInformation(this.inputData.superTaskId, this.inputData.subTaskId, this.isUsedForBeneEdit);
        }
        else if (((_c = (_b = this.editLicenceData) === null || _b === void 0 ? void 0 : _b.caseType) === null || _c === void 0 ? void 0 : _c.toLowerCase()) == 'perm') {
            url = this.apiService.getLicensesInformationPerm(this.inputData.caseId, this.isUsedForBeneEdit);
        }
        url.pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            if (!response.data) {
                response.data = [];
            }
            if (response === null || response === void 0 ? void 0 : response['data']) {
                this.licenseData = response['data'].map((item) => {
                    let _item = Object.assign({}, item);
                    if (item.subjects) {
                        _item.subjects = item.subjects.split(',');
                    }
                    _item.documents = item.documents.filter(e => !!e.fileLocation);
                    _item.startDate = item.startDate ? moment(item.startDate, 'YYYY-MMM-DD').format('DD-MMM-YYYY') : '';
                    _item.endDate = item.endDate ? moment(item.endDate, 'YYYY-MMM-DD').format('DD-MMM-YYYY') : '';
                    return _item;
                });
                // response['data'].map((item) => {
                //   item.startDate = item.startDate ? moment(item.startDate).format('DD-MMM-YYYY') : '';
                //   item.endDate = item.endDate ? moment(item.endDate).format('DD-MMM-YYYY') : '';
                // });
                // this.licenseData = response['data'];
                this.dataSource = new MatTableDataSource(this.licenseData);
                this.translet();
            }
        });
    }
    isFormFilled(form) {
        return form && form.controls
            ? Object.entries(form.controls).some(([key, control]) => {
                const value = control.value;
                return value !== null && value !== undefined && (typeof value === 'string' ? value.trim() !== '' : !!value);
            })
            : false;
    }
    getLicensesForProfile() {
        if (sessionStorage.getItem('newFamilyId')) {
            this.familyId = sessionStorage.getItem('newFamilyId');
        }
        this.apiService.getLicenceDetailsForProfile(this.beneficiaryId, 'LICENSE', this.familyId)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe(res => {
            var _a, _b, _c, _d, _e, _f;
            (_b = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.profEducation) === null || _b === void 0 ? void 0 : _b.map((item) => {
                if (item.subjects) {
                    item.subjects = item.subjects.split(',');
                }
            });
            (_d = (_c = res === null || res === void 0 ? void 0 : res.data) === null || _c === void 0 ? void 0 : _c.profEducation) === null || _d === void 0 ? void 0 : _d.map((item) => {
                item.startDate = item.startDate ? moment(item.startDate).format('DD-MMM-YYYY') : '';
                item.endDate = item.endDate ? moment(item.endDate).format('DD-MMM-YYYY') : '';
            });
            this.licenseData = (_e = res === null || res === void 0 ? void 0 : res.data) === null || _e === void 0 ? void 0 : _e.profEducation;
            this.dataSource = new MatTableDataSource((_f = res === null || res === void 0 ? void 0 : res.data) === null || _f === void 0 ? void 0 : _f.profEducation);
            this.translet();
        });
    }
    getLicense() {
        this.apiService.getBeneDetails(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, sync_profile_code.SYNC_TASK_TYPE_LICENSE, this.inputData.superTaskId, this.inputData.subTaskId, this.isUsedForBeneEdit).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            if (!response.data) {
                response.data = [];
            }
            if (response === null || response === void 0 ? void 0 : response['data']) {
                response['data'].map((item) => {
                    if (item.subjects) {
                        item.subjects = item.subjects.split(',');
                    }
                });
                response['data'].map((item) => {
                    item.startDate = item.startDate ? moment(item.startDate).format('DD-MMM-YYYY') : '';
                    item.endDate = item.endDate ? moment(item.endDate).format('DD-MMM-YYYY') : '';
                });
                this.licenseData = response['data'];
                this.dataSource = new MatTableDataSource(response['data']);
                this.translet();
            }
        });
    }
    handleEdit(input) {
        this.isEditMode = true;
        this.expandPanel = true;
        this.isTabEmitter.emit(false);
        if (input && input.endDate === '') {
            this.infiniteDtFlag = true;
        }
        this.license = {
            id: input.id,
            name: input.name,
            subjects: input.subjects,
            institution: input.institution,
            startDate: input.startDate ? moment(input.startDate).toISOString() : '',
            endDate: (input.endDate) ? moment(input.endDate).toISOString() : ''
        };
        const obj = [];
        if (input.subjects) {
            input.subjects.forEach((item) => {
                obj.push({ 'subject': item });
            });
        }
        this.hasID = true;
        this.isLinear = false;
        this.listSubjects = new MatTableDataSource(obj);
        this.license.subjects = input.subjects && input.subjects.length ? input.subjects.join() : [];
        this.configurations.entityId = input.id;
        this.configurations.useCaseId = this.beneficiaryId;
        this.configurations.familyId = this.familyId ? this.familyId : null;
        this.listUploadedFiles = input.documents ? this.listUploadedFiles.concat(input.documents) : [];
        this.configurations.listUploadedFiles = input.documents ? this.configurations.listUploadedFiles.concat(input.documents) : [];
        this.configurations = Object.assign({}, this.configurations);
    }
    handleDelete(input, licForm) {
        const title = 'Confirm';
        const message = 'Do you wish to remove this item?';
        this.dialogueInitializer(event, title, message).afterClosed().subscribe(result => {
            var _a, _b, _c;
            if (result) {
                let url;
                if (this.isProfile) {
                    url = this.apiService.deleteLicenceDetailsForProfile(this.beneficiaryId, 'LICENSE', input.id, this.familyId);
                }
                else if (((_a = this.editLicenceData) === null || _a === void 0 ? void 0 : _a.caseType) == 'I140' || ((_c = (_b = this.editLicenceData) === null || _b === void 0 ? void 0 : _b.caseType) === null || _c === void 0 ? void 0 : _c.toLowerCase()) == 'perm') {
                    url = this.apiService.deleteLicensesInformation(this.inputData.superTaskId, this.inputData.subTaskId, input.id);
                }
                else {
                    url = this.apiService.deleteLicenceDocuments(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, sync_profile_code.SYNC_TASK_TYPE_LICENSE, this.inputData.superTaskId, this.inputData.subTaskId, input.id);
                }
                url.pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
                    var _a, _b, _c;
                    if (response.status === 200) {
                        if (this.license.id === input.id) {
                            this.resetForm(licForm);
                        }
                        this.toastr.success('Data deleted successfully!', 'Success');
                        if (this.isProfile) {
                            this.getLicensesForProfile();
                        }
                        else if (((_a = this.editLicenceData) === null || _a === void 0 ? void 0 : _a.caseType) == 'I140' || ((_c = (_b = this.editLicenceData) === null || _b === void 0 ? void 0 : _b.caseType) === null || _c === void 0 ? void 0 : _c.toLowerCase()) == 'perm') {
                            this.getLicenseForPermOrI140();
                        }
                        else {
                            this.getLicense();
                        }
                    }
                });
            }
        });
    }
    saveLicenseTrianing(licForm, isDraft = false) {
        const payload = {
            id: this.license.id || 0,
            name: this.license.name,
            subjects: this.license.subjects,
            institution: this.license.institution,
            startDate: this.license.startDate ? moment(this.license.startDate).format('YYYY-MM-DD') : null,
            endDate: (this.license.endDate) ? moment(this.license.endDate).format('YYYY-MM-DD') : null,
            isSaveAsDraft: isDraft
        };
        if (!this.isFormFilled(licForm)) {
            this.toastr.warning('Empty records cannot be saved!', 'Warning');
            return;
        }
        let url;
        if (this.isProfile) {
            url = this.apiService.saveLicenceDetailsForProfile(this.beneficiaryId, 'LICENSE', payload, this.familyId);
        }
        else if (this.inputData.caseType == 'I140') {
            url = this.apiService.savegcI140LicenseDetails(this.inputData.caseId, payload, 'LICENSE');
        }
        else if (this.inputData.caseType.toLowerCase() == 'perm') {
            url = this.apiService.savePermLicenseDetails(this.inputData.caseId, payload, 'LICENSE');
        }
        else {
            url = this.apiService.saveTrainingDetails(payload);
        }
        url.pipe(takeUntil(this.observableSubscription$))
            .subscribe(response => {
            var _a, _b, _c, _d, _e;
            if (response.status === 200) {
                if ((_a = response.data) === null || _a === void 0 ? void 0 : _a.profEducation) {
                    response.data = (_b = response.data) === null || _b === void 0 ? void 0 : _b.profEducation;
                }
                this.license.id = response.data[0].id;
                this.toastr.success("License details saved successfully!", 'Success');
                response.data.forEach(element => {
                    this.configurations.entityId = element.id;
                    this.configurations.familyId = this.familyId ? this.familyId : null;
                    this.configurations = Object.assign({}, this.configurations);
                });
                this.configurations.useCaseId = this.beneficiaryId;
                if (this.isProfile) {
                    this.getLicensesForProfile();
                }
                else if (((_c = this.editLicenceData) === null || _c === void 0 ? void 0 : _c.caseType) == 'I140' || ((_e = (_d = this.editLicenceData) === null || _d === void 0 ? void 0 : _d.caseType) === null || _e === void 0 ? void 0 : _e.toLowerCase()) == 'perm') {
                    this.getLicenseForPermOrI140();
                }
                else {
                    this.getLicense();
                }
                this.hasID = true;
                this.isLinear = false;
                licForm.reset(licForm.value);
            }
            else {
                CustomErrorToastComponent.showErrorToast(this.toastr, response.message);
            }
        });
    }
    getUpolodedFiles(id) {
        if (this.beneficiaryId && this.categoryName) {
            this.apiService.genericGetUploadDocument(this.configurations.useCase, this.configurations.useCaseId, this.categoryName, this.configurations.entityId, this.configurations.useEntityId, this.configurations.familyId)
                .pipe(takeUntil(this.observableSubscription$))
                .subscribe((response) => {
                if (response['status'] === 200) {
                    if (response['data'] && response['data'].length > 0) {
                        response['data'].forEach(val => {
                            if (val.entityId == id) {
                                this.listUploadedFiles.push(val);
                                this.configurations.listUploadedFiles.push(val);
                                this.configurations = Object.assign({}, this.configurations);
                            }
                        });
                    }
                }
                else {
                    this.listUploadedFiles = [];
                    this.configurations.listUploadedFiles = [];
                    this.configurations = Object.assign({}, this.configurations);
                }
            });
        }
    }
    resetForm(licForm) {
        licForm.resetForm();
        this.infiniteDtFlag = false;
        this.license = {
            id: 0,
            name: '',
            subjects: '',
            institution: '',
            startDate: '',
            endDate: ''
        };
        this.listUploadedFiles = [];
        this.configurations.listUploadedFiles = [];
        this.configurations.entityId = 0;
        this.configurations.familyId = this.familyId ? this.familyId : null;
        this.configurations = Object.assign({}, this.configurations);
        this.listSubjects = new MatTableDataSource();
        this.hasID = false;
        this.isLinear = true;
    }
    redirectToDocs() {
        this.selectedIndex = 1;
    }
    handleTabChange(tab) {
        this.selectedIndex = tab.index;
    }
    add(event) {
        const input = event.input;
        const value = event.value;
        // Add subject
        if ((value || '').trim()) {
            this.listAddedSubjects.push(value.trim());
        }
        // Reset the input value
        if (input) {
            input.value = '';
        }
    }
    pasteChips(event) {
        event.preventDefault(); // Prevents the default action
        event.clipboardData
            .getData('Text') // Gets the text pasted
            .split(/,/) // Splits it when a SEMICOLON or COMMA or NEWLINE
            .forEach(value => {
            if (value.trim()) {
                this.listAddedSubjects.push(value.trim()); // Push if valid
            }
        });
    }
    remove(fruit) {
        const index = this.listAddedSubjects.indexOf(fruit);
        if (index >= 0) {
            this.listAddedSubjects.splice(index, 1);
        }
    }
    addSubjects(isDel) {
        var _a;
        if (!this.license.id) {
            this.toastr.info('Please add the licence details first, then proceed to topics');
            return;
        }
        const payload = {
            id: this.license.id || 0,
            name: this.license.name,
            subjects: '',
            institution: this.license.institution,
            startDate: this.license.startDate ? moment(this.license.startDate).format('YYYY-MM-DD') : null,
            endDate: this.infiniteDtFlag ? null : (this.license.endDate ? moment(this.license.endDate).format('YYYY-MM-DD') : null),
        };
        const subs = [];
        if (this.listSubjects) {
            this.listSubjects.data.forEach((item) => {
                subs.push(item.subject);
            });
        }
        payload.subjects = subs.concat(this.listAddedSubjects).join();
        let url;
        if (this.isProfile) {
            url = this.apiService.saveLicenceDetailsForProfile(this.beneficiaryId, 'LICENSE', payload, this.familyId);
        }
        else if (this.inputData.caseType == 'I140') {
            url = this.apiService.savegcI140LicenseDetails(this.inputData.caseId, payload, 'LICENSE');
        }
        else if (((_a = this.inputData.caseType) === null || _a === void 0 ? void 0 : _a.toLowerCase()) == 'perm') {
            url = this.apiService.savePermLicenseDetails(this.inputData.caseId, payload, 'LICENSE');
        }
        else {
            url = this.apiService.saveTrainingDetails(payload);
        }
        url.pipe(takeUntil(this.observableSubscription$))
            .subscribe(response => {
            var _a, _b, _c, _d, _e;
            if (response.status === 200) {
                if ((_a = response.data) === null || _a === void 0 ? void 0 : _a.profEducation) {
                    response.data = (_b = response.data) === null || _b === void 0 ? void 0 : _b.profEducation;
                }
                if (isDel) {
                    this.toastr.success('Data deleted successfully!', 'Success');
                }
                else {
                    this.toastr.success(response.message, 'Success');
                }
                const obj = [];
                if (response.data[0]['subjects']) {
                    response.data[0]['subjects'].split(',').forEach((item) => {
                        obj.push({ 'subject': item });
                    });
                }
                this.listSubjects = new MatTableDataSource(obj);
                response.data.forEach(element => {
                    this.configurations.entityId = element.id;
                    this.configurations = Object.assign({}, this.configurations);
                });
                this.configurations.useCaseId = this.beneficiaryId;
                this.listAddedSubjects = [];
                if (this.isProfile) {
                    this.getLicensesForProfile();
                }
                else if (((_c = this.editLicenceData) === null || _c === void 0 ? void 0 : _c.caseType) == 'I140' || ((_e = (_d = this.editLicenceData) === null || _d === void 0 ? void 0 : _d.caseType) === null || _e === void 0 ? void 0 : _e.toLowerCase()) == 'perm') {
                    this.getLicenseForPermOrI140();
                }
                else {
                    this.getLicense();
                }
                this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
            }
            else {
                CustomErrorToastComponent.showErrorToast(this.toastr, response.message);
            }
        });
    }
    deleteSubject(index) {
        this.listSubjects.data.splice(index, 1);
        this.addSubjects(true); // Resolved for IM-5066
    }
    fileUploadSuccess() {
        var _a, _b, _c;
        if (this.isProfile) {
            this.getLicensesForProfile();
        }
        else if (((_a = this.editLicenceData) === null || _a === void 0 ? void 0 : _a.caseType) == 'I140' || ((_c = (_b = this.editLicenceData) === null || _b === void 0 ? void 0 : _b.caseType) === null || _c === void 0 ? void 0 : _c.toLowerCase()) == 'perm') {
            this.getLicenseForPermOrI140();
        }
        else {
            this.getLicense();
        }
    }
    closeForm(f) {
        this.resetForm(f);
        this.toggleExpansion();
    }
    toggleListView(val) {
        if (!val) {
            this.isTimeLineView = true;
            this.isListView = false;
        }
        else {
            this.isTimeLineView = false;
            this.isListView = true;
        }
    }
    getGlobalErrorMessages(error) {
        return errorUtils.errorMessages.get(error);
    }
    dialogueInitializer(event, title, message) {
        const cordinates = event;
        const dialogRef = this.dialog.open(ConfirmationModalComponent, {
            width: '400px',
            data: {
                update: { title, message },
                buttons: ['Cancel', 'Delete']
            }
        });
        return dialogRef;
    }
    ngOnChanges(changes) {
        var _a, _b, _c;
        if (changes.editLicenceData.currentValue) {
            this.inputData = changes.editLicenceData.currentValue;
            if (this.isProfile) {
                this.getLicensesForProfile();
            }
            else if (((_a = this.editLicenceData) === null || _a === void 0 ? void 0 : _a.caseType) == 'I140' || ((_c = (_b = this.editLicenceData) === null || _b === void 0 ? void 0 : _b.caseType) === null || _c === void 0 ? void 0 : _c.toLowerCase()) == 'perm') {
                this.getLicenseForPermOrI140();
            }
            else {
                this.getLicense();
            }
        }
    }
    ngAfterViewInit() {
        if (this.modeVal) {
            this.showLifeStoryTimeLineSection = true;
            this.toggleListView(true);
            this.translet();
        }
    }
    ngOnDestroy() {
        if (this.formChangesSubscriptions) {
            this.formChangesSubscriptions.forEach(item => { item.unsubscribe(); });
        }
        this.destroy$.next();
        this.destroy$.complete();
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
        this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
    }
    saveAsDraft(event) {
        this.saveLicenseTrianing(this.licForm, event);
    }
}
EditLicenseDetailsComponent.ɵfac = function EditLicenseDetailsComponent_Factory(t) { return new (t || EditLicenseDetailsComponent)(i0.ɵɵdirectiveInject(i1$2.ReferenceLibraryService), i0.ɵɵdirectiveInject(EditLicenseDetailsService), i0.ɵɵdirectiveInject(i3.ToastrService), i0.ɵɵdirectiveInject(i2$1.MatDialog), i0.ɵɵdirectiveInject(i8.Store), i0.ɵɵdirectiveInject(i6.ActivatedRoute)); };
EditLicenseDetailsComponent.ɵcmp = i0.ɵɵdefineComponent({ type: EditLicenseDetailsComponent, selectors: [["edit-license-details"]], viewQuery: function EditLicenseDetailsComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(MatPaginator, 3);
        i0.ɵɵviewQuery(MatSort, 3);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.paginator = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sort = _t.first);
    } }, inputs: { editLicenceData: "editLicenceData", isWizard: "isWizard", isProfile: "isProfile", isUsedForBeneEdit: "isUsedForBeneEdit" }, outputs: { isTabEmitter: "isTabEmitter" }, features: [i0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["class", "licenseContainer custom-stepper", 4, "ngIf"], [1, "licenseContainer", "custom-stepper"], [1, "mt-0", "btn-group", "row"], [1, "col-7"], ["class", "col viewType", 4, "ngIf"], ["class", "row", 4, "ngIf"], ["class", "add-placeholder", 4, "ngIf"], [4, "ngIf"], [1, "col", "viewType"], [1, "childBtn", "firstBtn", 3, "click"], ["matTooltip", "Change to timeline view", 1, "btn-icn"], ["id", "timeLineView", 1, "common-bene-class-for-translation"], [1, "childBtn", "lastBtn", 3, "click"], ["matTooltip", "Change to list view", 1, "btn-icn"], ["id", "listView", 1, "common-bene-class-for-translation"], [1, "row"], [1, "add-placeholder"], ["mat-fab", "", "color", "primary", "class", "btn", 3, "click", 4, "ngIf"], ["mat-fab", "", "color", "primary", 1, "btn", 3, "click"], ["matTooltip", "Add License / Certificate"], ["class", "spacing im-card-no-border-table list-view-table", 4, "ngIf"], [1, "row", "d-flex", "justify-content-end"], ["class", "text-danger mt-2 mr-3 common-bene-class-for-translation", 4, "ngIf"], ["class", "btn btn-primary mb-2", "type", "button", 3, "click", 4, "ngIf"], ["hideToggle", "", 3, "expanded", "ngClass"], [1, "close-edit"], [1, "close-icon", "pi", "pi-times", 3, "click"], ["labelPosition", "bottom", 1, "pb-mat-stepper-custom-horizontal", 3, "linear"], ["stepper", ""], [3, "completed"], ["matStepLabel", ""], [3, "ngSubmit"], ["licForm", "ngForm"], [1, "formBox", 3, "ngClass"], [1, "form-group", "col-md-12", "mt-2"], ["id", "licNameLabel", 1, "label-cls", "common-bene-class-for-translation"], ["type", "text", "name", "name", "placeholder", "Enter", 1, "im-input", 3, "ngModel", "ngModelChange"], ["name", "ngModel"], [1, "form-group", "col-md-12"], ["id", "issOrgLabel", 1, "label-cls", "common-bene-class-for-translation"], ["type", "text", "name", "institution", "placeholder", "Enter", 1, "im-input", 3, "ngModel", "ngModelChange"], ["institution", "ngModel"], ["name", "infineDtFlag", 1, "example-margin", 3, "ngModel", "ngModelChange"], ["id", "credExpWarning", 1, "common-bene-class-for-translation"], [1, "form-group", "col-md-6"], ["id", "startDateLabelLic", 1, "label-cls", "common-bene-class-for-translation"], ["appearance", "outline", 1, "mt-0", "date-field"], ["name", "startDt", "matInput", "", 3, "ngModel", "max", "matDatepicker", "ngModelChange", "click"], ["startDt", "ngModel"], ["matSuffix", "", 3, "for"], ["startDate", ""], ["class", "invalid-message common-bene-class-for-translation", "id", "startDateErrorLic", 4, "ngIf"], ["class", "form-group col-md-6", 4, "ngIf"], [1, "row", "paddingTop10", "dasheedTopBorder"], ["type", "submit", 1, "btn", "btn-success", 3, "disabled"], ["id", "saveForm2", 1, "common-bene-class-for-translation"], ["type", "button", "class", "btn btn-primary ml-3", "matStepperNext", "", 4, "ngIf"], ["class", "mt-2", 4, "ngIf"], [1, "row", "formBox", 3, "ngClass"], ["id", "topicsInstruction1", 1, "row", "common-bene-class-for-translation"], ["id", "topicsInstruction2", 1, "common-bene-class-for-translation", "ml-3"], [1, "col-md-12", "margin-adjust"], [1, "row", "paddingTop10"], ["id", "smallHeadTopic", 1, "col-md-12", "required", "common-bene-class-for-translation"], [1, "col-md-12"], ["appearance", "outline", 1, "example-chip-list", "chips-contianer"], ["aria-label", "Topic selection"], ["chipList", ""], [3, "selectable", "removable", "removed", 4, "ngFor", "ngForOf"], ["placeholder", "New subject...", "name", "topic", 3, "matChipInputFor", "matChipInputSeparatorKeyCodes", "ngModel", "paste", "ngModelChange", "input", "matChipInputTokenEnd"], ["id", "hintCourseName1", 1, "hint-text", "common-bene-class-for-translation"], [1, "col-md-2", "mt-3"], ["type", "button", 1, "btn", "btn-success", 3, "disabled", "click"], ["id", "addSubjects", 1, "common-bene-class-for-translation"], [1, "spacing", "px-3", "im-card-no-border-table", "mt-4"], ["mat-table", "", "matSort", "", 1, "im-card-no-border-table", "w-100", 3, "dataSource"], [3, "matColumnDef", 4, "ngFor", "ngForOf"], ["mat-header-row", "", 4, "matHeaderRowDef"], ["mat-row", "", 4, "matRowDef", "matRowDefColumns"], [1, "w-100"], [1, "row", "margin-adjust"], [1, "col-md-6"], ["type", "button", "matStepperPrevious", "", 1, "back-button"], ["id", "back3", 1, "common-bene-class-for-translation"], ["type", "button", "matStepperNext", "", 1, "btn", "btn-primary", "ml-3"], ["id", "next3", 1, "common-bene-class-for-translation"], [1, "col-md-12", "mt-2"], [1, "w-100", 3, "isWizard", "primaryData", "configurations", "fileUploadSuccess"], ["id", "back4", 1, "common-bene-class-for-translation"], ["type", "button", 1, "btn", "btn-primary", "ml-3", 3, "click"], ["id", "addNextLic", 1, "common-bene-class-for-translation"], [1, "text-danger", "mt-2", "mr-3", "common-bene-class-for-translation"], ["type", "button", 1, "btn", "btn-primary", "mb-2", 3, "click"], ["id", "add-lic", 1, "common-bene-class-for-translation"], ["id", "sectionHeadLic", 1, "common-bene-class-for-translation"], ["id", "startDateErrorLic", 1, "invalid-message", "common-bene-class-for-translation"], ["id", "endDateLabelLic", 1, "label-cls", "common-bene-class-for-translation"], ["name", "endDt", "matInput", "", 3, "ngModel", "min", "matDatepicker", "ngModelChange", "click"], ["endDt", "ngModel"], ["endDate", ""], ["class", "invalid-message common-bene-class-for-translation", "id", "endDateErrorLic", 4, "ngIf"], ["id", "endDateErrorLic", 1, "invalid-message", "common-bene-class-for-translation"], [1, "mt-2"], [1, "common-bene-class-for-translation"], ["id", "sectionHeadTopic1", 1, "common-bene-class-for-translation"], [3, "selectable", "removable", "removed"], [1, "common-bene-class-for-translation", 3, "id"], ["matTooltip", "Remove this item", "matChipRemove", "", 4, "ngIf"], ["matTooltip", "Remove this item", "matChipRemove", ""], [3, "matColumnDef"], ["class", "common-bene-class-for-translation", "mat-header-cell", "", "mat-sort-header", "", 3, "id", 4, "matHeaderCellDef"], ["mat-cell", "", 4, "matCellDef"], ["mat-header-cell", "", "mat-sort-header", "", 1, "common-bene-class-for-translation", 3, "id"], ["mat-cell", ""], ["class", "column.customClass", 4, "ngIf"], ["class", "common-bene-class-for-translation", 3, "id", 4, "ngIf"], [1, "column.customClass"], ["matTooltip", "Delete", 1, "mr-1", "icn", 3, "click"], ["mat-header-row", ""], ["mat-row", ""], ["id", "sectionHeadDocsLic", 1, "common-bene-class-for-translation"], [1, "spacing", "im-card-no-border-table", "list-view-table"], ["multiTemplateDataRows", "", "mat-table", "", 1, "im-card-no-border-table", 3, "dataSource"], [1, "example-element-description"], ["matColumnDef", "expandedDetail"], ["id", "headListOfTopics1", 1, "common-bene-class-for-translation"], ["class", "w40", "mat-cell", "", 4, "matCellDef"], ["mat-row", "", "class", "example-element-row", 3, "example-expanded-row", "click", 4, "matRowDef", "matRowDefColumns"], ["mat-row", "", "class", "example-detail-row", 4, "matRowDef", "matRowDefColumns"], ["class", "common-bene-class-for-translation", "mat-header-cell", "", 3, "id", 4, "matHeaderCellDef"], ["mat-header-cell", "", 1, "common-bene-class-for-translation", 3, "id"], ["class", "row", "class", "toggle-col", 4, "ngIf"], [1, "toggle-col"], ["matTooltip", "View more"], ["class", "mr-1 icn", "matTooltip", "Edit", "class", "im-table-verticle-icon", 3, "click", 4, "ngIf"], ["matTooltip", "Edit", 1, "im-table-verticle-icon", 3, "click"], ["mat-cell", "", 1, "w40"], [1, "example-element-detail"], ["class", "w100 example-element-description py-1", 4, "ngIf"], [1, "w100", "example-element-description", "py-1"], [1, "table", "table-striped"], ["class", "border border-dark", 4, "ngFor", "ngForOf"], [1, "border", "border-dark"], [1, "w40"], [1, "circleIndex", "rounded-circle", "common-bene-class-for-translation", 3, "id"], ["nowrap", "", 1, "common-bene-class-for-translation", 3, "id"], ["id", "headListOfDocs2", 1, "common-bene-class-for-translation", "header-tab"], [1, "im-card-no-border-table", "border"], ["id", "tableHeadDocOuter2", 1, "common-bene-class-for-translation"], ["id", "tableHeadDocTypeOuter2", 1, "common-bene-class-for-translation"], ["aria-hidden", "true", 1, "fa", "fa-download", "fa-lg", "icn"], [4, "ngFor", "ngForOf"], ["nowrap", ""], [3, "fileName", "Path"], ["id", "headListOfTopics2", 1, "common-bene-class-for-translation", "header-tab"], ["mat-row", "", 1, "example-element-row", 3, "click"], ["mat-row", "", 1, "example-detail-row"]], template: function EditLicenseDetailsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, EditLicenseDetailsComponent_div_0_Template, 7, 4, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.showLifeStoryTimeLineSection);
    } }, directives: [i10.NgIf, i22.MatIcon, i9$1.MatAccordion, i9$1.MatExpansionPanel, i10.NgClass, i10$1.MatCard, i11.MatHorizontalStepper, i11.MatStep, i11.MatStepLabel, i12.ɵangular_packages_forms_forms_ba, i12.NgControlStatusGroup, i12.NgForm, i12.DefaultValueAccessor, i12.NgControlStatus, i12.NgModel, i13.MatCheckbox, i16.MatFormField, i17.MatInput, i18.MatDatepickerInput, i18.MatDatepickerToggle, i16.MatSuffix, i18.MatDatepicker, i19.MatChipList, i10.NgForOf, i19.MatChipInput, i16.MatHint, i23.MatTable, i23.MatHeaderRowDef, i23.MatRowDef, i11.MatStepperPrevious, i11.MatStepperNext, i20.FileUploadDeafultLibraryComponent, i19.MatChip, i19.MatChipRemove, i23.MatColumnDef, i23.MatHeaderCellDef, i23.MatCellDef, i23.MatHeaderCell, i23.MatCell, i23.MatHeaderRow, i23.MatRow, i20$1.FileDownloadLibraryComponent], styles: [".licenseContainer .margin-adjust{margin-left:-15px}.licenseContainer .mat-form-field{font-size:14px;width:100%}.licenseContainer .icn{cursor:pointer}.licenseContainer .spacing{margin:10px 0}.licenseContainer .f10{font-size:12px;color:#afaaaa}.licenseContainer .dasheedTopBorder{border-top:1px dashed grey}.licenseContainer .paddingTop10{padding-top:10px}.licenseContainer .formBox,.licenseContainer .mTop10{margin-top:10px!important}.licenseContainer .w100{width:100%!important}.licenseContainer table{width:100%}.licenseContainer tr.example-detail-row{height:0}.licenseContainer tr.example-element-row:not(.example-expanded-row):hover{background:#f5f5f5}.licenseContainer tr.example-element-row:not(.example-expanded-row):active{background:#efefef}.licenseContainer .example-element-row td{border-bottom-width:0}.licenseContainer .example-element-detail{overflow:hidden}.licenseContainer .example-element-diagram{min-width:80px;border:2px solid #000;padding:8px;font-weight:lighter;margin:8px 0;height:104px}.licenseContainer .example-element-symbol{font-weight:700;font-size:40px;line-height:normal}.licenseContainer .example-element-description{padding:16px}.licenseContainer .example-element-description-attribution{opacity:.5}.licenseContainer .topics-list-item{line-height:40px;width:80%;border:1px solid #d3d3d3;padding-left:25px}.licenseContainer .circleIndex{width:20px;height:20px;background-color:#8ecdd6;text-align:center}.licenseContainer .w40{width:40px!important}.licenseContainer .mLeft{margin-left:2rem}.licenseContainer .close-edit{position:absolute;right:15px}.licenseContainer .header-tab{font-weight:600;color:#425772!important}"], encapsulation: 2, data: { animation: [
            trigger('detailExpand', [
                state('collapsed', style({ height: '0px', minHeight: '0' })),
                state('expanded', style({ height: '*' })),
                transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
            ]),
        ] } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EditLicenseDetailsComponent, [{
        type: Component,
        args: [{
                selector: 'edit-license-details',
                templateUrl: './edit-license-details.component.html',
                styleUrls: ['./edit-license-details.component.scss'],
                encapsulation: ViewEncapsulation.None,
                animations: [
                    trigger('detailExpand', [
                        state('collapsed', style({ height: '0px', minHeight: '0' })),
                        state('expanded', style({ height: '*' })),
                        transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
                    ]),
                ],
            }]
    }], function () { return [{ type: i1$2.ReferenceLibraryService }, { type: EditLicenseDetailsService }, { type: i3.ToastrService }, { type: i2$1.MatDialog }, { type: i8.Store }, { type: i6.ActivatedRoute }]; }, { editLicenceData: [{
            type: Input
        }], isWizard: [{
            type: Input
        }], isTabEmitter: [{
            type: Output
        }], isProfile: [{
            type: Input
        }], isUsedForBeneEdit: [{
            type: Input
        }], paginator: [{
            type: ViewChild,
            args: [MatPaginator, { static: true }]
        }], sort: [{
            type: ViewChild,
            args: [MatSort, { static: true }]
        }] }); })();

function GenericBeneficiaryEducationComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵelementStart(1, "div", 4);
    i0.ɵɵelementStart(2, "span", 5);
    i0.ɵɵlistener("click", function GenericBeneficiaryEducationComponent_div_1_Template_span_click_2_listener() { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(); return ctx_r4.selectTab("EDU"); });
    i0.ɵɵtext(3, " Education ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 6);
    i0.ɵɵlistener("click", function GenericBeneficiaryEducationComponent_div_1_Template_span_click_4_listener() { i0.ɵɵrestoreView(_r5); const ctx_r6 = i0.ɵɵnextContext(); return ctx_r6.selectTab("TRN"); });
    i0.ɵɵtext(5, "Trainings");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "span", 7);
    i0.ɵɵlistener("click", function GenericBeneficiaryEducationComponent_div_1_Template_span_click_6_listener() { i0.ɵɵrestoreView(_r5); const ctx_r7 = i0.ɵɵnextContext(); return ctx_r7.selectTab("LIC"); });
    i0.ɵɵtext(7, " Licenses Or Certifications");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", ctx_r0.selectedTab == "EDU" ? "highLighedTab" : "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", ctx_r0.selectedTab == "TRN" ? "highLighedTab" : "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", ctx_r0.selectedTab == "LIC" ? "highLighedTab" : "");
} }
function GenericBeneficiaryEducationComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵelementStart(1, "add-education-details", 9);
    i0.ɵɵlistener("isTabEmitter", function GenericBeneficiaryEducationComponent_div_3_Template_add_education_details_isTabEmitter_1_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(); return ctx_r8.handleIsTab($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("isSyncPage", ctx_r1.isSyncPage)("isUsedForBeneEdit", ctx_r1.isUsedForBeneEdit)("isWizard", ctx_r1.isWizard)("editEduData", ctx_r1.inputData)("isProfile", ctx_r1.isBeneficiaryProfile)("formDetailsData", ctx_r1.formDetails)("documentTypeData", ctx_r1.documentType);
} }
function GenericBeneficiaryEducationComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵelementStart(1, "edit-training-details", 10);
    i0.ɵɵlistener("isTabEmitter", function GenericBeneficiaryEducationComponent_div_4_Template_edit_training_details_isTabEmitter_1_listener($event) { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(); return ctx_r10.handleIsTab($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("isUsedForBeneEdit", ctx_r2.isUsedForBeneEdit)("isWizard", ctx_r2.isWizard)("editTrainingData", ctx_r2.inputData)("isProfile", ctx_r2.isBeneficiaryProfile);
} }
function GenericBeneficiaryEducationComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵelementStart(1, "edit-license-details", 11);
    i0.ɵɵlistener("isTabEmitter", function GenericBeneficiaryEducationComponent_div_5_Template_edit_license_details_isTabEmitter_1_listener($event) { i0.ɵɵrestoreView(_r13); const ctx_r12 = i0.ɵɵnextContext(); return ctx_r12.handleIsTab($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("isUsedForBeneEdit", ctx_r3.isUsedForBeneEdit)("isWizard", ctx_r3.isWizard)("editLicenceData", ctx_r3.inputData)("isProfile", ctx_r3.isBeneficiaryProfile);
} }
class GenericBeneficiaryEducationComponent {
    constructor(referenceLibraryService) {
        this.referenceLibraryService = referenceLibraryService;
        this.selectedTab = 'EDU';
        this.isWizard = false;
        this.isUsedForBeneEdit = false;
        this.isSyncPage = false;
        this.isTab = true;
    }
    ngOnChanges(changes) {
        var _a, _b;
        if ((_a = changes.formDetails) === null || _a === void 0 ? void 0 : _a.currentValue) {
            debugger;
            if (this.documentType == 'RESUME') {
                this.formDetails = (_b = changes.formDetails) === null || _b === void 0 ? void 0 : _b.currentValue;
                this.documentType == 'RESUME';
            }
        }
    }
    selectTab(val) {
        this.selectedTab = val;
        this.isTab = true;
    }
    handleIsTab(event) {
        // console.log(event)
        this.isTab = event;
    }
    ngAfterViewInit() {
        this.translet();
    }
    translet() {
        setTimeout(() => {
            this.referenceLibraryService.transletConversion();
        }, 600);
    }
}
GenericBeneficiaryEducationComponent.ɵfac = function GenericBeneficiaryEducationComponent_Factory(t) { return new (t || GenericBeneficiaryEducationComponent)(i0.ɵɵdirectiveInject(i1$2.ReferenceLibraryService)); };
GenericBeneficiaryEducationComponent.ɵcmp = i0.ɵɵdefineComponent({ type: GenericBeneficiaryEducationComponent, selectors: [["lib-generic-beneficiary-education"]], inputs: { inputData: "inputData", isWizard: "isWizard", isBeneficiaryProfile: "isBeneficiaryProfile", isUsedForBeneEdit: "isUsedForBeneEdit", isSyncPage: "isSyncPage", formDetails: "formDetails", documentType: "documentType" }, features: [i0.ɵɵNgOnChangesFeature], decls: 6, vars: 4, consts: [[1, "w-100", "bg-white", "p-3"], ["class", "border-bottom", 4, "ngIf"], ["class", "w-100", 4, "ngIf"], [1, "border-bottom"], [1, "d-flex"], ["id", "tabHeadEdu", 1, "firstChild", "text-custom", "p-3", "font-weight-bold", "cursor-pointer", "common-bene-class-for-translation", 3, "ngClass", "click"], ["id", "tabHeadTrn", 1, "p-3", "text-custom", "font-weight-bold", "cursor-pointer", "common-bene-class-for-translation", 3, "ngClass", "click"], ["id", "tabHeadLic", 1, "lastChild", "p-3", "text-custom", "font-weight-bold", "cursor-pointer", "common-bene-class-for-translation", 3, "ngClass", "click"], [1, "w-100"], [3, "isSyncPage", "isUsedForBeneEdit", "isWizard", "editEduData", "isProfile", "formDetailsData", "documentTypeData", "isTabEmitter"], [3, "isUsedForBeneEdit", "isWizard", "editTrainingData", "isProfile", "isTabEmitter"], [3, "isUsedForBeneEdit", "isWizard", "editLicenceData", "isProfile", "isTabEmitter"]], template: function GenericBeneficiaryEducationComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, GenericBeneficiaryEducationComponent_div_1_Template, 8, 3, "div", 1);
        i0.ɵɵelementStart(2, "div");
        i0.ɵɵtemplate(3, GenericBeneficiaryEducationComponent_div_3_Template, 2, 7, "div", 2);
        i0.ɵɵtemplate(4, GenericBeneficiaryEducationComponent_div_4_Template, 2, 4, "div", 2);
        i0.ɵɵtemplate(5, GenericBeneficiaryEducationComponent_div_5_Template, 2, 4, "div", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isTab);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.selectedTab == "EDU");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.selectedTab == "TRN");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.selectedTab == "LIC");
    } }, directives: [i10.NgIf, i10.NgClass, AddEducationDetailsComponent, EditTrainingDetailsComponent, EditLicenseDetailsComponent], styles: [".highLighedTab[_ngcontent-%COMP%]{border-bottom:3px solid #2da7d5;background-color:#fff}.text-custom[_ngcontent-%COMP%]{color:#728499}.highLighedTab[_ngcontent-%COMP%]   .text-custom[_ngcontent-%COMP%]{color:#2da7d5}.cursor-pointer[_ngcontent-%COMP%]{cursor:pointer}.header-tab[_ngcontent-%COMP%]{font-weight:600;color:#425772!important}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GenericBeneficiaryEducationComponent, [{
        type: Component,
        args: [{
                selector: 'lib-generic-beneficiary-education',
                templateUrl: './generic-beneficiary-education.component.html',
                styleUrls: ['./generic-beneficiary-education.component.scss']
            }]
    }], function () { return [{ type: i1$2.ReferenceLibraryService }]; }, { inputData: [{
            type: Input
        }], isWizard: [{
            type: Input
        }], isBeneficiaryProfile: [{
            type: Input
        }], isUsedForBeneEdit: [{
            type: Input
        }], isSyncPage: [{
            type: Input
        }], formDetails: [{
            type: Input
        }], documentType: [{
            type: Input
        }] }); })();

// See the Moment.js docs for the meaning of these formats:
// https://momentjs.com/docs/#/displaying/format/
const MY_FORMATS = {
    parse: {
        dateInput: "YYYY"
    },
    display: {
        dateInput: "YYYY",
        monthYearLabel: "MMM YYYY",
        dateA11yLabel: "LL",
        monthYearA11yLabel: "MMMM YYYY"
    }
};
class YearDatePickerComponent {
    constructor() {
        //this.yearFormControl.setValue(this.setYear);
    }
    _yearSelectedHandler(chosenDate, datepicker) {
        this.yearFormControl.setValue(chosenDate, { emitEvent: true });
        datepicker.close();
    }
}
YearDatePickerComponent.ɵfac = function YearDatePickerComponent_Factory(t) { return new (t || YearDatePickerComponent)(); };
YearDatePickerComponent.ɵcmp = i0.ɵɵdefineComponent({ type: YearDatePickerComponent, selectors: [["year-date-picker"]], inputs: { yearFormControl: "yearFormControl" }, features: [i0.ɵɵProvidersFeature([
            // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
            // application's root module. We provide it at the component level here, due to limitations of
            // our example generation script.
            {
                provide: DateAdapter,
                useClass: MomentDateAdapter,
                deps: [MAT_DATE_LOCALE]
            },
            { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
        ])], decls: 5, vars: 3, consts: [["appearance", "outline", 1, "mt-0", "date-field", "w-100", "step-date-wrong-invalid-shown"], ["matInput", "", "maxlength", "4", "type", "number", 3, "matDatepicker", "formControl", "click"], ["matSuffix", "", 3, "for"], ["startView", "multi-year", "panelClass", "year-picker", 3, "yearSelected"], ["dp", ""]], template: function YearDatePickerComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "mat-form-field", 0);
        i0.ɵɵelementStart(1, "input", 1);
        i0.ɵɵlistener("click", function YearDatePickerComponent_Template_input_click_1_listener() { i0.ɵɵrestoreView(_r1); const _r0 = i0.ɵɵreference(4); return _r0.open(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelement(2, "mat-datepicker-toggle", 2);
        i0.ɵɵelementStart(3, "mat-datepicker", 3, 4);
        i0.ɵɵlistener("yearSelected", function YearDatePickerComponent_Template_mat_datepicker_yearSelected_3_listener($event) { i0.ɵɵrestoreView(_r1); const _r0 = i0.ɵɵreference(4); return ctx._yearSelectedHandler($event, _r0); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = i0.ɵɵreference(4);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("matDatepicker", _r0)("formControl", ctx.yearFormControl);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("for", _r0);
    } }, directives: [i16.MatFormField, i17.MatInput, i12.NumberValueAccessor, i18.MatDatepickerInput, i12.DefaultValueAccessor, i12.MaxLengthValidator, i12.NgControlStatus, i12.FormControlDirective, i18.MatDatepickerToggle, i16.MatSuffix, i18.MatDatepicker], styles: [""] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(YearDatePickerComponent, [{
        type: Component,
        args: [{
                selector: 'year-date-picker',
                templateUrl: './yearDatePicker.component.html',
                styleUrls: ['./yearDatePicker.component.scss'],
                providers: [
                    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
                    // application's root module. We provide it at the component level here, due to limitations of
                    // our example generation script.
                    {
                        provide: DateAdapter,
                        useClass: MomentDateAdapter,
                        deps: [MAT_DATE_LOCALE]
                    },
                    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
                ]
            }]
    }], function () { return []; }, { yearFormControl: [{
            type: Input
        }] }); })();

class GenericBeneficiaryEducationModule {
}
GenericBeneficiaryEducationModule.ɵfac = function GenericBeneficiaryEducationModule_Factory(t) { return new (t || GenericBeneficiaryEducationModule)(); };
GenericBeneficiaryEducationModule.ɵmod = i0.ɵɵdefineNgModule({ type: GenericBeneficiaryEducationModule });
GenericBeneficiaryEducationModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            //AddEducationDetailsModule,
            //EditLicenseDetailsModule,
            //EditTrainingDetailsModule,
            PrimengLibraryModule,
            CommonModule,
            FormsModule,
            ReactiveFormsModule,
            MatDialogModule,
            ImageCropperModule,
            YearDatePickerLibraryModule,
            MatIconModule,
            DropdownModule,
            DialogModule,
            ButtonModule,
            PaginatorModule,
            CustomQuestionnaireModule,
            MultiSelectModule,
            InputTextareaModule,
            MatExpansionModule,
            ConfirmDialogModule,
            AccordionModule,
            MatDatepickerModule,
            DeleteDialogLibraryModule,
            MatSidenavModule,
            MatListModule,
            MatExpansionModule,
            MatFormFieldModule,
            MatInputModule,
            MatDividerModule,
            FileUploadDeafultLibraryModule,
            FileUploadLibraryModule,
            MatCardModule,
            MatCheckboxModule,
            MatMomentDateModule,
            MatNativeDateModule,
            MatStepperModule,
            MatSlideToggleModule,
            MatRadioModule,
            MatSelectModule,
            MatChipsModule,
            MatTableModule,
            SaveAsDraftModule,
            MatTabsModule,
            FileUploadLibraryModule,
            FileUploadDeafultLibraryModule,
            FileDownloadLibraryModule,
            HelpVideoOverlayLibraryModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(GenericBeneficiaryEducationModule, { declarations: [GenericBeneficiaryEducationComponent,
        ConfirmationModalComponent,
        YearDatePickerComponent,
        EditLicenseDetailsComponent,
        EditTrainingDetailsComponent,
        AddEducationDetailsComponent], imports: [
        //AddEducationDetailsModule,
        //EditLicenseDetailsModule,
        //EditTrainingDetailsModule,
        PrimengLibraryModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatDialogModule,
        ImageCropperModule,
        YearDatePickerLibraryModule,
        MatIconModule,
        DropdownModule,
        DialogModule,
        ButtonModule,
        PaginatorModule,
        CustomQuestionnaireModule,
        MultiSelectModule,
        InputTextareaModule,
        MatExpansionModule,
        ConfirmDialogModule,
        AccordionModule,
        MatDatepickerModule,
        DeleteDialogLibraryModule,
        MatSidenavModule,
        MatListModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatInputModule,
        MatDividerModule,
        FileUploadDeafultLibraryModule,
        FileUploadLibraryModule,
        MatCardModule,
        MatCheckboxModule,
        MatMomentDateModule,
        MatNativeDateModule,
        MatStepperModule,
        MatSlideToggleModule,
        MatRadioModule,
        MatSelectModule,
        MatChipsModule,
        MatTableModule,
        SaveAsDraftModule,
        MatTabsModule,
        FileUploadLibraryModule,
        FileUploadDeafultLibraryModule,
        FileDownloadLibraryModule,
        HelpVideoOverlayLibraryModule], exports: [GenericBeneficiaryEducationComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GenericBeneficiaryEducationModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    GenericBeneficiaryEducationComponent,
                    ConfirmationModalComponent,
                    YearDatePickerComponent,
                    EditLicenseDetailsComponent,
                    EditTrainingDetailsComponent,
                    AddEducationDetailsComponent
                ],
                imports: [
                    //AddEducationDetailsModule,
                    //EditLicenseDetailsModule,
                    //EditTrainingDetailsModule,
                    PrimengLibraryModule,
                    CommonModule,
                    FormsModule,
                    ReactiveFormsModule,
                    MatDialogModule,
                    ImageCropperModule,
                    YearDatePickerLibraryModule,
                    MatIconModule,
                    DropdownModule,
                    DialogModule,
                    ButtonModule,
                    PaginatorModule,
                    CustomQuestionnaireModule,
                    MultiSelectModule,
                    InputTextareaModule,
                    MatExpansionModule,
                    ConfirmDialogModule,
                    AccordionModule,
                    MatDatepickerModule,
                    DeleteDialogLibraryModule,
                    MatSidenavModule,
                    MatListModule,
                    MatExpansionModule,
                    MatFormFieldModule,
                    MatInputModule,
                    MatDividerModule,
                    FileUploadDeafultLibraryModule,
                    FileUploadLibraryModule,
                    MatCardModule,
                    MatCheckboxModule,
                    MatMomentDateModule,
                    MatNativeDateModule,
                    MatStepperModule,
                    MatSlideToggleModule,
                    MatRadioModule,
                    MatSelectModule,
                    MatChipsModule,
                    MatTableModule,
                    SaveAsDraftModule,
                    MatTabsModule,
                    FileUploadLibraryModule,
                    FileUploadDeafultLibraryModule,
                    FileDownloadLibraryModule,
                    HelpVideoOverlayLibraryModule,
                ],
                exports: [
                    GenericBeneficiaryEducationComponent
                ]
            }]
    }], null, null); })();

/*
 * Public API Surface of generic-beneficiary-education
 */

/**
 * Generated bundle index. Do not edit.
 */

export { GenericBeneficiaryEducationComponent, GenericBeneficiaryEducationModule };
//# sourceMappingURL=generic-beneficiary-education.js.map
